import axios from "axios";
import React, { useState, useEffect, createRef, useRef, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { MdOutlineNavigateNext } from "react-icons/md";
import frame from "../images/thumbnail.svg";
import frame1 from "../images/play.svg";
import { RxCross2 } from "react-icons/rx";
import { server_API } from "../config";
import { sanitizeHTML } from "../utils/sanitize";
import { IoMdArrowBack, IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import "swiper/swiper-bundle.css";
import Dropzone from "react-dropzone";
import docIcon from "../images/docIcon.png";
import { FaChevronLeft, FaChevronRight, FaEdit, FaSave } from "react-icons/fa";
import cross from "../images/Vector.svg";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import OfferLetter from "./OfferLetter";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import arrow from "../images/arrow.png";
import arrowleft from "../images/arrowleft.png";
import proposalimage from "../images/proposal.png";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import ReactApexChart from "react-apexcharts";
import framelogo from "../images/framelogo.png";
import { toast, ToastContainer } from "react-toastify";
import Download from "../images/Download.svg";
import Select from "react-select";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Copyright from "./Copyright";
import { useDispatch, useSelector } from "react-redux";
import { selectCid } from "../features/companyid";
import { getUserPrivilege, selectUuid } from "../features/userid";
import { ButtonHollowXs, ButtonXs } from "./ButtonComponents";
import { useDropzone } from "react-dropzone";
import DatePicker from "react-datepicker";
import { MdOutlineDateRange } from "react-icons/md";
import ModernDatePicker from "./ui/ModernDatePicker";
import { parseCustomDate } from "../utils/dateUtils";
import { pdfjs } from "react-pdf";
import CreatableSelect from "react-select/creatable";
import SwipeFeedback from "../components/SwipeFeedback";
import emptydocs from "../images/empty_docs.png";
import {
  createNotification,
  deleteBulkNotifications,
} from "./NotificationFunctions";
import axiosInstance from "../axiosInstance";
import {
  FiCheckCircle,
  FiClock,
  FiDownload,
  FiDownloadCloud,
} from "react-icons/fi";
import { FiCalendar } from "react-icons/fi";
import { FiBarChart2 } from "react-icons/fi";
import ReactQuill from "react-quill";
import { populateTemplate } from "../utils/stringUtils";
import html2pdf from "html2pdf.js";
import { pdf } from "@react-pdf/renderer";
import CandidatePDFDocument from "./CandidatePDFDocument";
import cheatflag from "../images/cheatflag.png";
import { TailSpin } from "react-loader-spinner";
import {
  getCurrencySymbol,
  getPDFCurrencySymbol,
  getPhoneCode,
  formatSalary,
} from "../utils/currencyUtils";
import {
  selectCandidateFilters,
  updateCandidateFilters,
} from "../features/candidateFilters";
import { selectActiveInterviewedTab } from "../features/activeInterviewedTab";
import { selectCandidateTab } from "../features/candidateTab";
import Tooltip from "./ui/Tooltip";
import useFetch from "../hooks/useFetch";
import Button from "./ui/Button";
import { IoArrowBackOutline, IoEllipsisVertical } from "react-icons/io5";
import EditCandidateModal from "./modal/EditCandidateModal";
import { HEARD_ABOUT_US_MAPPER, roleTypes } from "../constants/common";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip as ChartTooltip,
  Legend as ChartLegend,
} from "chart.js";
import { Radar } from "react-chartjs-2";
import Dropdown from "./ui/Dropdwon";
import CustomVideoPlayer from "./ui/CustomVideoPlayer";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, ChartTooltip, ChartLegend);

const TestOfferInitiation = () => {
  // Refactored formatting logic
  const location = useLocation();

  const navigate = useNavigate();
  // console.log(tabState);
  const [isSalaryProposalModalOpen, setIsSalaryProposalModalOpen] =
    useState(false);
  const [fileTypeError, setFileTypeError] = useState("");
  const [companyCountryCode, setCompanyCountryCode] = useState("IN");
  const curr = getCurrencySymbol(companyCountryCode);
  const [applicant, setApplicant] = useState({});
  const [loader, setLoader] = useState(true);
  const [interviews, setInterviews] = useState([]);
  const [rank, setRank] = useState();
  const [tabState, setTabState] = useState("");
  const [proposalId, setProposalId] = useState("");
  const [activeDocId, setActiveDocId] = useState();
  const [currentStatus, setCurrentStatus] = useState("");
  const [activeDocStatus, setActiveDocStatus] = useState();
  const [activeProposalStatus, setActiveProposalStatus] = useState("");
  const [activeOfferStatus, setActiveOfferStatus] = useState();
  const [latestSProposalUuid, setLatestSProposalUuid] = useState();
  const [latestSalaryProposal, setLatestSalaryProposal] = useState();
  const [activeOfferUuid, setActiveOfferUuid] = useState("");
  const [loggedUser, setLoggedUser] = useState();
  const [url, setUrl] = useState("");
  const [activeDocUuid, setActiveDocUuid] = useState();
  const [activeQuestion, setActiveQuestion] = useState("");
  const [hirManager, setHirManager] = useState();
  const [activeIndex, setActiveIndex] = useState(null);
  const [openPlayer, setOpenPlayer] = useState(false);
  const [openSummary, setOpenSummary] = useState(false);
  const [allDocuments, setAllDocuments] = useState();
  const [comment, setComment] = useState("");
  const [allSalaryProposal, setAllSalaryProposal] = useState([]);
  const [allOfferLetter, setAllOfferLetter] = useState([]);
  const [activeDocName, setActiveDocName] = useState();
  const [activeSProposalUuid, setActiveSProposalUuid] = useState();
  const [confirmationModal, setConfirmationModal] = useState("");
  const [openAcceptedOfferModal, setOpenAcceptedOfferModal] = useState("");
  const [joiningDate, setJoiningDate] = useState();
  const [activeProposal, setActiveProposal] = useState({});
  const [expiryDate, setExpiryDate] = useState();
  const [joiningLocationOptions, setJoiningLocationOptions] = useState([]);
  const [docRejectReason, setDocRejectReason] = useState();
  const [joiningDateFocused, setJoiningDateFocused] = useState(false);
  const [expiryDateFocused, setExpiryDateFocused] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRows, setSelectdRows] = useState([]);
  const [isRecordedVisible, setRecordedVisible] = useState(true);
  const [hiringManager, setHiringManager] = useState();
  const [isAIVisible, setAIVisible] = useState(true);
  const [isTechExpanded, setIsTechExpanded] = useState(false);
  const [isEmpExpanded, setIsEmpExpanded] = useState(false);
  const [hiringManagerId, setHiringManagerId] = useState("");
  const [isFeedbackVisible, setFeedbackVisible] = useState(false);
  const [isDocumentVisible, setDocumentVisible] = useState(false);
  const [isProposalsVisible, setProposalsVisible] = useState(false);
  const [visibleDocumentName, setVisibleDocumentName] = useState("");
  const [isRejectedFeedbackOpen, setRejectedFeedbackOpen] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [recruiters, setRecruiters] = useState([]);
  const [emailBody, setEmailBody] = useState("");
  const [hiringManagers, setHiringManagers] = useState([]);
  const [jobDetails, setJobDetails] = useState({});
  const [jobid, setJobid] = useState();
  const [skillArray, setSkillArray] = useState([]);
  const [open, setOpen] = useState(false);
  const [maxSalary, setMaxSalary] = useState(0);
  const [minSalary, setMinSalary] = useState(0);
  const [userLabels, setuserLabels] = useState([]);
  const [adminUserLabels, setAdminUserLabels] = useState([]);
  const [nextCandidate, setNextCandidate] = useState(false);
  const [prevCandidate, setPrevCandidate] = useState(false);
  const [isOnNextPage, setOnNextPage] = useState(false);
  const [isOnPrevPage, setOnPrevPage] = useState(false);
  const companyID = useSelector(selectCid);
  const userid = useSelector(selectUuid);
  const [companyDetails, setCompanyDetails] = useState({});
  const [applicantDetails, setApplicantDetails] = useState({});
  const [tab, setTab] = useState(tabState ? tabState : "candidate");
  const [templateType, setTemplateType] = useState();
  const [justification, setJustification] = useState("");
  const [showingjustification, setShowJustification] = useState("");
  const pdfgeneration = useRef(null);
  const [documentAction, setDocumentAction] = useState("");
  const [viewDocuments, setViewDocuments] = useState(false);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [salarysubject, setSalarySubject] = useState("");
  const [salarybody, setSalaryBody] = useState("");
  const [Docsubject, setDocSubject] = useState("");
  const [Docbody, setDocBody] = useState("");
  const [files, setFiles] = useState([]);
  const [docFiles, setDocFiles] = useState([]);
  const [logo, setLogo] = useState(null);
  const [sendTo, setSendTo] = useState("");
  const [templatename, setTemplateName] = useState("");
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [joiningLocation, setJoiningLocation] = useState("");

  const [add1, setAdd1] = useState("");
  const [add2, setAdd2] = useState("");
  const [gender, setGender] = useState("");
  const [pin, setPin] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [offerLetterDetails, setOfferLetterDetails] = useState(null);
  const [country, setCountry] = useState("");
  const [pinLoading, setPinLoading] = useState(false);
  const pinRef = useRef(pin);
  pinRef.current = pin;
  const isGB = companyCountryCode === "GB";
  const [controllingOfficer, setControllingOfficer] = useState("");
  const [probationPeriod, setProbationPeriod] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [addedDocumentType, setAddedDocumentType] = useState("");
  const [documenturl, setDoumenturl] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [uuid, setUuid] = useState("");
  const [formType, setFormType] = useState("");
  const [openInterviewFeedbacks, setOpenInterviewFeedbacks] = useState(false);
  const [offerletterPending, setOfferLetterPending] = useState(false);
  const [defaultDocuments, setDefultDocuments] = useState([
    "Photo",
    "Aadhar Card",
    "Pan Card",
    "3 months salary slip",
    "Education Certificate",
  ]);

  const displayedDocuments = defaultDocuments.filter(
    (d) => companyCountryCode !== "GB" || (d !== "Aadhar Card" && d !== "Pan Card")
  );

  const dispatch = useDispatch();
  const [remindApproval, setRemindApproval] = useState(false);
  const [pendingModal, setPendingModal] = useState(false);
  const [showPdfMenu, setShowPdfMenu] = useState(false);
  const offerRef = useRef();
  const userPrivilege = useSelector(getUserPrivilege);
  const [activeSalaryProposal, setActiveSalaryProposal] = useState({});
  const [scores, setScores] = useState(new Map());
  const [notifications, setNotifications] = useState([]);
  const [hackerRankVisible, setHackerRankVisible] = useState(false);
  const [selectedSalaryTemplate, setSelectedSalaryTemplate] = useState(null);
  const [selectedDocTemplate, setSelectedDocTemplate] = useState(null);
  const [selectedDocRejectTemplate, setSelectedDocRejectTemplate] =
    useState(null);
  const [isEditingSalary, setIsEditingSalary] = useState(false);
  const [isEditingJoining, setIsEditingJoining] = useState(false);
  const [selectedDocRejectedTemplate, setSelectedDocRejectedTemplate] =
    useState(null);
  const [docRejectSubject, setDocRejectSubject] = useState("");
  const [docRejectBody, setDocRejectBody] = useState("");
  const [currentSalary, setCurrentSalary] = useState("");
  const [expectedSalary, setExpectedSalary] = useState("");
  const [joiningTime, setJoiningTime] = useState("");
  const [isSendingOffer, setIsSendingOffer] = useState(false);

  const filters = useSelector(selectCandidateFilters);
  const ait = useSelector(selectActiveInterviewedTab);
  const ct = useSelector(selectCandidateTab);

  const [pageDetails, setPageDetails] = useState({});
  const [candidateEdit, setCandidateEdit] = useState(false);
  const [candidateDetails, setCandidateDetails] = useState({
    name: applicant.name,
    email: applicant.email,
    phone: applicant.phone,
    heardaboutus: applicant.heardaboutus,
    refferre_name: applicant.refferre_name,
    employee_id: applicant.employee_id,
    agency_name: applicant.agency_name,
    joiningtime: applicant.joiningtime,
    expectedsalary: applicant.expectedsalary,
    currentsalary: applicant.currentsalary,
  });

  const videoRef = useRef(null);
  const [followUpAlert, setFollowUpAlert] = useState({
    visible: false,
    text: "",
    position: "center",
  });
  const [hasTriggeredFollowUp, setHasTriggeredFollowUp] = useState(false);

  useEffect(() => {
    setHasTriggeredFollowUp(false);
    setFollowUpAlert({ visible: false, text: "", position: "center" });
  }, [activeIndex]);

  const handleTimeUpdate = (e) => {
    if (!videoRef.current) return;

    const currentChunk = interviews[0]?.chunk?.[activeIndex];

    if (!currentChunk) return;

    // Check if we have follow-up data
    if (
      currentChunk.FollowUpTimeOffset &&
      currentChunk.FollowupQuestion &&
      !hasTriggeredFollowUp &&
      !isNaN(e.target.duration) &&
      e.target.currentTime !== e.target.duration
    ) {
      // Parse offset, ensure it is a valid number
      const offset = parseFloat(currentChunk.FollowUpTimeOffset) / 1000;

      // We check if current time passed the offset.
      // We also verify offset > 0 to avoid immediate trigger bugs if data is bad.
      if (!isNaN(offset) && offset > 0 && e.target.currentTime >= offset) {
        // Pause Video
        videoRef.current.pause();
        setHasTriggeredFollowUp(true);

        // Show Question in Center
        setFollowUpAlert({
          visible: true,
          text: currentChunk.FollowupQuestion,
          position: "center",
        });

        // Animation Sequence
        // 1. Wait 2 seconds (reading time)
        setTimeout(() => {
          // 2. Move to Top
          setFollowUpAlert((prev) => ({ ...prev, position: "top" }));

          // 3. Wait 1 second (animation settle) then Resume
          setTimeout(() => {
            if (videoRef.current) videoRef.current.play();
          }, 1000);
        }, 2000);
      }
    }
  };

  const handleCandidateUpdate = (formBody) => {
    const body = {
      companyid: companyID,
      uuid: applicant.uuid,
      ...formBody,
    };

    if (formBody.heardaboutus !== HEARD_ABOUT_US_MAPPER["Employees referral"]) {
      delete body.refferre_name;
      delete body.employee_id;
    }

    if (formBody.heardaboutus !== HEARD_ABOUT_US_MAPPER["Recruitment agency"]) {
      delete body.agency_name;
    }

    return axios
      .patch(`${server_API}/v2/applicant/update`, body)
      .then(() => {
        setCandidateEdit(false);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
        return toast.error(error.response.data.message);
      });
  };

  const handleAddDocument = () => {
    if (addedDocumentType.trim() !== "") {
      setDefultDocuments((prevDocuments) => [
        ...prevDocuments,
        addedDocumentType,
      ]);
      setAddedDocumentType(""); // Clear the input box
      setShowInput(!showInput); // Hide the input box after adding the document
    }
  };

  function formatToDDMMYYYY(isoString) {
    const date = new Date(isoString);

    if (isNaN(date.getTime())) {
      return "-";
    }

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}-${month}-${year}`;
  }

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "Completed":
        return "bg-green-100 text-green-700";
      case "Invited":
        return "bg-yellow-100 text-yellow-700";
      default:
        return "bg-gray-100 text-gray-600";
    }
  };

  const convertToPdf = () => {
    if (!pdfgeneration.current) return;

    // Step 2: Wait for re-render before capturing
    setTimeout(() => {
      const content = pdfgeneration.current;

      const options = {
        margin: [0.5, 0.5, 0.5, 0.5], // top, left, bottom, right
        filename: `${applicant?.name || "salaryproposal"}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        pagebreak: {
          mode: ["css", "legacy"],
          before: ".html2pdf__page-break",
        },
      };

      html2pdf().set(options).from(content).toPdf().get("pdf").save();
    }, 100);
  };

  // const sendOfferLetter = () => {
  //   axios
  //     .get(`${server_API}/v2/applicant/offer/${applicant.uuid}/${companyID}`)
  //     .then((res) => {
  //       console.log(res);
  //       axios
  //         .patch(`${server_API}/v2/applicant/update`, {
  //           uuid: applicant.uuid,
  //           status: "Acceptance Awaited",
  //           companyid: companyID,
  //         })
  //         .then((res) => {
  //           toast.success("Email to applicant has been successfully sent.", {
  //             icon: <ToastIcon />,
  //           });
  //         });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  // Fetch company for company_countries (currency symbol) - run when companyID or applicant.companyid available
  const companyIdForFetch =
    applicant?.companyid ||
    (typeof companyID === "string" ? companyID : "");
  useEffect(() => {
    const cid = companyIdForFetch;
    if (cid && cid.length > 0) {
      axiosInstance
        .get(`/v2/company/get/${cid}`)
        .then((res) => {
          setCompanyDetails(res.data);
          const code = res.data?.company_countries?.[0] || res.data?.CompanyCountries?.[0];
          if (code) {
            setCompanyCountryCode(code);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [companyIdForFetch]);

  useEffect(() => {
    axiosInstance
      .get(`/v2/notification/getall/${companyID}`)
      .then((res) => {
        console.log(res);
        setNotifications(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const statusChecks = [
    "Offer Initiation",
    "Offered",
    "Salary Proposal In-progress",
    "Salary Proposal Pending Approval",
    "Salary Proposal Approved",
    "Offer Letter In-progress",
    "Offer Letter Generated",
    "Offer Letter Pending Approval",
    "Offer Letter Approved",
    "Offer Letter Disapproved",
    "Offer Letter Revoked",
    "Acceptance Awaited",
    "Accepted",
    "Joined",
  ];

  const removeNotification = () => {
    const ids = notifications.filter((n) => {
      if (n.notificationtype == "Approval") {
        const extra_data = JSON.parse(n.subtask);
        if (extra_data.docid == activeSalaryProposal.uuid) {
          return n.uuid;
        }
      }
    });

    const uuids = ids.map((i) => {
      return i.uuid;
    });

    deleteBulkNotifications(uuids, companyID);
  };

  const removeOfferLetterPendingNotification = () => {
    const ids = notifications.filter((n) => {
      if (n.notificationtype == "todo") {
        const extra_data = JSON.parse(n.subtask);
        if (extra_data.id == applicant?.uuid) {
          return n.uuid;
        }
      }
    });

    const uuids = ids.map((i) => {
      return i.uuid;
    });

    deleteBulkNotifications(uuids, companyID);
  };

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();

  useEffect(() => {
    if (location.state != null) {
      const { uuid, rank, id, proposalId, tabState, offerletterpending } =
        location.state;
      setUuid(uuid);
      setRank(rank);
      console.log(offerletterpending);
      console.log(applicant.status);
      if (offerletterpending) {
        // setConfirmationModal("offer");
        setOfferLetterPending(true);
      }
      if (tabState) {
        setTab(
          tabState === "reqdoc" || tabState === "reqdocagain"
            ? "candidate"
            : tabState,
        );
      } else {
        setTab("candidate");
      }
      setProposalId(proposalId);
    } else {
      setUuid(query.get("aid"));
      setTabState("");
      setTab("candidate");
    }
  }, [applicant.status, location, query]);

  useEffect(() => {
    if (offerletterPending && applicant.status === "Offer Letter Generated") {
      setConfirmationModal("offer");
    }
  }, [offerletterPending, applicant.status]);

  useEffect(() => {
    if (applicant && tab == "offerletterdraft" && latestSalaryProposal) {
      fetchEditOfferLetter(applicant.offerid);
      setProposalFromLatest(latestSalaryProposal);
    }
  }, [applicant, tab, latestSalaryProposal]);

  useEffect(() => {
    if (
      companyDetails?.from_acfl &&
      (tab === "offerletter" || tab === "offerletterdraft")
    ) {
      const today = joiningDate ? parseCustomDate(joiningDate) : new Date();
      const expiry = new Date(today);
      expiry.setDate(today.getDate() + 7);
      setExpiryDate(expiry);
      setErrors((prev) => ({ ...prev, joiningDate: null, expiryDate: null }));
    }
  }, [tab, companyDetails?.from_acfl, joiningDate]);

  const statusUpdate = (stat, next) => {
    if (stat == "Salary Proposal Pending Approval") {
    }
    let data1 = {
      uuid: applicant.uuid,
      status: stat,
      companyid: companyID,
      department: jobDetails.department,
    };
    if (stat == "Salary Proposal Approved") {
      data1 = {
        uuid: applicant.uuid,
        status: stat,
        companyid: companyID,
        salaryoffered: renderValue(
          parseFloat(activeSalaryProposal?.totalfixedpay?.proposed || 0)
        ).toString(),
        salaryproposalid: activeProposal.uuid,
      };
    } else if (stat == "Offer Letter Generated") {
      data1 = {
        uuid: applicant.uuid,
        status: stat,
        companyid: companyID,
        joiningdate: joiningDate,
      };
    }
    axios
      .patch(`${server_API}/v2/applicant/update`, data1)
      .then((res) => {
        console.log(res);
        setTab(next);
      })
      .catch((err) => { });
  };
  const [docOptions, setDocOptions] = useState([
    { label: "Photo", value: "photo" },
    { label: "Aadhar Card", value: "aadharcard" },
    { label: "Pan Card", value: "pancard" },
    { label: "3 months salary slip", value: "salaryslip" },
    { label: "Education Certificate", value: "educationcertificate" },
    { label: "Others", value: "Others" },
  ]);

  const displayedDocOptions = useMemo(() => {
    return docOptions.filter(
      (opt) => companyCountryCode !== "GB" || (opt.label !== "Aadhar Card" && opt.label !== "Pan Card")
    );
  }, [docOptions, companyCountryCode]);

  const [uploadDocType, setUploadDocType] = useState();
  const [requiredDocuments, setRequiredDocuments] = useState([]);
  const [proposal, setProposal] = useState([
    {
      totalfixedpay: 0,
      variablepay: 0,
      esop: 0,
      esopvalue: 0,
      medicallifeinsurance: 0,
      relocationbonus: 0,
      sprintbonus: 0,
      totalcompensation: 0,
      increaseonctc: 0,
      increaseontc: 0,
      grossmonthlypay: 0,
      lastmonthlygrossdrawn: 0,
      proposedtotalctc: 0,
      projectedtakehome: 0,
      outgoingemployeelastgross: 0,
      effectivedateofappointment: "",
      nextpayreview: "",
      candidaturedetails: "",
      positionsanctioned: "Yes",
      newposition: "No",
      replacement: "No",
      outgoingemployee_id: "",
      outgoingemployee_name: "",
      hikepercentage: 0,
    },
    {
      totalfixedpay: 0,
      variablepay: 0,
      esop: 0,
      esopvalue: 0,
      medicallifeinsurance: 0,
      relocationbonus: 0,
      sprintbonus: 0,
      totalcompensation: 0,
      increaseonctc: 0,
      increaseontc: 0,
      grossmonthlypay: 0,
      lastmonthlygrossdrawn: 0,
      proposedtotalctc: 0,
      projectedtakehome: 0,
      outgoingemployeelastgross: 0,
      effectivedateofappointment: "",
      nextpayreview: "",
      candidaturedetails: "",
      positionsanctioned: "Yes",
      newposition: "No",
      replacement: "No",
      outgoingemployee_id: "",
      outgoingemployee_name: "",
      hikepercentage: 0,
    },
  ]);

  const handleUserSelect = async (user) => {
    try {
      setIsSendingOffer(true);
      setIsOpen(false);

      if (offerletterPending) {
        removeOfferLetterPendingNotification();
      }

      await sendOfferApproval(user.value);

      toast.success(`Offer letter Send for approval ${user.label}`, {
        icon: <ToastIcon />,
      });

      createNotification(
        companyID,
        user.value,
        "Approval",
        "Pending Offer Approval",
        `Offer approval request pending for ${applicant.name}`,
        JSON.stringify({ id: applicant.uuid }),
      );

      // reset states
      setConfirmationModal("");
      setTab("candidate");
      setIsSubmitted(false);
      setTemplateType("");
      setJoiningDate();
      setExpiryDate();
      setAdd1("");
      setAdd2("");
      setGender("");
      setPin("");
      setCity("");
      setState("");
      setCountry("");
      setJoiningLocation("");
      setErrors({});
    } catch (error) {
      toast.error("Failed to send offer letter");
      console.error(error);
    } finally {
      setIsSendingOffer(false); // stop loader
    }
  };

  const normalizeSalary = (val) => {
    if (!val) return "";
    let cleaned = val.trim();

    // list of possible prefixes to strip: you can extend if you have others
    const prefixes = ["INR", "₹", getCurrencySymbol(companyCountryCode)];

    // repeatedly strip any of those from the start (handles "INR ₹ 1000" etc.)
    let again = true;
    while (again) {
      again = false;
      for (const p of prefixes) {
        const pattern = new RegExp(
          `^\\s*${p.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}\\s*`,
          "i",
        );
        if (pattern.test(cleaned)) {
          cleaned = cleaned.replace(pattern, "").trim();
          again = true;
        }
      }
    }

    return cleaned;
  };

  const UpdateApplicant = () => {
    axios
      .patch(`${server_API}/v2/applicant/update`, {
        uuid: applicant.uuid,
        expectedsalary: `${expectedSalary && expectedSalary !== 0
          ? `${curr} ${normalizeSalary(expectedSalary)}`
          : normalizeSalary(expectedSalary)
          }`.trim(),

        currentsalary: `${currentSalary && currentSalary !== 0
          ? `${curr} ${normalizeSalary(currentSalary)}`
          : normalizeSalary(currentSalary)
          }`.trim(),

        joiningtime: joiningTime,
        companyid: companyID,
      })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [previewUrl, setPreviewUrl] = useState(null);
  const onDrop = (acceptedFiles, fileRejections) => {
    if (fileRejections && fileRejections.length > 0) {
      if (fileRejections[0].errors.some((err) => err.code === "file-too-large")) {
        setFileTypeError("File size exceeds 2 MB limit.");
      } else {
        setFileTypeError("The uploaded file format is not supported.");
      }
      setDocFiles([]);
      setPreviewUrl(null);
      return;
    }
    setFileTypeError("");
    setDocFiles(acceptedFiles);
    if (acceptedFiles.length > 0) {
      const newPreviewUrl = URL.createObjectURL(acceptedFiles[0]);
      setPreviewUrl(newPreviewUrl);
      console.log("previewUrl", newPreviewUrl);
    }
    console.log("files", acceptedFiles);
  };

  const dropzoneRef = createRef();
  const openDialog = () => {
    if (dropzoneRef.current) {
      dropzoneRef.current.open();
    }
  };

  //When in the preview section , and wrong format file is replaced then run this useEffect
  useEffect(() => {
    if (docFiles.length > 0) {
      if (confirmationModal == "previewdoc" && fileTypeError)
        setConfirmationModal("adddoc");
    }
  }, [docFiles, fileTypeError]);

  useEffect(() => {
    if (Object.keys(applicant).length > 0) {
      axios
        .get(
          `${server_API}/v2/offer/get/applicant/${applicant.uuid}/${companyID}`,
        )
        .then((res) => {
          setOfferLetterDetails(res.data[0]);
          console.log(res.data[0]);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [applicant]);

  useEffect(() => {
    if (offerLetterDetails) {
      console.log("[BUG_TRACE offerLetterDetails->PATCH applicant.update]", {
        applicant_state_uuid: applicant?.uuid,
        offerLetterDetails_uuid: offerLetterDetails?.uuid,
        offerLetterDetails_applicantid: offerLetterDetails?.applicantid,
      });
      if (
        offerLetterDetails?.applicantid &&
        applicant?.uuid &&
        offerLetterDetails.applicantid !== applicant.uuid
      ) {
        console.error(
          "[BUG_TRACE offerLetterDetails->PATCH applicant.update] SKIP: stale offerLetterDetails belongs to a different applicant",
          {
            applicant_uuid: applicant.uuid,
            offerLetterDetails_applicantid: offerLetterDetails.applicantid,
          },
        );
        return;
      }
      axios
        .patch(`${server_API}/v2/applicant/update`, {
          offerid: offerLetterDetails.uuid,
          companyid: companyID,
          uuid: applicant.uuid,
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [offerLetterDetails]);
  useEffect(() => {
    // Cleanup URL object when component unmounts or previewUrl changes
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const salaryFields = companyDetails?.salaryDetail
    ? [
      {
        label: "Medical/Life Insurance Premium",
        name: "medicallifeinsurance",
      },
      { label: "Joining/Relocation Bonus", name: "relocationbonus" },
      { label: "⁠⁠Performance/Sprint Bonus", name: "sprintbonus" },
    ]
    : [
      { label: "Variable Pay", name: "variablepay" },
      { label: "No. of Stocks", name: "esop" },
      { label: "ESOP Value", name: "esopvalue" },
    ];

  const acflFields = [
    {
      label: "LAST MONTHLY GROSS SALARY DRAWN BY THE CANDIDATE",
      name: "lastmonthlygrossdrawn",
      highlight: false,
      prefix: "Rs. ",
    },
    {
      label: "PROPOSED MONTHLY GROSS",
      name: "grossmonthlypay",
      highlight: false,
      prefix: "Rs. ",
    },
    {
      label: "PROPOSED TOTAL CTC",
      name: "proposedtotalctc",
      highlight: false,
      prefix: "Rs. ",
    },
    {
      label: "PROJECTED PRESENT TAKE HOME PAY (AFTER ALL DEDUCTIONS)",
      name: "projectedtakehome",
      highlight: false,
      prefix: "Rs. ",
    },
    {
      label: "OUTGOING EMPLOYEE LAST GROSS SALARY",
      name: "outgoingemployeelastgross",
      highlight: false,
      prefix: "Rs. ",
      visible: (p) => p.replacement === "Yes",
    },
    {
      label: "HIKE (in %age on Monthly Gross)",
      name: "hikepercentage",
      highlight: false,
      suffix: " %",
      readOnly: true,
    },
    {
      label: "EFFECTIVE DATE OF APPOINTMENT",
      name: "effectivedateofappointment",
      highlight: false,
      type: "date",
    },
    {
      label: "NEXT PAY REVIEW",
      name: "nextpayreview",
      highlight: false,
      type: "date",
    },
    {
      label: "Any other details on candidature of the candidate",
      name: "candidaturedetails",
      highlight: false,
      fullWidth: true,
      type: "textarea",
    },
  ];
  const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
    useDropzone({
      accept: ".pdf,.jpeg,.jpg,.png",
      maxSize: 2 * 1024 * 1024, // 2MB
      maxFiles: 1,
      noClick: true,
      noKeyboard: true,
      onDropAccepted: (acceptedFiles) => {
        setDocFiles(acceptedFiles);
      },
      onDropRejected: (fileRejections) => {
        console.log("Rejected files:", fileRejections);
      },
    });

  const fileValidator = () => {
    if (docFiles.length > 0) {
      // Check if the file type is supported
      if (
        !docFiles[0].name.endsWith(".pdf") &&
        !docFiles[0].name.endsWith(".jpeg") &&
        !docFiles[0].name.endsWith(".jpg") &&
        !docFiles[0].name.endsWith(".png")
      ) {
        setFileTypeError(
          "The uploaded file format is not supported. Please select a file in an acceptable format.",
        );
      }
      // Check if the file size exceeds 2MB
      else if (docFiles[0].size > 2 * 1024 * 1024) {
        // 2MB in bytes
        setFileTypeError(
          "The file size exceeds 2MB. Please select a smaller file.",
        );
      }
      // Check if the file name is too long
      else if (docFiles[0].name.length > 50) {
        setFileTypeError(
          "The file name is too long. Please select a file with a shorter name.",
        );
      } else {
        setFileTypeError(""); // Clear any error if all conditions are met
      }
    }
  };

  const showReport = (uuid) => {
    const isCb = applicant.coderbyte_enabled || jobDetails.coderbyte_enabled;
    const testId = isCb ? jobDetails.coderbyte_test_id : jobDetails.hackerrank_test_id;
    const reportPath = isCb ? "coderbyte/report" : "hackerrank/report";
    window.open(
      `${server_API}/v2/applicant/${reportPath}/${testId}/${uuid}/${companyID}`,
      "_blank",
    );
  };
  useEffect(() => {
    fileValidator();
  }, [docFiles]);
  const fetchDocumentUrl = async (id) => {
    try {
      const response = await axios.get(
        `${server_API}/v2/document/getdocumenturl/${uuid}/${id}/${companyID}`,
      );
      setDoumenturl(response.data.url);
    } catch (err) {
      setDoumenturl("");
      console.error("Error fetching documents:", err);
    }
  };

  useEffect(() => {
    if (companyID) {
      axios
        .get(`${server_API}/v2/company/geturl/${companyID}`)
        .then((response) => {
          console.log(response);
          setLogo(response.data.url);
          //   console.log(response.data.url)
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [companyID]);

  const downloadDocumentUrl = async (id) => {
    try {
      const response = await axios.get(
        `${server_API}/v2/document/getdocumenturl/${uuid}/${id}/${companyID}`,
      );
      window.location.href = response.data.url;
      // setDoumenturl(response.data.url);
    } catch (err) {
      setDoumenturl("");
      console.error("Error fetching documents:", err);
    }
  };

  //Validation of Different Forms

  const validate = (formType) => {
    let newErrors = {};

    switch (formType) {
      case "uploadDocForm":
        if (!uploadDocType)
          newErrors.uploadDocType = "Document Type is required.";
        if (!docFiles) newErrors.docFiles = "Document file is required";
        break;

      case "reqDocForm":
        if (!templateType)
          newErrors.templateType = "Email Template is required";
        if (!requiredDocuments.length > 0)
          newErrors.requiredDocuments = "Document is required";
        break;

      case "reqDocAgainForm":
        if (!templateType)
          newErrors.templateType = "Email Template is required";

        break;

      case "salaryProposalForm":
        if (!templateType)
          newErrors.templateType = "Email Template is required";
        if (!hirManager) newErrors.hirManager = "Hiring Manager is required";
        if (!proposal) newErrors.proposal = "Salary Proposal is required";
        if (!justification)
          newErrors.justification = "Justification is required";
        if (companyDetails?.from_acfl) {
          if (proposal && proposal.length > 1) {
            acflFields.forEach((field) => {
              if (field.visible && !field.visible(proposal[1])) return;
              if (field.readOnly) return;
              if (!proposal[1][field.name] && proposal[1][field.name] !== 0) {
                if (!newErrors.proposal || newErrors.proposal === "Salary Proposal is required") {
                  newErrors.proposal = `${field.label} is required`;
                }
              }
            });
          }
        }
        break;

      case "offerForm":
        if (!offerLetterTemplate?.value)
          newErrors.templateType = "Email Template is required";
        if (!joiningDate) newErrors.joiningDate = "Joining date is required";
        if (!expiryDate) newErrors.expiryDate = "Expiry date is required";
        if (isGB) {
          if (!add1) newErrors.add1 = "Address Line 1 is required";
          if (!city) newErrors.city = "Town or City is required";
          if (!pin) {
            newErrors.pincode = "Postcode is required";
          } else if (!/^[A-Za-z0-9 ]+$/.test(pin)) {
            newErrors.pincode = "Invalid Postcode format";
          }
          if (!country) newErrors.country = "Country is required";
        } else {
          if (!add1) newErrors.add1 = "Address line is required";
          if (!add2 && !companyDetails?.from_acfl)
            newErrors.add2 = "Address line is required";
          if (!pin) newErrors.pincode = "Pin Code is required";
          if (!city) newErrors.city = "City is required";
          if (!state) newErrors.state = "State is required";
          if (!country) newErrors.country = "Country is required";
        }
        if (!joiningLocation)
          newErrors.joiningLocation = "Joining location is Required";
        if (!gender || !gender.length) newErrors.gender = "Gender is required";
        if (companyDetails?.from_acfl) {
          if (!controllingOfficer)
            newErrors.controllingOfficer = "Controlling Officer is required";
          if (!probationPeriod)
            newErrors.probationPeriod = "Probation Period is required";
        }
        break;

      case "docRejectForm":
        if (!docRejectReason) newErrors.docRejectReason = "Reason is required";

        break;
      default:
        break;
    }
    console.log("Errors", newErrors);
    setErrors(newErrors);

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (isSubmitted) {
      switch (formType) {
        case "uploadDocForm":
          validate("uploadDocForm");
          break;

        case "reqDocForm":
          validate("reqDocForm");
          break;

        case "reqDocAgainForm":
          validate("reqDocAgainForm");
          break;

        case "salaryProposalForm":
          validate("salaryProposalForm");
          break;

        case "offerForm":
          validate("offerForm");
          break;

        case "docRejectForm":
          validate("docRejectForm");
          break;

        default:
          break;
      }
      console.log("Validation Done");
    }
    console.log("isSubmitted", isSubmitted);
  }, [
    uploadDocType,
    justification,
    proposal,
    hirManager,
    docFiles,
    templateType,
    requiredDocuments,
    formType,
    isSubmitted,
    docRejectReason,
    joiningDate,
    expiryDate,
    add1,
    add2,
    pin,
    city,
    state,
    country,
    gender,
    joiningLocation,
    controllingOfficer,
    probationPeriod,
  ]);

  const fetchEmailTemplates = async (companyID) => {
    try {
      const response = await axios.get(
        `${server_API}/v2/email/getcompanys/${companyID}`,
      );
      setEmailTemplates(response?.data ?? []);
    } catch (err) {
      setEmailTemplates([]);
      console.error("Error fetching Email Templates:", err);
    }
  };

  useEffect(() => {
    if (companyID) {
      fetchEmailTemplates(companyID);
    }
  }, [companyID]);

  const emailTemplatesOptions = useMemo(
    () =>
      emailTemplates.map((template) => ({
        value: template.uuid,
        label: template.category,
        data: template,
      })),
    [emailTemplates],
  );

  const salaryTemplatesOptions = useMemo(
    () =>
      emailTemplates
        .filter((template) => template.templatename === "Salary Approval" || template.templatename === "Salary Approval ACFL")
        .map((template) => ({
          value: template.uuid,
          label: template.templatename,
          data: template,
        })),
    [emailTemplates],
  );
  const DocTemplatesOptions = useMemo(
    () =>
      emailTemplates
        .filter((template) => template.templatename === "Document Upload")
        .map((template) => ({
          value: template.uuid,
          label: template.templatename,
          data: template,
        })),
    [emailTemplates],
  );

  const DocRejectTemplatesOptions = useMemo(
    () =>
      emailTemplates
        .filter(
          (template) =>
            template.templatename ===
            "Document Request from Candidate - Rejection",
        )
        .map((template) => ({
          value: template.uuid,
          label: template.templatename,
          data: template,
        })),
    [emailTemplates],
  );

  useEffect(() => {
    if (!selectedSalaryTemplate) {
      const def =
        salaryTemplatesOptions.find((o) => o.label === "Salary Approval") ??
        null;
      if (def) {
        setSelectedSalaryTemplate(def);
        setTemplateType(def);
        handleSalaryChangeEmailTemplate(def);
      }
    }
  }, [salaryTemplatesOptions, selectedSalaryTemplate]);

  useEffect(() => {
    if (!selectedDocRejectedTemplate) {
      const def =
        DocRejectTemplatesOptions.find(
          (o) => o.label === "Document Request from Candidate - Rejection",
        ) ?? null;
      if (def) {
        setSelectedDocRejectTemplate(def);
        setTemplateType(def);
        handleDocRejectChangeEmailTemplate(def);
      }
    }
  }, [DocRejectTemplatesOptions, selectedDocRejectedTemplate]);

  useEffect(() => {
    if (!selectedDocTemplate) {
      const def =
        DocTemplatesOptions.find((o) => o.label === "Document Upload") ?? null;
      if (def) {
        setSelectedDocTemplate(def);
        setTemplateType(def);
        handleDocChangeEmailTemplate(def);
      }
    }
  }, [DocTemplatesOptions, selectedDocTemplate]);

  const templateData = useMemo(
    () => ({
      Name: applicant?.name ?? "",
      CompanyName: companyDetails?.name ?? "",
      Company: companyDetails?.name ?? "",
      DocumentList: requiredDocuments.reduce(
        (acc, doc) => acc + `<p>${doc}</p>`,
        [""],
      ),
      UserName: loggedUser,
      ApplicantName: applicant?.name ?? "",
      HiringManagerName: hirManager?.label ?? "",
    }),
    [hirManager, loggedUser, applicant, companyDetails, requiredDocuments],
  );

  const documentRequestTemplateData = useMemo(
    () => ({
      Name: applicant?.name ?? "",
      CompanyName: companyDetails?.name ?? "",
      Company: companyDetails?.name ?? "",
      DocumentList: requiredDocuments.reduce(
        (acc, doc) => acc + `<p>${doc}</p>`,
        [""],
      ),
      UserName: loggedUser,
      ApplicantName: applicant?.name ?? "",
      HiringManagerName: hirManager?.label ?? "",
    }),
    [hirManager, loggedUser, applicant, companyDetails, requiredDocuments],
  );

  const handleSalaryChangeEmailTemplate = (value) => {
    if (value && value.data) {
      setSelectedTemplate(value);
      setSalarySubject(value.data.subject || "");
      setSalaryBody(value.data.emailbody || "");
    }
  };

  const handleDocChangeEmailTemplate = (value) => {
    if (value && value.data) {
      setSelectedTemplate(value);
      setDocSubject(value.data.subject || "");
      setDocBody(value.data.emailbody || "");
    }
  };

  const handleDocRejectChangeEmailTemplate = (value) => {
    if (value && value.data) {
      setSelectedTemplate(value);
      setDocRejectSubject(value.data.subject || "");
      setDocRejectBody(value.data.emailbody || "");
    }
  };

  const salaryTemplateData = {
    ApplicantName: applicant?.name ?? "",
    Name: applicant?.name ?? "",
    Company: companyDetails?.name ?? "",
    HiringManagerName: hirManager?.label ?? "",
    RecruiterName: loggedUser ?? "",
    JobTitle: jobDetails?.profilename ?? "",
  };

  console.log(activeDocId);

  const documentRejectTemplateData = useMemo(
    () => ({
      Name: applicant?.name ?? "",
      User: loggedUser,
      Company: companyDetails?.name ?? "",
      DocumentName: activeDocName ?? "",
      Reason: docRejectReason?.value,
    }),
    [loggedUser, applicant, companyDetails, activeDocName, docRejectReason],
  );

  const previewSalarySubject = populateTemplate(
    salarysubject,
    salaryTemplateData,
  );
  const previewSalaryBody = populateTemplate(salarybody, salaryTemplateData);

  const previewDocSubject = populateTemplate(
    Docsubject,
    documentRequestTemplateData,
  );
  const previewDocBody = populateTemplate(Docbody, documentRequestTemplateData);

  const previewDocRejectSubject = populateTemplate(
    docRejectSubject,
    documentRejectTemplateData,
  );
  const previewDocRejectBody = populateTemplate(
    docRejectBody,
    documentRejectTemplateData,
  );

  // const previewContentSubject = useMemo(() => { return populateTemplate(subject, templateData)}, [subject, templateData]);
  // const previewContentBody = useMemo(() => { return populateTemplate(body, templateData)}, [body, templateData]);

  const fetchDocuments = async () => {
    try {
      const response = await axios.get(
        `${server_API}/v2/document/get/applicant/${uuid}/${companyID}`,
      );
      const records = response.data;
      const docs = [];
      if (Array.isArray(records)) {
        records.forEach((record) => {
          if (Array.isArray(record.documentinfo)) {
            record.documentinfo.forEach((doc) => {
              docs.push({ ...doc, parentUuid: record.uuid });
            });
          }
        });
      }
      setAllDocuments(docs);
      if (records.length > 0) {
        setActiveDocUuid(records[0].uuid);
      }
    } catch (err) {
      setAllDocuments([]);
      console.error("Error fetching documents:", err);
    }
  };

  useEffect(() => {
    if (Object.keys(applicant).length > 0) {
      fetchDocuments();
    }
  }, [applicant]);

  const createDocument = async () => {
    const data = {
      applicantid: applicant.uuid,
      companyid: companyID,
      document_name: requiredDocuments,
      email_subject: Docsubject,
      email_body: Docbody,
    };

    try {
      const response = await axios.post(
        `${server_API}/v2/document/createdocument`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response) {
        createNotification(
          companyID,
          userid,
          "",
          "Document request mail has been sent successfully",
          `Document request mail has been successfully sent for ${companyDetails.name} to ${applicant.name}.`,
        );
      }
      console.log(response.data);
      fetchDocuments();
      setSubject("");
      setBody("");
      setSelectedTemplate();
    } catch (error) {
      console.error("Error creating document:", error);
    }
  };

  const hasErrors = Object.keys(errors).length > 0;

  //Again  Req for Doc upload by Candidate
  const uploadAgainDocument = async (status) => {
    const rejectedCaseData = {
      uuid: activeDocUuid,
      companyid: companyID,
      documentinfo: {
        document_name: activeDocName,
        status: "Pending",
        viewed: "",
      },
      send_email: status,
      subject: status ? docRejectSubject : "",
      body: status ? docRejectBody : "",
      documentid: activeDocId,
    };

    try {
      const response = await axios.patch(
        `${server_API}/v2/document/update/document`,
        rejectedCaseData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      console.log(response.data);
      fetchDocuments();
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  console.log(proposal);
  // Upload Document directly by Recruiter
  const uploadDocument = async () => {
    const data = {
      uuid: activeDocUuid,
      companyid: companyID,
      documentinfo: {
        document_name: uploadDocType,
        uploadedby: loggedUser,
        uploadeddate: new Date(),

        status: "Verified",
      },
    };

    try {
      // First PATCH request to get the document ID
      const firstResponse = await axios.patch(
        `${server_API}/v2/document/update/document`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const docid = firstResponse.data.message;

      if (docid) {
        const formData = new FormData();
        formData.append("uploadedby", loggedUser);
        formData.append("uploadeddate", new Date());
        formData.append("uuid", activeDocUuid);
        formData.append("documentid", docid);
        formData.append("companyid", companyID);
        formData.append("applicantid", applicant.uuid);
        formData.append("file", docFiles[0]);
        formData.append("status", "Verified");

        // Second PATCH request to upload the document
        const secondResponse = await axios.patch(
          `${server_API}/v2/document/addeddocument`,
          formData,
        );

        console.log("Document uploaded successfully:", secondResponse.data);
        fetchDocuments();
      }
    } catch (error) {
      console.error("Error updating document:", error);
      // Consider showing a user-friendly message to the user here
    }
  };
  console.log(proposal);

  const updateDocumentViewStatus = async (docId, docUuid) => {
    const data = {
      uuid: docUuid || activeDocUuid,
      companyid: companyID,
      documentid: docId,
      viewed: "viewed",
    };
    const url = `${server_API}/v2/document/update/documentinfo`;
    try {
      const response = await axios.patch(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("Response:", response.data);
      fetchDocuments();
    } catch (error) {
      console.error("Error updating document info:", error);
    }
  };

  console.log(activeDocId);

  //Update Document Status API
  const updateDocumentStatus = async (docid, status) => {
    const data = {
      uuid: activeDocUuid,
      companyid: companyID,
      documentid: docid,
      status: status,
      reason: status != "Verified" ? docRejectReason.value : "",
      comments: comment,
    };
    const url = `${server_API}/v2/document/update/documentinfo`;
    try {
      const response = await axios.patch(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response) {
        // createNotification(companyID, userid, "","",`Rejection mail has been successfully sent for ${activeDocName} along with re-upload link.` )
        navigate("/jobs/candidates/about", { state: { uuid: uuid } });
      }
      console.log("Response:", response.data);
      fetchDocuments();
    } catch (error) {
      console.error("Error updating document info:", error);
    }
  };

  const onlyContainsNumbers = (str) => /^[0-9,.]*$/.test(str);

  useEffect(() => {
    // console.log(proposalId)
    if (proposalId?.length > 0) {
      console.log(proposalId);
      axiosInstance
        .get(`/v2/salaryproposal/get/${proposalId}/${companyID}`)
        .then((res) => {
          console.log(res);
          setActiveSalaryProposal(res.data);
          setIsSalaryProposalModalOpen(true);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [proposalId]);

  // --------------------------------------------------------------

  //Salary Proposal APIs

  //Get salary Proposal API
  const fetchSalaryProposal = async () => {
    // Reset upfront so stale data from a previous candidate cannot leak into
    // banner/conditionals while the new fetch is in flight or returns nothing.
    setAllSalaryProposal([]);
    setLatestSProposalUuid(undefined);
    setLatestSalaryProposal(undefined);
    try {
      const response = await axios.get(
        `${server_API}/v2/salaryproposal/get/applicant/${applicant.uuid}/${companyID}`,
      );
      console.log("Fetched Salary Proposals:", response.data);

      // Setting all salary proposals
      setAllSalaryProposal(response.data);

      // Find the latest approved salary proposal
      const latestApprovedProposal = response.data
        .filter((proposal) => proposal.status === "Approved")
        .slice(-1)[0]; // Get the last approved proposal

      // Set the latest approved salary proposal UUID and proposal data
      if (latestApprovedProposal) {
        setLatestSProposalUuid(latestApprovedProposal.uuid);
        setLatestSalaryProposal(latestApprovedProposal); // Set the latest salary proposal data
      }
    } catch (error) {
      setAllSalaryProposal([]); // Clear state on error
      console.error("Error fetching salary proposals:", error);
    }
  };

  //Salary Proposal Creation API

  const fetchEditSalaryProposal = async (id) => {
    try {
      const response = await axios.get(
        `${server_API}/v2/salaryproposal/get/${id}/${companyID}`,
      );
      console.log("Fetched salary proposal id:", response.data);
      const fetchedProposal = [
        {
          totalfixedpay: response.data.totalfixedpay.current,
          variablepay: response.data.variablepay.current,
          esop: response.data.esop.current,
          esopvalue: response.data.esopvalue.current,
          medicallifeinsurance: response.data.medicallifeinsurance.current,
          relocationbonus: response.data.relocationbonus.current,
          sprintbonus: response.data.sprintbonus.current,
          totalcompensation: response.data.totalcompensation.current,
          increaseonctc: response.data.increaseonctc,
          increaseontc: response.data.increaseontc,
        },
        {
          totalfixedpay: response.data.totalfixedpay.proposed,
          variablepay: response.data.variablepay.proposed,
          esop: response.data.esop.proposed,
          esopvalue: response.data.esopvalue.proposed,
          medicallifeinsurance: response.data.medicallifeinsurance.proposed,
          relocationbonus: response.data.relocationbonus.proposed,
          sprintbonus: response.data.sprintbonus.proposed,
          totalcompensation: response.data.totalcompensation.proposed,
          increaseonctc: response.data.increaseonctc,
          increaseontc: response.data.increaseontc,
          grossmonthlypay: response.data.grossmonthlypay,
          lastmonthlygrossdrawn: response.data.lastmonthlygrossdrawn,
          proposedtotalctc: response.data.proposedtotalctc,
          projectedtakehome: response.data.projectedtakehome,
          outgoingemployeelastgross: response.data.outgoingemployeelastgross,
          effectivedateofappointment:
            response.data.effectivedateofappointment || "",
          nextpayreview: response.data.nextpayreview || "",
          candidaturedetails: response.data.candidaturedetails || "",
          positionsanctioned: response.data.positionsanctioned || "Yes",
          newposition: response.data.newposition || "No",
          replacement: response.data.replacement || "No",
          outgoingemployee_id: response.data.outgoingemployee_id || "",
          outgoingemployee_name: response.data.outgoingemployee_name || "",
          hikepercentage: response.data.hikepercentage || 0,
        },
      ];

      // Update the state with fetched proposal data
      setProposal(fetchedProposal);
      if (companyDetails.from_acfl)
        setJoiningDate(response.data.effectivedateofappointment);
      setJustification(response.data.justification);
    } catch (error) {
      console.error("Error fetching Offer Letter:", error);
    }
  };
  useEffect(() => {
    if (Object.keys(applicant).length > 0) {
      fetchSalaryProposal();
    }
  }, [applicant]);

  useEffect(() => {
    console.log("Updated Salary Proposal State:", allSalaryProposal);
  }, [allSalaryProposal]);

  const deleteSalaryProposalDraft = async (status) => {
    try {
      const response = await axios.delete(
        `${server_API}/v2/salaryproposal/delete/${activeSProposalUuid}/${companyID}`,
      );
      console.log(response.data);
      fetchSalaryProposal();
    } catch (error) {
      console.error("Error  deleting :", error);
    }
  };

  const activeSalaryProposalCtc = () => {
    const proposed = parseFloat(
      activeSalaryProposal?.totalfixedpay.proposed || 0,
    );
    const current = parseFloat(
      activeSalaryProposal?.totalfixedpay.current || 0,
    );
    const diff = proposed - current;
    let per = diff / current;
    return ~~(per * 100);
  };

  const activeSalaryProposalTc = () => {
    const proposed = parseFloat(
      activeSalaryProposal?.totalcompensation.proposed || 0,
    );

    const current = parseFloat(
      activeSalaryProposal?.totalcompensation.current || 0,
    );
    const diff = proposed - current;
    let per = diff / current;
    return ~~(per * 100);
  };

  const increaseOnCtc = () => {
    const proposed = parseFloat(proposal[1].totalfixedpay || 0);
    const current = parseFloat(proposal[0].totalfixedpay || 0);
    const diff = proposed - current;
    let per = diff / current;
    return ~~(per * 100);
  };

  const increaseOnTc = () => {
    console.log(proposal[1].totalcompensation);
    const proposed = proposedTotalComp();

    const current = currentTotalComp();
    const diff = proposed - current;
    let per = diff / current;
    return ~~(per * 100);
  };

  const createSalaryProposal = async (status) => {
    const current = proposal[0];
    const proposed = proposal[1];
    const data = {
      applicantid: applicant.uuid,
      companyid: companyID,
      totalfixedpay: {
        current: `${companyDetails?.from_acfl ? proposed.lastmonthlygrossdrawn * 12 : current.totalfixedpay}`,
        proposed: `${companyDetails?.from_acfl ? proposed.grossmonthlypay * 12 : proposed.totalfixedpay}`,
      },
      variablepay: {
        current: `${current.variablepay}`,
        proposed: `${proposed.variablepay}`,
      },
      esop: {
        current: `${current.esop}`,
        proposed: `${proposed.esop}`,
      },
      esopvalue: {
        current: `${current.esopvalue}`,
        proposed: `${proposed.esopvalue}`,
      },
      totalcompensation: {
        current: `${currentTotalComp()}`,
        proposed: `${proposedTotalComp()}`,
      },
      relocationbonus: {
        current: `${current.relocationbonus}`,
        proposed: `${proposed.relocationbonus}`,
      },
      medicallifeinsurance: {
        current: `${current.medicallifeinsurance}`,
        proposed: `${proposed.medicallifeinsurance}`,
      },
      sprintbonus: {
        current: `${current.sprintbonus}`,
        proposed: `${proposed.sprintbonus}`,
      },
      increaseonctc: `${proposed.increaseonctc}`,
      increaseontc: `${proposed.increaseontc}`,
      hiring_manager: hirManager.value,
      justification: justification,
      status: status,
      createdby: loggedUser,
      email_body: salarybody,
      email_subject: salarysubject,
      ...(companyDetails?.from_acfl && {
        grossmonthlypay: String(proposed.grossmonthlypay) || "0",
        lastmonthlygrossdrawn: String(proposed.lastmonthlygrossdrawn) || "0",
        proposedtotalctc: String(proposed.proposedtotalctc) || "0",
        projectedtakehome: String(proposed.projectedtakehome) || "0",
        outgoingemployeelastgross:
          String(proposed.outgoingemployeelastgross) || "0",
        effectivedateofappointment: String(proposed.effectivedateofappointment),
        nextpayreview: String(proposed.nextpayreview),
        candidaturedetails: String(proposed.candidaturedetails),
        positionsanctioned: String(proposed.positionsanctioned),
        newposition: String(proposed.newposition),
        replacement: String(proposed.replacement),
        outgoingemployee_id: String(proposed.outgoingemployee_id),
        outgoingemployee_name: String(proposed.outgoingemployee_name),
        hikepercentage: String(proposed.hikepercentage),
      }),
    };

    try {
      const response = await axios.post(
        `${server_API}/v2/salaryproposal/create`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      console.log(response.data);
      if (response) {
        setBody("");
        setSubject("");
        setSelectedTemplate();
        if (status == "Approval Pending") {
          // createNotification(
          //   companyID,
          //   userid,
          //   "Approval",
          //   "Approve Salary Proposal",
          //   `Approve ${applicant.name}'s salary proposal`,
          //   JSON.stringify({ id: applicant.uuid, docid: response.data.message })
          // );
          createNotification(
            companyID,
            hirManager.value,
            "Approval",
            "Approve Salary Proposal",
            `Approve ${applicant.name}'s salary proposal`,
            JSON.stringify({
              id: applicant.uuid,
              docid: response.data.message,
            }),
          );
        }
        axios
          .post(
            `${server_API}/v2/salaryproposal/approved/${response.data.message}/${companyID}`,
          )
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      }
      fetchSalaryProposal();
    } catch (error) {
      console.error("Error creating document:", error);
    }
  };

  const updateSalaryProposalStatus = (status) => {
    axios
      .patch(`${server_API}/v2/salaryproposal/update`, {
        companyid: companyID,
        uuid: activeSalaryProposal.uuid,
        status: status,
      })
      .then((res) => {
        // navigate()
        if (status !== "Approved")
          window.location.reload();
        // window.location.reload()
      })
      .catch((err) => {
        console.log(err);
      });
  };

  console.log(proposal);

  const updateSalaryProposalDraft = async (status) => {
    const current = proposal[0];
    const proposed = proposal[1];
    const data = {
      uuid: activeSProposalUuid,
      companyid: companyID,
      totalfixedpay: {
        current: `${companyDetails?.from_acfl ? proposed.lastmonthlygrossdrawn * 12 : current.totalfixedpay}`,
        proposed: `${companyDetails?.from_acfl ? proposed.grossmonthlypay * 12 : proposed.totalfixedpay}`,
      },
      variablepay: {
        current: `${current.variablepay}`,
        proposed: `${proposed.variablepay}`,
      },
      esop: {
        current: `${current.esop}`,
        proposed: `${proposed.esop}`,
      },
      esopvalue: {
        current: `${current.esopvalue}`,
        proposed: `${proposed.esopvalue}`,
      },
      totalcompensation: {
        current: `${current.totalcompensation}`,
        proposed: `${proposed.totalcompensation}`,
      },
      increaseonctc: `${proposed.increaseonctc}`,
      increaseontc: `${proposed.increaseontc}`,

      justification: justification,
      status: status,
      createdby: loggedUser,
      ...(companyDetails?.from_acfl && {
        grossmonthlypay: String(proposed.grossmonthlypay) || "0",
        lastmonthlygrossdrawn: String(proposed.lastmonthlygrossdrawn) || "0",
        proposedtotalctc: String(proposed.proposedtotalctc) || "0",
        projectedtakehome: String(proposed.projectedtakehome) || "0",
        outgoingemployeelastgross:
          String(proposed.outgoingemployeelastgross) || "0",
        effectivedateofappointment:
          String(proposed.effectivedateofappointment) || "",
        nextpayreview: String(proposed.nextpayreview),
        candidaturedetails: String(proposed.candidaturedetails),
        positionsanctioned: String(proposed.positionsanctioned),
        newposition: String(proposed.newposition),
        replacement: String(proposed.replacement),
        outgoingemployee_id: String(proposed.outgoingemployee_id),
        outgoingemployee_name: String(proposed.outgoingemployee_name),
        hikepercentage: String(proposed.hikepercentage),
      }),
    };

    try {
      const response = await axios.patch(
        `${server_API}/v2/salaryproposal/update`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      console.log(response.data);
      fetchSalaryProposal();
    } catch (error) {
      console.error("Error creating document:", error);
    }
  };

  //set The latest Proposal array to Proposal
  const setProposalFromLatest = (latestProposal) => {
    const fetchedProposal = [
      {
        totalfixedpay: latestProposal.totalfixedpay.current,
        variablepay: latestProposal.variablepay.current,
        esop: latestProposal.esop.current,
        esopvalue: latestProposal.esopvalue.current,
        medicallifeinsurance: latestProposal.medicallifeinsurance.current,
        relocationbonus: latestProposal.relocationbonus.current,
        sprintbonus: latestProposal.sprintbonus.current,
        totalcompensation: latestProposal.totalcompensation.current,
        increaseonctc: latestProposal.increaseonctc,
        increaseontc: latestProposal.increaseontc,
      },
      {
        totalfixedpay: latestProposal.totalfixedpay.proposed,
        variablepay: latestProposal.variablepay.proposed,
        esop: latestProposal.esop.proposed,
        esopvalue: latestProposal.esopvalue.proposed,
        medicallifeinsurance: latestProposal.medicallifeinsurance.proposed,
        relocationbonus: latestProposal.relocationbonus.proposed,
        sprintbonus: latestProposal.sprintbonus.proposed,
        totalcompensation: latestProposal.totalcompensation.proposed,
        increaseonctc: latestProposal.increaseonctc,
        increaseontc: latestProposal.increaseontc,
        // ACFL Fields
        grossmonthlypay: latestProposal.grossmonthlypay,
        lastmonthlygrossdrawn: latestProposal.lastmonthlygrossdrawn,
        proposedtotalctc: latestProposal.proposedtotalctc,
        projectedtakehome: latestProposal.projectedtakehome,
        outgoingemployeelastgross: latestProposal.outgoingemployeelastgross,
        effectivedateofappointment: latestProposal.effectivedateofappointment,
        nextpayreview: latestProposal.nextpayreview,
        candidaturedetails: latestProposal.candidaturedetails,
        positionsanctioned: latestProposal.positionsanctioned,
        newposition: latestProposal.newposition,
        replacement: latestProposal.replacement,
        outgoingemployee_id: latestProposal.outgoingemployee_id,
        outgoingemployee_name: latestProposal.outgoingemployee_name,
        hikepercentage: latestProposal.hikepercentage,
      },
    ];

    setProposal(fetchedProposal);
    if (companyDetails.from_acfl)
      setJoiningDate(latestProposal.effectivedateofappointment);
  };

  //------------------------------------------
  // Offer Letter APIs
  const fetchOfferLetter = async () => {
    // Reset upfront so previous candidate's offer-letter state cannot leak into
    // banners/conditionals while the new fetch is in flight or returns nothing.
    setAllOfferLetter([]);
    setActiveOfferUuid();
    setActiveOfferStatus();
    try {
      const response = await axios.get(
        `${server_API}/v2/offer/get/applicant/${applicant.uuid}/${companyID}`,
      );
      console.log("Fetched Offer Letter:", response.data);

      // Setting all salary proposals
      setAllOfferLetter(response.data);
      setActiveOfferUuid(response.data.uuid);
      setActiveOfferStatus(response.data.status);
    } catch (error) {
      setAllOfferLetter([]); // Clear state on error
      setActiveOfferUuid();
      setActiveOfferStatus();
      console.error("Error fetching Offer Letter:", error);
    }
  };

  console.log(activeProposalStatus);
  useEffect(() => {
    if (Object.keys(jobDetails).length > 0) {
      if (jobDetails["location:"].includes(",")) {
        const locations = jobDetails["location:"].split(",").map((j) => {
          return { label: j, value: j };
        });
        setJoiningLocationOptions(locations);
      } else {
        setJoiningLocationOptions([
          { label: jobDetails["location:"], value: jobDetails["location"] },
        ]);
      }
    }
  }, [jobDetails]);

  useEffect(() => {
    if (Object.keys(applicant).length > 0 && applicant.address) {
      const addressSplit = applicant.address.split(",");
      setAdd1(addressSplit[0]?.trim() || "");
      setAdd2(addressSplit[1]?.trim() || "");
      setPin(addressSplit[2]?.trim() || "");
      setGender(applicant.gender || "");
      setCity(addressSplit[3]?.trim() || "");
      setState(addressSplit[4]?.trim() || "");
      setCountry(addressSplit[5]?.trim() || "");
    }
  }, [applicant]);

  const fetchPincodeDetails = useCallback(async (pincode) => {
    const trimmed = String(pincode).trim();
    if (trimmed.length !== 6 || !/^\d{6}$/.test(trimmed)) return;
    setPinLoading(true);
    try {
      const res = await axios.get(`https://api.postalpincode.in/pincode/${trimmed}`);
      const data = res.data?.[0];
      if (data?.Status === "Success" && data?.PostOffice?.length > 0 && pinRef.current === trimmed) {
        const first = data.PostOffice[0];
        setCity(first.District || "");
        setState(first.State || "");
        setCountry(first.Country || "India");
      }
    } catch (err) {
      console.error("Pincode lookup error:", err);
    } finally {
      if (pinRef.current === trimmed) setPinLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isGB) return;
    const trimmed = String(pin).trim();
    if (trimmed.length === 6 && /^\d{6}$/.test(trimmed)) {
      fetchPincodeDetails(trimmed);
    }
  }, [pin, fetchPincodeDetails, isGB]);

  const fetchEditOfferLetter = async (id) => {
    console.log(id);
    try {
      const response = await axios.get(
        `${server_API}/v2/offer/getoffer/${companyID}/${id}`,
      );
      const draftData = response.data;
      console.log("Fetched Offer Letterid:", response.data);
      if (draftData.templatename) {
        setTemplateType({
          value: draftData.templatename || "",
          label: draftData.templatename || "",
        });
      } else {
        setTemplateType();
      }

      if (draftData.joiniglocation) {
        setJoiningLocation({
          value: draftData.joiniglocation || "",
          label: draftData.joiniglocation || "",
        });
      } else {
        setJoiningLocation();
      }
      setJoiningDate(
        location.state.joiningDate || draftData.joiningdate || null,
      );
      setExpiryDate(draftData.expirydate || null);
      const addressParts = draftData.adderess.split(",");
      setAdd1(addressParts[0]?.trim() || "");
      setAdd2(addressParts[1]?.trim() || "");
      setPin(addressParts[2]?.trim() || "");
      setCity(addressParts[3]?.trim() || "");
      setState(addressParts[4]?.trim() || "");
      setCountry(addressParts[5]?.trim() || "");
      setGender(applicant.gender || "");
      setControllingOfficer(draftData.controlling_officer || "");
      setProbationPeriod(draftData.probation_period || "");
    } catch (error) {
      console.error("Error fetching Offer Letter:", error);
    }
  };

  const { send } = useFetch(
    "/v2/applicant/offer/generate",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    },
    false,
  );

  useEffect(() => {
    if (Object.keys(applicant).length > 0) {
      fetchOfferLetter();
    }
  }, [applicant]);

  const createOfferLetter = async (status) => {
    const data = {
      applicantid: applicant.uuid,
      companyid: companyID,
      salaryproposalid: latestSProposalUuid,
      createdby: loggedUser,
      templatename: offerLetterTemplate.value,
      title: jobDetails?.profilename,
      joiningdate: joiningDate,
      expirydate: expiryDate,
      joiniglocation: joiningLocation?.label,
      date: new Date(),
      adderess: `${add1}, ${add2}, ${pin}, ${city}, ${state}, ${country}`,
      status: status,
      ...(companyDetails?.from_acfl && {
        controlling_officer: controllingOfficer,
        probation_period: probationPeriod,
      }),
    };

    try {
      const response = await axios.post(`${server_API}/v2/offer/create`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("Offer Letter Created:", response.data);
      const newOfferId = response.data.message || response.data.uuid;
      const offerLetterData = {
        company_id: companyID,
        offer_id: newOfferId,
        template_id: offerLetterTemplate.value,
        applicant_id: applicant.uuid,
        variables: {
          candidate_name: applicant.name,
          candidate_first_name: applicant.name?.split(" ")?.[0],
          address_line_1: add1,
          address_line_2: add2,
          city: city,
          pin_code: pin,
          state: state,
          job_title: jobDetails?.profilename,
          department_name: jobDetails?.department || "",
          grade: jobDetails?.grade || "",
          date_of_join: joiningDate,
          date_of_offer_expiry: expiryDate,
          location: joiningLocation?.label,
          company_name: companyDetails?.companyname,
          ...(companyDetails?.from_acfl && {
            controlling_officer: controllingOfficer,
            probation_period: probationPeriod,
          }),
        },
      };

      if (status !== "Generated") send({ ...offerLetterData, offer_id: newOfferId });
      setIsSubmitted(true);
      fetchOfferLetter();
      return newOfferId;
    } catch (error) {
      console.error("Error creating document:", error);
    }
  };

  function parseNumber(val) {
    if (val === null || val === undefined) return 0;
    if (typeof val === "string") {
      val = val.replace(/,/g, "").trim(); // remove commas/spaces
    }
    const num = Number(val);
    return isNaN(num) ? 0 : num;
  }

  const currentTotalComp = () => {
    if (companyDetails?.salaryDetail) {
      return (
        parseNumber(proposal[0].totalfixedpay) +
        parseNumber(proposal[0].medicallifeinsurance) +
        parseNumber(proposal[0].relocationbonus) +
        parseNumber(proposal[0].sprintbonus)
      );
    } else {
      return (
        parseNumber(proposal[0].totalfixedpay) +
        parseNumber(proposal[0].variablepay) +
        parseNumber(proposal[0].esopvalue)
      );
    }
  };

  const proposedTotalComp = () => {
    if (companyDetails?.salaryDetail) {
      return (
        parseNumber(proposal[1].totalfixedpay) +
        parseNumber(proposal[1].medicallifeinsurance) +
        parseNumber(proposal[1].relocationbonus) +
        parseNumber(proposal[1].sprintbonus)
      );
    } else {
      return (
        parseNumber(proposal[1].totalfixedpay) +
        parseNumber(proposal[1].variablepay) +
        parseNumber(proposal[1].esopvalue)
      );
    }
  };

  const deleteOfferDraft = async (id) => {
    try {
      const response = await axios.delete(
        `${server_API}/v2/offer/delete/${companyID}/${id}`,
      );
      console.log(response.data);
      fetchOfferLetter();
    } catch (error) {
      console.error("Error  deleting :", error);
    }
  };

  const updateOfferDraft = async (status) => {
    const data = {
      uuid: activeOfferUuid,
      companyid: companyID,
      title: jobDetails?.profilename,
      joiningdate: joiningDate,
      expirydate: expiryDate,
      joiniglocation: joiningLocation?.label,
      date: new Date(),
      adderess: `${add1}, ${add2}, ${pin}, ${city}, ${state}, ${country}`,
      status: status,
      ...(companyDetails?.from_acfl && {
        controlling_officer: controllingOfficer,
        probation_period: probationPeriod,
      }),
    };

    try {
      const response = await axios.patch(
        `${server_API}/v2/offer/update`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const newOfferId = activeOfferUuid;
      const offerLetterData = {
        company_id: companyID,
        template_id: offerLetterTemplate.value,
        offer_id: newOfferId,
        applicant_id: applicant.uuid,
        variables: {
          candidate_name: applicant.name,
          candidate_first_name: applicant.name?.split(" ")?.[0],
          address_line_1: add1,
          address_line_2: add2,
          city: city,
          pin_code: pin,
          state: state,
          job_title: jobDetails?.profilename,
          grade: jobDetails?.grade,
          date_of_join: joiningDate,
          date_of_offer_expiry: expiryDate,
          location: joiningLocation?.label,
          company_name: companyDetails?.companyname,
          ...(companyDetails?.from_acfl && {
            controlling_officer: controllingOfficer,
            probation_period: probationPeriod,
          }),
        },
      };
      if (status !== "Generated") send({ ...offerLetterData, offer_id: newOfferId });
      fetchOfferLetter();
      return newOfferId;
    } catch (error) {
      console.error("Error ", error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString();

    return `${day} ${month} ${year}`;
  };

  const monthlySalary = (event) => {
    const { value } = event.target;
    if (onlyContainsNumbers(value)) {
      const sanitizedValue = value.replace(/,/g, "");

      // Format the number with commas

      const formattedValue = Number(sanitizedValue).toLocaleString();

      setCurrentSalary(formattedValue);
    } else {
      setCurrentSalary("");
    }
  };

  const expectedMSalary = (event) => {
    const { value } = event.target;
    if (onlyContainsNumbers(value)) {
      const sanitizedValue = value.replace(/,/g, "");

      // Format the number with commas

      const formattedValue = Number(sanitizedValue).toLocaleString();

      setExpectedSalary(formattedValue);
    } else {
      setExpectedSalary("");
    }
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const newData = proposal.map((f, i) => {
      if (index === i) {
        let updatedRow = { ...f, [name]: value };

        // ACFL specific calculations
        if (companyDetails?.from_acfl) {
          if (name === "grossmonthlypay") {
            const monthly = parseFloat(value) || 0;
            updatedRow.totalfixedpay = monthly * 12;

            // Calculate Hike if lastmonthlygrossdrawn is present
            const lastGross = parseFloat(updatedRow.lastmonthlygrossdrawn) || 0;
            if (lastGross > 0) {
              updatedRow.hikepercentage = (
                ((monthly - lastGross) / lastGross) *
                100
              ).toFixed(2);
            }
          }
          if (name === "lastmonthlygrossdrawn") {
            const lastGross = parseFloat(value) || 0;
            const monthly = parseFloat(updatedRow.grossmonthlypay) || 0;
            if (lastGross > 0) {
              updatedRow.hikepercentage = (
                ((monthly - lastGross) / lastGross) *
                100
              ).toFixed(2);
            }
          }
        }

        return updatedRow;
      }
      return f;
    });
    setProposal(newData);
  };
  const underReviewActions = [
    { label: "Show Document", value: "show" },
    { label: "Download", value: "download" },
  ];

  const rejectedActions = [{ label: "Request Again", value: "request" }];

  useEffect(() => {
    if (documentAction.length > 0) {
    }
  }, [documentAction]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [tab]);

  const toggleRecorded = () => {
    setRecordedVisible((prev) => !prev);
  };
  const toggleAi = () => {
    setAIVisible((prev) => !prev);
  };
  const toggleFeedback = () => {
    setFeedbackVisible((prev) => !prev);
  };
  const toggleDocument = () => {
    setDocumentVisible((prev) => !prev);
  };
  const toggleHackerRank = () => {
    setHackerRankVisible((prev) => !prev);
  };
  const toggleProposals = () => {
    if (userPrivilege === roleTypes.hiringManager) return;
    setProposalsVisible((prev) => !prev);
  };
  const buildPDFPayload = () => {
    const chunk = interviews?.[0]?.chunk ?? [];
    const catMap = { ct: "Critical Thinking", gm: "Growth Mindset", c: "Communication", tw: "Teamwork", ls: "Active Listening" };
    const softSkills = Object.entries(catMap)
      .map(([key, label]) => {
        const found = chunk.find((c) => c.Category === key);
        const score = found
          ? (found.Status === "Completed" ? found.MLNumericScore : found.BiLSTMScore || found.GorgoniaMLNumericScore) ?? 0
          : 0;
        return { label, score, max: 5 };
      })
      .filter((s) => s.score > 0);

    // Strip any currency prefix/symbol/commas to get a clean numeric string
    // Handles: "INR 300,000" / "₹ 2400000" / "" / undefined
    const extractNum = (s) => String(s || "").replace(/[^0-9]/g, "");
    const pdfSym = getPDFCurrencySymbol(companyCountryCode);

    const currentNumStr = extractNum(applicant?.currentsalary);
    const expectedNumStr = extractNum(applicant?.expectedsalary);

    const currentSalaryDisplay = currentNumStr
      ? `${pdfSym}${formatSalary(currentNumStr, companyCountryCode)}`
      : "-";
    const expectedSalaryDisplay = expectedNumStr
      ? `${pdfSym}${formatSalary(expectedNumStr, companyCountryCode)}`
      : "-";
    // Pass raw integer for salary range comparison in PDF
    const expectedSalaryRaw = parseInt(expectedNumStr, 10) || null;

    return {
      applicant,
      jobDetails,
      skillArray,
      minSalary,
      maxSalary,
      companyCountryCode,
      currencySymbol: pdfSym,
      phoneCode: getPhoneCode(companyCountryCode),
      joiningTime,
      softSkills,
      interviews,
      isFromACFL: companyDetails?.from_acfl ?? false,
      currentSalaryDisplay,
      expectedSalaryDisplay,
      expectedSalaryRaw,
    };
  };

  const downloadPDF = async () => {
    try {
      setShowPdfMenu(false);
      const payload = buildPDFPayload();
      const blob = await pdf(<CandidatePDFDocument payload={payload} />).toBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${applicant?.name || "candidate"}_overview.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("PDF generation failed:", err);
    }
  };

  const toggleRejected = () => {
    setRejectedFeedbackOpen((prev) => !prev);
  };
  // const companyID = localStorage.getItem("companyID");
  // const applicantId = localStorage.getItem("uuid");

  const { data: listOfTemplates = {} } = useFetch(
    `/v2/template/getall/${companyID}?type=offer`,
  );

  const emailTemplateOptions = listOfTemplates.templates
    ? listOfTemplates.templates.map((template) => ({
      label: template.name,
      value: template.uuid,
    }))
    : [{}];

  const [offerLetterTemplate, setOfferLetterTemplate] = useState([]);

  console.log("required", requiredDocuments);
  const renderValue = (value) => (value ? value : "-");
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   if(companyID.length>0){
  //     axios
  //       .get(`${server_API}/v2/user/company/${companyID}`)
  //       .then((response) => {
  //         console.log(response)
  //         setAllUsers(response.data.Users);
  //       })
  //       .catch((err) => {
  //         setAllUsers([]);
  //         console.error(err);
  //       });
  //   }
  // }, [companyID]);

  console.log(companyID);
  useEffect(() => { }, []);

  console.log(allUsers);

  //get Logged User name
  useEffect(() => {
    window.scrollTo(0, 0);
    axiosInstance
      .get(`/v2/user/getuser`, {
        withCredentials: true,
      })
      .then((res) => {
        console.log(res);
        setLoggedUser(res.data.success.name);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
    const myHeaders = new Headers();
    myHeaders.append("Cookie", "Cookie_1=value");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${server_API}/v2/user/company/${companyID}`, requestOptions)
      .then(async (result) => {
        const res = await result.json();
        setAllUsers(res.message.Users);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    if (allUsers.length > 0) {
      let userOptions = [];
      allUsers.map((u) => {
        if (u.status != "sent") {
          userOptions.push({ label: u.name, value: u.uuid });
        }
      });
      setuserLabels(userOptions);
    }
  }, [allUsers]);

  useEffect(() => {
    if (allUsers.length > 0) {
      let userOptions = [];
      allUsers.map((u) => {
        if (u.status != "sent" && u.privilege == "Admin" && u.uuid != userid) {
          userOptions.push({ label: u.name, value: u.uuid });
        }
      });
      setAdminUserLabels(userOptions);
    }
  }, [allUsers]);

  const handleJoiningDateChange = (date) => {
    setJoiningDate(date);

    if (expiryDate && date && expiryDate >= date) {
      setErrors((prev) => ({
        ...prev,
        joiningDate: "Joining Date must be after Offer Valid Till",
      }));
    } else {
      setErrors((prev) => ({ ...prev, joiningDate: null, expiryDate: null }));
    }
  };

  const handleExpiryDateChange = (date) => {
    setExpiryDate(date);

    if (joiningDate && date && date >= joiningDate) {
      setErrors((prev) => ({
        ...prev,
        expiryDate: "Offer Valid Till must be before Joining Date",
      }));
    } else {
      setErrors((prev) => ({ ...prev, joiningDate: null, expiryDate: null }));
    }
  };

  const resetProposal = () => {
    const emptyProposal = proposal.map(() => ({
      totalfixedpay: 0,
      variablepay: 0,
      esop: 0,
      esopvalue: 0,
      medicallifeinsurance: 0,
      relocationbonus: 0,
      sprintbonus: 0,
      totalcompensation: 0,
      increaseonctc: 0,
      increaseontc: 0,
    }));
    setProposal(emptyProposal);
  };

  console.log(tab);

  // useEffect(() => {
  //   if (allUsers.length > 0) {
  //     const users = allUsers.filter((item) => {
  //       if (item.status === "accepted") {
  //         Object.defineProperty(
  //           item,
  //           "value",
  //           Object.getOwnPropertyDescriptor(item, "uuid")
  //         );
  //         Object.defineProperty(
  //           item,
  //           "label",
  //           Object.getOwnPropertyDescriptor(item, "name")
  //         );
  //         return item;
  //       }
  //     });

  //     users.push({ value: "12", label: "Sanjeev" });

  //     setHiringManagers(users);
  //     console.log("hm", hiringManagers);

  //     const editorOrViewers = allUsers.filter((f) => {
  //       if (f.privilege !== "Admin" && f.status === "accepted") {
  //         Object.defineProperty(
  //           f,
  //           "value",
  //           Object.getOwnPropertyDescriptor(f, "uuid")
  //         );
  //         Object.defineProperty(
  //           f,
  //           "label",
  //           Object.getOwnPropertyDescriptor(f, "name")
  //         );
  //         return f;
  //       }
  //     });
  //     setRecruiters(editorOrViewers);
  //   }
  // }, [allUsers]);

  useEffect(() => {
    if (allUsers?.length > 0) {
      // Process and transform users for hiringManagers
      const users = allUsers
        .filter((item) => item.status === "accepted")
        .map((item) => {
          return {
            value: item.uuid,
            label: item.name,
          };
        });

      // Add your name to the users array
      users.push({ value: "12", label: "Sanjeev" });

      // Add the default option at the beginning
      users.unshift({ value: "", label: "Select an option" });

      setHiringManagers(users);
      console.log("hm", users);

      // Process and transform users for recruiters without changing the recruiters code
      const editorOrViewers = allUsers
        .filter((f) => f.privilege !== "Admin" && f.status === "accepted")
        .map((f) => {
          return {
            value: f.uuid,
            label: f.name,
          };
        });

      setRecruiters(editorOrViewers);
    }
  }, [allUsers]);

  useEffect(() => {
    if (interviews.length > 0) {
      interviews[0].chunk.map((c, i) => {
        scores.set(
          c.Category,
          c.Status === "Completed"
            ? c.MLNumericScore
            : c.BiLSTMScore || c.GorgoniaMLNumericScore,
        );
      });
    }
  }, [interviews]);

  const sendOfferApproval = async (uuid_signatory) => {
    if (offerRef.current) {
      const offerAddress = allOfferLetter[0].adderess?.split(", ");

      console.log("[BUG_TRACE sendOfferApproval] state snapshot", {
        url_uuid: uuid,
        applicant_state_uuid: applicant?.uuid,
        applicant_state_name: applicant?.name,
        offerLetterDetails_uuid: offerLetterDetails?.uuid,
        offerLetterDetails_applicantid: offerLetterDetails?.applicantid,
        offerLetterDetails_templatename: offerLetterDetails?.templatename,
        allOfferLetter_0_uuid: allOfferLetter?.[0]?.uuid,
        allOfferLetter_0_applicantid: allOfferLetter?.[0]?.applicantid,
      });
      if (!applicant?.uuid || !offerLetterDetails?.uuid) {
        toast.error("Applicant data still loading. Please try again in a moment.");
        return;
      }
      if (
        offerLetterDetails.applicantid &&
        applicant.uuid !== offerLetterDetails.applicantid
      ) {
        console.error(
          "[BUG_TRACE sendOfferApproval] BLOCKED: offerLetterDetails belongs to a different applicant",
          {
            applicant_uuid: applicant.uuid,
            offerLetterDetails_applicantid: offerLetterDetails.applicantid,
          },
        );
        toast.error(
          "Offer letter data is out of sync with this applicant. Please refresh and try again.",
        );
        return;
      }

      await offerRef.current.sendOfferApproval({
        company_id: companyID,
        offer_id: offerLetterDetails.templatename,
        applicant_id: applicant.uuid,
        user_id: uuid_signatory,
        offer_letter_id: offerLetterDetails.uuid,
        variables: {
          candidate_name: applicant.name,
          candidate_first_name: applicant.name?.split(" ")?.[0],
          address_line_1: offerAddress[0],
          address_line_2: offerAddress[1],
          city: isGB ? (offerAddress[3] || "").trim().toUpperCase() : offerAddress[3],
          pin_code: offerAddress[2],
          state: offerAddress[4],
          job_title: jobDetails?.profilename,
          grade: jobDetails?.grade,
          date_of_join: joiningDate,
          date_of_offer_expiry: expiryDate,
          location: joiningLocation?.label,
          company_name: companyDetails?.companyname,
          signatory: uuid_signatory,
        },
      });
    }
  };

  const sendOfferLetter = async () => {
    if (offerRef.current) {
      const offerAddress = allOfferLetter[0].adderess?.split(", ");

      if (!applicant?.uuid || !offerLetterDetails?.uuid) {
        toast.error("Applicant data still loading. Please try again in a moment.");
        return;
      }
      if (
        offerLetterDetails.applicantid &&
        applicant.uuid !== offerLetterDetails.applicantid
      ) {
        console.error(
          "[BUG_TRACE sendOfferLetter] BLOCKED: offerLetterDetails belongs to a different applicant",
          {
            applicant_uuid: applicant.uuid,
            offerLetterDetails_applicantid: offerLetterDetails.applicantid,
          },
        );
        toast.error(
          "Offer letter data is out of sync with this applicant. Please refresh and try again.",
        );
        return;
      }

      await offerRef.current.sendOfferLetter({
        company_id: companyID,
        template_id: offerLetterDetails.templatename,
        applicant_id: applicant.uuid,
        offer_id: offerLetterDetails.uuid,
        variables: {
          candidate_name: applicant.name,
          candidate_first_name: applicant.name?.split(" ")?.[0],
          address_line_1: offerAddress[0],
          address_line_2: offerAddress[1],
          city: isGB ? (offerAddress[3] || "").trim().toUpperCase() : offerAddress[3],
          pin_code: offerAddress[2],
          state: offerAddress[4],
          job_title: jobDetails?.profilename,
          grade: jobDetails?.grade,
          date_of_join: joiningDate,
          date_of_offer_expiry: expiryDate,
          location: joiningLocation?.label,
          company_name: companyDetails?.companyname,
        },
      });
    }
  };

  const fetchApplicants = async (currentJobId, page) => {
    const mapStatusToTab = {
      0: "",
      1: "interviewed",
      2: "offer",
      3: "hired",
      5: "rejected",
      4: "Onhold",
    };

    const params = { jobid: currentJobId };

    if (mapStatusToTab[ct]?.length) {
      params.status = mapStatusToTab[ct];
    }
    if (filters.fitmentFilter.label !== "--") {
      params.salaryFitment = filters.fitmentFilter.label;
    }
    if (filters.timeToJoinFilter.label !== "--") {
      params.time_to_join = filters.timeToJoinFilter.label;
    }
    if (filters.sourceFilter.label !== "--") {
      params.source = filters.sourceFilter.label;
    }
    if (filters?.startDate?.length || filters?.endDate?.length) {
      if (filters?.endDate?.length)
        params.application_date = (filters.startDate || "") + "#" + (filters.endDate || "");
      else params.application_date = filters.startDate || "";
    }

    const finalFilters = {
      page: page || filters.page,
      page_size: filters.page_size,
      filter: new URLSearchParams(params).toString().replaceAll("+", " "),
    };

    const baseUrl = `${server_API}/v2/applicant/getall/${companyID}?`;
    let url = "";

    const urlFilters = new URLSearchParams(finalFilters).toString();

    if (mapStatusToTab[ct] === "interviewed") {
      const roundKey = { 0: "ai interview", 99: "selected" };
      url =
        baseUrl +
        urlFilters
          .replaceAll("%3D", "%3A")
          .replaceAll("%26", "%2C")
          .replace("interviewed", `${roundKey[ait] || "Interviewed R" + ait}`);
    } else {
      url =
        baseUrl + urlFilters.replaceAll("%3D", "%3A").replaceAll("%26", "%2C");
    }

    const res = await axios.get(url);
    const allApplicants = res.data.data;
    const totalPages = res.data.total_page;
    const statusMap = {
      hired: "Hired",
      offer: "Offer",
      rejected: "Rejected",
      Onhold: "On-hold",
    };
    const interviewdStatusMap = {
      0: "AI Interview",
      99: "Selected",
    };

    const statusKey =
      statusMap[mapStatusToTab[ct]] ||
      interviewdStatusMap[ait] ||
      "Round " + ait;

    const statusCount =
      ct === 0 || !ct
        ? res.data.total || 0
        : res.data.status_count[statusKey] || 0;

    const currentIndex = allApplicants.findIndex((c) => c.uuid === uuid);

    const currentCandidateIndex =
      currentIndex + 1 + (filters.page - 1) * filters.page_size;

    setPageDetails({
      statusCount,
      currentCandidateIndex,
    });

    if (currentIndex !== -1) {
      if (currentIndex > 0) {
        setPrevCandidate(allApplicants[currentIndex - 1]);
        setOnPrevPage(false);
      } else if (filters.page > 1) {
        setPrevCandidate(null);
        setOnPrevPage(true);
      } else {
        setPrevCandidate(null);
        setOnPrevPage(false);
      }

      if (currentIndex < allApplicants.length - 1) {
        setNextCandidate(allApplicants[currentIndex + 1]);
        setOnNextPage(false);
      } else if (filters.page < totalPages) {
        setNextCandidate(null);
        setOnNextPage(true);
      } else {
        setNextCandidate(null);
        setOnNextPage(false);
      }
    } else {
      console.warn("Current candidate not found in this page");
      setPrevCandidate(null);
      setNextCandidate(null);
    }

    return allApplicants;
  };

  useEffect(() => {
    let currentJobId = jobid;
    if (uuid.length > 0) {
      axios
        .get(`${server_API}/v2/applicant/get/${uuid}/${companyID}`)
        .then((res) => {
          setApplicant(res.data);
          setJobid(res.data.jobid);
          currentJobId = res.data.jobid;
          setSkillArray(res.data.skillset.split(","));
          setCurrentSalary(res.data?.currentsalary);
          setExpectedSalary(res.data?.expectedsalary);
          setJoiningTime(res.data?.joiningtime);
          setCandidateDetails({
            name: res.data.name,
            email: res.data.email,
            phone: res.data.phone,
            heardaboutus: res.data.heardaboutus,
            refferre_name: res.data.refferre_name,
            employee_id: res.data.employee_id,
            agency_name: res.data.agency_name,
            expectedsalary: res.data.expectedsalary,
            currentsalary: res.data.currentsalary,
            joiningtime: res.data.joiningtime,
          });
          axios
            .get(
              `${server_API}/v2/applicant/getinterviews/${uuid}/${companyID}`,
            )
            .then((response) => {
              setInterviews([...response.data].reverse());
              setLoader(false);
            })
            .catch((err) => {
              setInterviews([]);
              setLoader(false);
            });
        })
        .then(async () => {
          await fetchApplicants(currentJobId);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [uuid]);

  const handleNextCandidate = async () => {
    if (isOnNextPage) {
      const nextPage = filters.page + 1;
      const allApplicants = await fetchApplicants(jobid, nextPage);
      console.log({ allApplicants });
      dispatch(updateCandidateFilters({ ...filters, page: nextPage }));
      navigate(location.pathname, {
        state: {
          ...location.state,
          uuid: allApplicants[0].uuid,
        },
      });
    } else if (nextCandidate) {
      navigate(location.pathname, {
        state: {
          ...location.state,
          uuid: nextCandidate.uuid,
        },
      });
    }
  };

  const handlePrevCandidate = async () => {
    if (isOnPrevPage) {
      const prevPage = filters.page - 1;
      dispatch(updateCandidateFilters({ ...filters, page: prevPage }));
      const allApplicants = await fetchApplicants(jobid, prevPage);
      console.log({ allApplicants });
      navigate(location.pathname, {
        state: {
          ...location.state,
          uuid: allApplicants[allApplicants.length - 1].uuid,
        },
      });
    } else if (prevCandidate) {
      navigate(location.pathname, {
        state: {
          ...location.state,
          uuid: prevCandidate.uuid,
        },
      });
    }
  };

  const showResume = () => {
    axios
      .get(`${server_API}/v2/applicant/geturl/${companyID}/${applicant.uuid}`)
      .then((response) => {
        window.open(response.data.url, "_blank");
      });
  };

  const fileInputRef = useRef(null);
  const [resumeUploadText, setResumeUploadText] = useState("Upload Resume");

  const submitNewResume = () => {
    fileInputRef.current.click();
  };

  const handleResumeFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append("applicantid", applicant.uuid);
      formData.append("companyid", companyID);
      formData.append("jobid", jobDetails.uuid);
      formData.append("file", file);

      setResumeUploadText("Processing Resume...");

      await axiosInstance
        .post("/v2/applicant/update/resume", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          console.log("✅ Upload successful");
          setResumeUploadText("Resume Uploaded");
          toast.success(
            "Resume has been uploaded. Revisit this page to see recalculated score and skills.",
          );
        });
    } catch (error) {
      console.error("❌ Upload failed:", error);
      setResumeUploadText("Retry Resume Upload");
      alert("Failed to upload resume!");
    }
  };

  useEffect(() => {
    if (activeIndex != null) {
      setActiveQuestion(interviews[0].chunk[activeIndex].QuestionText);
      axios
        .get(
          `${server_API}/v2/applicant/getvideo/${companyID}/${interviews[0].chunk[activeIndex].Path}`,
        )
        .then((response) => {
          console.log(response);
          setUrl(response.data.url);
          // setOpenPlayer(true);
          // console.log("openplayer",openPlayer)
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [activeIndex]);

  console.log(Object.keys(activeSalaryProposal));

  useEffect(() => {
    if (jobid?.length > 0) {
      axios
        .get(`${server_API}/v2/job/get/${jobid}/${companyID}`)
        .then((res) => {
          setAIVisible(res.data.aiinterviewenabled);
          setJobDetails(res.data);
          console.log(res.data);
          let maxSal = res.data.salaryto;
          let minSal = res.data.salaryfrom;
          maxSal = maxSal.replaceAll(",", "");
          minSal = minSal.replaceAll(",", "");
          setMaxSalary(parseInt(maxSal));
          setMinSalary(parseInt(minSal));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [applicant]);

  console.log(applicant?.expectedsalary?.split(" ")[1]?.replaceAll(",", ""));

  const options = {
    chart: {
      type: "radialBar",
    },
    grid: {
      top: 20,
    },
    series: [67],
    colors: ["rgba(0, 111, 214, 1)"],
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: "rgba(231, 244, 255, 1)",
          startAngle: -90,
          endAngle: 90,
          strokeWidth: "100%",
        },

        dataLabels: {
          name: {
            show: false,
          },
          value: {
            fontSize: "30px",
            show: false,
          },
        },
        hollow: {
          size: "42%",
        },
      },
    },

    stroke: {
      lineCap: "round",
    },
    labels: ["Progress"],
  };
  const series = [
    {
      name: "Score",
      data: [
        scores.get("ct") ?? null,
        scores.get("c") ?? null,
        scores.get("tw") ?? null,
        scores.get("gm") ?? null,
        scores.get("ls") ?? null,
      ],
    },
  ];

  const seriesoptions = {
    chart: {
      type: "radar",
      height: 200,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        barHeight: "50%",
        distributed: true,
      },
    },
    colors: ["#4FABFF"],
    dataLabels: {
      enabled: false,

      dropShadow: {
        enabled: true,
      },
    },

    xaxis: {
      categories: [
        "Critical Thinking",
        "Communication",
        "Team Work",
        "Growth Mindset",
        "Active Listening",
      ],
    },
    yaxis: {
      show: true,
      min: 0,
      max: 5,
      tickAmount: 5,
      stepSize: 1,
    },
    legend: {
      show: false,
    },
  };
  const radarData = useMemo(() => {
    const getScore = (cat) => {
      const chunk = interviews[0]?.chunk?.find((c) => c.Category === cat);
      if (!chunk) return 0;
      const score = chunk.Status === "Completed" ? chunk.MLNumericScore : chunk.BiLSTMScore || chunk.GorgoniaMLNumericScore;
      return score ?? 0;
    };
    return {
      labels: ["Critical Thinking", "Growth Mindset", "Communication", "Teamwork", "Active Listening"],
      datasets: [{
        data: [getScore("ct"), getScore("gm"), getScore("c"), getScore("tw"), getScore("ls")],
        backgroundColor: "rgba(99, 102, 241, 0.25)",
        borderColor: "rgba(99, 102, 241, 0.85)",
        borderWidth: 2,
        pointBackgroundColor: "rgba(99, 102, 241, 1)",
        pointBorderColor: "#fff",
        pointRadius: 4,
      }],
    };
  }, [interviews]);

  const radarChartOptions = {
    layout: { padding: { top: 16, bottom: 16, left: 70, right: 70 } },
    scales: {
      r: {
        angleLines: { display: true, color: "#e2e8f0" },
        grid: { circular: true, color: "#e2e8f0" },
        pointLabels: { font: { size: 12, weight: "600" }, color: "#1e293b", padding: 6 },
        ticks: { backdropColor: "transparent", stepSize: 1, max: 5, min: 0, color: "#94a3b8", font: { size: 10 } },
        min: 0,
        max: 5,
      },
    },
    plugins: { legend: { display: false }, tooltip: { enabled: false } },
    maintainAspectRatio: false,
  };
  const isPendingAI = applicant?.status === "Pending" && jobDetails?.aiinterviewenabled;

  function Progressbar({ progress }) {
    return (
      <div className="flex flex-col items-center w-full">
        <div
          className="relative w-full h-[2rem]  rounded-full overflow-hidden"
          style={{
            // border: "2px solid rgba(210, 212, 218, 1)",
            backgroundColor: "#E7F4FF",
          }}
        >
          <div
            style={{ width: `${progress}%` }}
            className="h-full bg-[#006FD6] transition-width duration-500 rounded-full"
          ></div>
        </div>
      </div>
    );
  }
  const patchStatus = (id, status) => {
    axios
      .patch(`${server_API}/v2/applicant/update`, {
        companyid: companyID,
        uuid: id,
        status: status,
      })
      .then((res) => {
        window.location.reload();
        console.log(res);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getVideoUrl = (path, ques) => {
    setActiveQuestion(ques);
    axios
      .get(`${server_API}/v2/applicant/getvideo/${companyID}/${path}`)
      .then((response) => {
        console.log(response);
        setUrl(response.data.url);
        setOpenPlayer(true);
      })

      .catch((err) => {
        console.log(err);
      });
  };

  const Swipe = () => {
    return (
      <div className="w-full">
        {interviews.length > 0 ? (
          <div className="w-[80rem]">
            <Swiper
              modules={[Navigation, A11y]}
              spaceBetween={60}
              slidesPerView={4}
              navigation
            >
              {interviews[0].chunk.map((c, i) => {
                let borderColor = "border-slate-300";
                if (c.CheatPercent > 50 && c.CheatPercent <= 70)
                  borderColor = "border-yellow-500";
                if (c.CheatPercent > 70) borderColor = "border-red-600";

                return (
                  <SwiperSlide key={i}>
                    <div
                      onClick={() => {
                        getVideoUrl(c.Path, c.QuestionText);
                        setActiveIndex(i);
                      }}
                      className={`cursor-pointer flex flex-col items-start p-4 rounded-lg relative h-full border-2 ${borderColor} gap-3`}
                    >
                      {/* Cheat flag header */}
                      {c.CheatPercent > 50 && (
                        <div className="absolute top-2 left-2 z-20 flex items-center gap-2 bg-white/90 px-2 py-1 rounded-md shadow-md">
                          <img src={cheatflag} alt="flag" className="h-4 w-4" />
                          <span className="text-xs font-medium text-red-600">
                            Inappropriate help suspected
                          </span>
                        </div>
                      )}

                      {/* Thumbnail */}
                      <div className="relative flex-shrink-0 w-full z-10">
                        <img
                          src={frame}
                          className="rounded-lg w-full object-cover"
                          alt="frame"
                        />
                        <img
                          src={frame1}
                          className="rounded-lg h-10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 hover:scale-125 transition-all"
                          alt="frame1"
                        />
                      </div>

                      {/* Progress Bar */}
                      {c.CheatPercent > 50 && (
                        <div className="w-full relative mt-2">
                          {/* Gradient zones */}
                          <div className="h-2 rounded-full overflow-hidden bg-gradient-to-r from-green-500 via-yellow-500 to-red-600" />

                          {/* Indicator line */}
                          <div
                            className="absolute -top-2 w-[2px] h-6 bg-gray-600 rounded-sm"
                            style={{ left: `calc(${c.CheatPercent}% - 1px)` }}
                          />

                          {/* Percent Label */}
                          <div
                            className="absolute -top-6 text-xs font-semibold text-gray-600 whitespace-nowrap group"
                            style={{
                              left: `calc(${Math.min(Math.max(c.CheatPercent, 5), 95)}% - 12px)`,
                            }}
                          >
                            {/* Percentage text */}
                            <span className="cursor-pointer">
                              {c.CheatPercent}%
                            </span>

                            {/* Tooltip */}
                            <div className="absolute text-gray-400 transition-all left-1/2 -translate-x-1/2 top-6 text-left p-1 z-50 border border-gray-300 scale-0 rounded-lg bg-white w-32 shadow-md text-[0.7rem] group-hover:scale-100 break-words leading-normal">
                              Away from the screen
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Question Text */}
                      <p className="leading-tight text-sm font-normal text-left flex-grow mt-2">
                        Q{i + 1}. {c.QuestionText}
                      </p>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        ) : (
          <div className="px-4 font-normal  text-left">
            The candidate has not given any interviews yet.
          </div>
        )}
      </div>
    );
  };
  const CandidateSummary = () => {
    return (
      <div className="flex-1 overflow-auto summarypage p-4 m-4 rounded-xl  bg-white">
        <div className="flex items-center ">
          <div>
            <div className="flex gap-4 mb-2 ">
              <h2 className="text-2xl font-semibold flex items-center">
                {applicant.name}
              </h2>
              <span className="text-lg font-semibold flex items-center">
                {" "}
                | &nbsp;{jobDetails.profilename}
              </span>
              {/* <span className="inline-block bg-light-green border border-[#40B2B7] text-[#40B2B7] px-2 py-1 text-sm font-medium rounded-md">
                High Match
              </span> */}
            </div>
            <p className="text-base font-normal mb-2">
              <span className=" font-medium">Email: </span>
              <a className="text-blue-400" href="mailto:recipient@example.com">
                {applicant.email}
              </a>
              &nbsp; | &nbsp; <span className=" font-medium">Phone: </span>{" "}
              {getPhoneCode(companyCountryCode)}&nbsp;
              {applicant.phone} &nbsp; |&nbsp;{" "}
              <span className=" font-medium">Location: </span>
              {applicant.address}&nbsp;
            </p>
            <p className="text-base font-normal">
              <span className=" font-medium">Education: </span>
              {applicant.highestqualification}
              <span className=" font-medium">Total Experience: </span>
              {applicant.totalexperience}
            </p>
          </div>
        </div>

        <div className=" w-full mt-6 ">
          <h2 className="font-semibold mt-1 relative mb-2 ">Skills</h2>

          <div className="flex flex-wrap gap-2 ">
            {skillArray?.map((skills, index) => (
              <span className="bg-[#f0f4fc] border-2 border-slate-300 font-semibold px-3 py-1 rounded-lg">
                {skills}
              </span>
            ))}
          </div>
        </div>

        {/* before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2 */}

        <div className=" w-full mt-6 flex gap-4  ">
          <div className="w-1/2">
            <h2 className="font-semibold relative mb-2 mt-1 text-base ">
              Annual Salary
            </h2>
            <div className="flex gap-4">
              <h3 className="text-slate-600 text-[14px] font-medium  pl-4 rounded-lg p-2 mb-2 border-2 border-slate-300 flex justify-between  relative  mt-1   before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-1/3 before:mr-4 before:transform before:-translate-y-1/2">
                Current Salary:
                <span className=" font-semibold text-black ml-2">
                  {getCurrencySymbol(companyCountryCode)}
                  {formatSalary(applicant.currentsalary, companyCountryCode)}
                </span>
              </h3>
              <h3 className="text-slate-600  text-[14px] p-2  pl-4 mb-2 font-medium rounded-lg border-2 flex justify-between  relative  mt-1   before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-1/3 before:mr-4 before:transform before:-translate-y-1/2">
                Expected Salary:
                <span className=" font-semibold text-black ml-2">
                  {getCurrencySymbol(companyCountryCode)}
                  {formatSalary(applicant.expectedsalary, companyCountryCode)}
                </span>{" "}
              </h3>
            </div>
          </div>
          <div className="w-1/2">
            <div className=" w-full  ">
              <h2 className="font-semibold relative mb-2 mt-1   ">
                Time to Join
              </h2>

              <h3 className="text-slate-600 font-medium text-[14px]   pl-4 rounded-lg p-2 mb-2 border-2 border-slate-300 flex justify-between  relative  mt-1   before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-1/3 before:mr-4 before:transform before:-translate-y-1/2">
                Approximate time to join:
                <span className=" font-semibold text-black ml-2">2 Weeks</span>
              </h3>
            </div>
          </div>
        </div>

        <div className=" w-full mt-6  ">
          <h2 className="font-semibold relative mb-2 mt-1   ">
            Candidate Evaluation
          </h2>

          <div className="bg-white border-2 border-slate-300 rounded-xl mt-6">
            <div className="w-full">
              <h2 className="font-semibold w-full pl-4 bg-[#f0f4fc] rounded-t-xl relative text-xl p-2 before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-1/3 before:mr-4 before:transform before:-translate-y-1/2">
                AI Interview
              </h2>
              <hr className="border-[#E9EBFA]" />
              <div className="px-4 pb-4 pt-3">
                {/* Top row */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                  <div className={isPendingAI ? "opacity-50 cursor-not-allowed" : ""}>
                    <p className="text-sm font-semibold text-gray-700 mb-1.5">Aggregate AI Score : <span className="text-[#148EFF]">{applicant.aggregate}</span></p>
                    <div className="w-full h-1.5 bg-[#E7F4FF] rounded-full"><div className="h-full bg-[#006FD6] rounded-full" style={{ width: `${applicant.aggregate || 0}%` }} /></div>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-700 mb-1.5">Resume Score : <span className="text-[#148EFF]">{applicant?.resumescore == -1 ? "N/A" : applicant?.resumescore}</span></p>
                    <div className="w-full h-1.5 bg-[#E7F4FF] rounded-full"><div className="h-full bg-[#006FD6] rounded-full" style={{ width: `${applicant?.resumescore > 0 ? applicant.resumescore : 0}%` }} /></div>
                  </div>
                  <div className={isPendingAI ? "opacity-50 cursor-not-allowed" : ""}>
                    <p className="text-sm font-semibold text-gray-700 mb-1.5">Voice Score : <span className="text-[#148EFF]">{applicant?.voiceanalysisscore}</span></p>
                    <div className="w-full h-1.5 bg-[#E7F4FF] rounded-full"><div className="h-full bg-[#006FD6] rounded-full" style={{ width: `${applicant?.voiceanalysisscore || 0}%` }} /></div>
                  </div>
                </div>
                {/* Bottom row — compact cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div
                    className={`border rounded-xl transition-all duration-200 ${isPendingAI ? "cursor-not-allowed opacity-50" : "cursor-pointer"} ${isTechExpanded ? "border-blue-400 shadow-sm" : "border-gray-200"}`}
                    onClick={isPendingAI ? undefined : (e) => { e.stopPropagation(); setIsTechExpanded(p => !p); setIsEmpExpanded(false); }}
                  >
                    <div className="flex justify-between items-center p-3">
                      <div className="flex-1 pr-4">
                        <p className={`text-sm font-semibold mb-1.5 ${isTechExpanded ? "text-gray-900" : isEmpExpanded ? "text-gray-400" : "text-gray-700"}`}>Technical Score : <span className="text-[#148EFF]">{applicant?.technicalscore}</span></p>
                        <div className="w-full h-1.5 bg-[#E7F4FF] rounded-full"><div className="h-full bg-[#006FD6] rounded-full" style={{ width: `${applicant?.technicalscore || 0}%` }} /></div>
                      </div>
                      {!isPendingAI && (isTechExpanded ? <IoIosArrowUp className="text-gray-500 flex-shrink-0" /> : <IoIosArrowDown className="text-gray-500 flex-shrink-0" />)}
                    </div>
                  </div>
                  <div
                    className={`border rounded-xl transition-all duration-200 ${isPendingAI ? "cursor-not-allowed opacity-50" : "cursor-pointer"} ${isEmpExpanded ? "border-blue-400 shadow-sm" : "border-gray-200"}`}
                    onClick={isPendingAI ? undefined : (e) => { e.stopPropagation(); setIsEmpExpanded(p => !p); setIsTechExpanded(false); }}
                  >
                    <div className="flex justify-between items-center p-3">
                      <div className="flex-1 pr-4">
                        <p className={`text-sm font-semibold mb-1.5 ${isEmpExpanded ? "text-gray-900" : isTechExpanded ? "text-gray-400" : "text-gray-700"}`}>Employability Score : <span className="text-[#148EFF]">{applicant?.aiscore}</span></p>
                        <div className="w-full h-1.5 bg-[#E7F4FF] rounded-full"><div className="h-full bg-[#006FD6] rounded-full" style={{ width: `${applicant?.aiscore || 0}%` }} /></div>
                      </div>
                      {!isPendingAI && (isEmpExpanded ? <IoIosArrowUp className="text-gray-500 flex-shrink-0" /> : <IoIosArrowDown className="text-gray-500 flex-shrink-0" />)}
                    </div>
                  </div>
                </div>
                {/* Expanded content — below both cards */}
                {isTechExpanded && !isPendingAI && (
                  <div className="mt-4 border-t border-slate-200">
                    <div className="p-4">
                      <p className="text-sm font-semibold text-gray-700 mb-2">Summary</p>
                      {applicant?.technical_summary ? (
                        <div
                          className="text-sm text-gray-600 leading-relaxed ai-summary-html"
                          dangerouslySetInnerHTML={sanitizeHTML(applicant?.technical_summary)}
                        />
                      ) : (
                        <p className="text-sm text-gray-400">Interview summary is unavailable for this candidate.</p>
                      )}
                    </div>
                  </div>
                )}
                {isEmpExpanded && !isPendingAI && (
                  <div className="mt-4 border-t border-slate-200">
                    {interviews.length === 0 ? (
                      <p className="text-sm text-gray-500 text-center py-6">Interview summary is unavailable for this candidate</p>
                    ) : (
                      <div style={{ display: "grid", gridTemplateColumns: "minmax(0,3fr) 1px minmax(0,2fr)" }}>
                        <div style={{ padding: "16px 8px 16px 16px", height: 420 }}>
                          <Radar data={radarData} options={radarChartOptions} />
                        </div>
                        <div style={{ background: "#e2e8f0", margin: "16px 0" }} />
                        <div style={{ padding: "20px 20px 20px 24px", display: "flex", flexDirection: "column", gap: 8, overflowY: "auto" }}>
                          <p style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 4 }}>Summary</p>
                          {applicant?.employability_summary ? (
                            <div
                              className="ai-summary-html"
                              style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.6 }}
                              dangerouslySetInnerHTML={sanitizeHTML(applicant?.employability_summary)}
                            />
                          ) : (
                            <p style={{ fontSize: 13, color: "#9ca3af", lineHeight: 1.6 }}>Interview summary is unavailable for this candidate.</p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleFileChange = (event) => {
    setSelectedFiles(event.target.files);
  };

  const handleUpload = async () => {
    const formData = new FormData();
    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append("files", selectedFiles[i]);
    }
  };
  if (Object.keys(applicant).length > 0)
    return (
      <>
        {latestSProposalUuid &&
          allOfferLetter.length == 0 &&
          tab == "candidate" && (
            <div className="bg-[#FFD9B2] gap-[6px] text-[#161A21] px-6 py-4  flex  items-center text-[14px] font-medium">
              <p>
                Your submitted Salary Proposal has been approved by hiring
                manager. Please create the Offer Letter.
              </p>
              <p
                onClick={() => {
                  if (userPrivilege !== "Hiring Manager") {
                    setProposalFromLatest(latestSalaryProposal);
                    setTab("offerletter");
                    statusUpdate("Offer Letter In-progress", "offerletter");
                  }
                }}
                className={`${userPrivilege === "Hiring Manager"
                  ? "text-gray-400 cursor-not-allowed"
                  : "text-[#148EFF] cursor-pointer"
                  }`}
              >
                Create Offer Letter
              </p>
            </div>
          )}
        <div className="p-6 pb-0 bg-[#f0f4fc]  min-h-screen    ">
          {tab == "candidate" && (
            <div>
              {openSummary && (
                <div className="fixed py-12    bg-black bg-opacity-60  p-4 h-screen w-screen text-white flex items-center justify-center  top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
                  <div className="w-[80%] h-full flex flex-col bg-[#f0f4fc] rounded-xl border-2 border-slate-500 text-black">
                    {/* Top div */}
                    <div className="flex p-4 bg-white items-center justify-between rounded-t-xl">
                      <h1 className="text-2xl font-semibold">
                        Candidate Overview
                      </h1>
                      <RxCross2
                        className="self-start text-3xl cursor-pointer z-50"
                        onClick={() => {
                          setOpenSummary(false);
                        }}
                      ></RxCross2>
                    </div>

                    {/* Middle div with scrolling */}
                    <CandidateSummary />

                    {/* Bottom div */}
                    <div className="flex p-4 bg-white items-center justify-end rounded-b-xl">
                      <button className="bg-[#148EFF] whitespace-nowrap text-white py-2 px-4 w-fit rounded-lg">
                        Download Now
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {candidateEdit && (
                <EditCandidateModal
                  openModal={setCandidateEdit}
                  handleSave={handleCandidateUpdate}
                  initialData={candidateDetails}
                  setInitialData={setCandidateDetails}
                />
              )}
              {isSalaryProposalModalOpen &&
                Object.keys(activeSalaryProposal).length > 0 && (
                  <div className="fixed py-12 bg-black bg-opacity-60  p-4 h-screen w-screen text-white flex items-center justify-center  top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50">
                    <div className="w-1/2 h-full overflow-y-scroll flex flex-col bg-[#f0f4fc] rounded-lg border-2 border-slate-500 text-black">
                      <div className=" rounded-tr-lg ">
                        <div className="p-6 pt-[20px] bg-[#F1F4FB] h-full flex flex-col    text-[12px]">
                          <div className="flex justify-between">
                            <h2 className="text-[14px] font-semibold mb-2">
                              Salary Proposal
                            </h2>
                            <img
                              src={cross}
                              onClick={() => {
                                setIsSalaryProposalModalOpen(false);
                              }}
                              className="h-4 cursor-pointer"
                            ></img>
                          </div>

                          <div className="bg-white p-[12px] flex-1  pb-0 border border-[#D2D4DA] rounded-[8px]">
                            <div className="p-1">
                              <div className="mb-[6px] text-[#444D63] ">
                                <p className="mb-1"> Candidates Details:</p>

                                <ul className="small-bullets list-disc pl-5">
                                  <li>
                                    Name:{" "}
                                    {applicant.name
                                      ? applicant.name
                                      : "[Candidate Name]"}
                                  </li>
                                  <li>
                                    Position:{" "}
                                    {jobDetails.profilename
                                      ? jobDetails.profilename
                                      : "[Job Title]"}
                                  </li>
                                </ul>
                              </div>
                              <div className="p-[6px] mb-[6px] pb-[12px]">
                                <p className="mb-[6px] font-medium">
                                  Salary Distribution
                                </p>
                                {companyDetails?.from_acfl ? (
                                  <div className="p-4 grid grid-cols-2 gap-x-8 gap-y-4 bg-gray-50/30 border border-[#D2D4DA] rounded-lg">
                                    {acflFields.map((field, idx) => {
                                      if (
                                        field.visible &&
                                        !field.visible(activeSalaryProposal)
                                      )
                                        return null;
                                      return (
                                        <div
                                          key={idx}
                                          className={`${field.fullWidth
                                            ? "col-span-2"
                                            : "col-span-1"
                                            } flex flex-col`}
                                        >
                                          <label className="text-[12px] font-bold mb-1 uppercase text-gray-700">
                                            {field.label}
                                          </label>
                                          <div
                                            className={`flex items-center border border-[#D2D4DA] rounded p-2 mt-0.5 shadow-sm transition-all ${field.highlight
                                              ? "bg-[#FFFF00] border-yellow-400"
                                              : "bg-white"
                                              }`}
                                          >
                                            {field.prefix && (
                                              <span className="mr-1 font-semibold text-gray-600">
                                                {field.prefix}
                                              </span>
                                            )}
                                            <div className="w-full bg-transparent outline-none text-[14px] font-medium py-1">
                                              {activeSalaryProposal[
                                                field.name
                                              ] || "-"}
                                            </div>
                                            {field.suffix && (
                                              <span className="ml-1 font-semibold text-gray-600">
                                                {field.suffix}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                ) : (
                                  <Table className="w-full border border-[#D2D4DA]">
                                    <Thead>
                                      <Tr>
                                        <Th className="w-1/3 p-[12px] border"></Th>
                                        <Th className="w-1/3 p-[12px] border">
                                          Current Salary
                                        </Th>
                                        <Th className="w-1/3 p-[12px] border">
                                          Proposed Salary
                                        </Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      <Tr>
                                        <Td className="p-[12px] border">
                                          Total Fixed Pay
                                        </Td>
                                        <Td className="p-[12px] border text-right">
                                          {renderValue(
                                            activeSalaryProposal[
                                            "totalfixedpay"
                                            ]["current"],
                                          )}
                                        </Td>
                                        <Td className="p-[12px] border text-right">
                                          {renderValue(
                                            activeSalaryProposal[
                                            "totalfixedpay"
                                            ]["proposed"],
                                          )}
                                        </Td>
                                      </Tr>
                                      {
                                        companyDetails?.salaryDetail ?
                                          <>
                                            <Tr>
                                              <Td className="p-[12px] border">
                                                Medical/Life Insurance Premium
                                              </Td>
                                              <Td className="p-[12px] border text-right">
                                                {renderValue(
                                                  activeSalaryProposal[
                                                  "medicallifeinsurance"
                                                  ]["current"],
                                                )}
                                              </Td>
                                              <Td className="p-[12px] border text-right">
                                                {renderValue(
                                                  activeSalaryProposal[
                                                  "medicallifeinsurance"
                                                  ]["proposed"],
                                                )}
                                              </Td>
                                            </Tr>
                                            <Tr>
                                              <Td className="p-[12px] border">
                                                Joining/Relocation Bonus
                                              </Td>
                                              <Td className="p-[12px] border text-right">
                                                {renderValue(
                                                  activeSalaryProposal[
                                                  "relocationbonus"
                                                  ]["current"],
                                                )}
                                              </Td>
                                              <Td className="p-[12px] border text-right">
                                                {renderValue(
                                                  activeSalaryProposal[
                                                  "relocationbonus"
                                                  ]["proposed"],
                                                )}
                                              </Td>
                                            </Tr>
                                            <Tr>
                                              <Td className="p-[12px] border">
                                                ⁠⁠Performance/Sprint Bonus
                                              </Td>
                                              <Td className="p-[12px] border text-right">
                                                {renderValue(
                                                  activeSalaryProposal[
                                                  "sprintbonus"
                                                  ]["current"],
                                                )}
                                              </Td>
                                              <Td className="p-[12px] border text-right">
                                                {renderValue(
                                                  activeSalaryProposal[
                                                  "sprintbonus"
                                                  ]["proposed"],
                                                )}
                                              </Td>
                                            </Tr>
                                          </>

                                          :
                                          <>
                                            <Tr>
                                              <Td className="p-[9px] border">
                                                Variable Pay
                                              </Td>
                                              <Td className="p-[9px] border text-right">
                                                {renderValue(activeSalaryProposal?.variablepay.current)}
                                              </Td>
                                              <Td className="p-[9px] border text-right">
                                                {renderValue(activeSalaryProposal?.variablepay.proposed)}
                                              </Td>
                                            </Tr>
                                            <Tr>
                                              <Td className="p-[9px] border">ESOP</Td>
                                              <Td className="p-[9px] border text-right">
                                                {renderValue(activeSalaryProposal?.esop.current)}
                                              </Td>
                                              <Td className="p-[9px] border text-right">
                                                {renderValue(activeSalaryProposal?.esop.proposed)}
                                              </Td>
                                            </Tr>
                                            <Tr>
                                              <Td className="p-[9px] border">
                                                ESOP Value
                                              </Td>
                                              <Td className="p-[9px] border text-right">
                                                {renderValue(activeSalaryProposal?.esopvalue.current)}
                                              </Td>
                                              <Td className="p-[9px] border text-right">
                                                {renderValue(activeSalaryProposal?.esopvalue.proposed)}
                                              </Td>
                                            </Tr>
                                          </>
                                      }

                                      <Tr>
                                        <Td className="p-[12px] border">-</Td>
                                        <Td className="p-[12px] border text-right">
                                          -
                                        </Td>
                                        <Td className="p-[12px] border text-right">
                                          -
                                        </Td>
                                      </Tr>

                                      <Tr className="font-bold">
                                        <Td className="p-[12px] border">
                                          {companyDetails?.salaryDetail
                                            ? "CTC"
                                            : "Total Compensation"}
                                        </Td>
                                        <Td className="p-[12px] border text-right">
                                          {renderValue(
                                            parseFloat(
                                              activeSalaryProposal
                                                ?.totalfixedpay?.current || 0,
                                            ) +
                                            parseFloat(
                                              companyDetails?.salaryDetail
                                                ? parseNumber(
                                                  activeSalaryProposal
                                                    ?.medicallifeinsurance
                                                    ?.current || 0,
                                                ) +
                                                parseNumber(
                                                  activeSalaryProposal
                                                    ?.relocationbonus
                                                    ?.current || 0,
                                                ) +
                                                parseNumber(
                                                  activeSalaryProposal
                                                    ?.sprintbonus
                                                    ?.current || 0,
                                                )
                                                : parseNumber(
                                                  activeSalaryProposal
                                                    ?.variablepay
                                                    ?.current || 0,
                                                ) +
                                                parseNumber(
                                                  activeSalaryProposal
                                                    ?.esopvalue
                                                    ?.current || 0,
                                                ),
                                            ),
                                          )}
                                        </Td>
                                        <Td className="p-[12px] border text-right">
                                          {renderValue(
                                            parseFloat(
                                              activeSalaryProposal
                                                ?.totalfixedpay?.proposed || 0,
                                            ) +
                                            parseFloat(
                                              companyDetails?.salaryDetail
                                                ? parseNumber(
                                                  activeSalaryProposal
                                                    ?.medicallifeinsurance
                                                    ?.proposed || 0,
                                                ) +
                                                parseNumber(
                                                  activeSalaryProposal
                                                    ?.relocationbonus
                                                    ?.proposed || 0,
                                                ) +
                                                parseNumber(
                                                  activeSalaryProposal
                                                    ?.sprintbonus
                                                    ?.proposed || 0,
                                                )
                                                : parseNumber(
                                                  activeSalaryProposal
                                                    ?.variablepay
                                                    ?.proposed || 0,
                                                ) +
                                                parseNumber(
                                                  activeSalaryProposal
                                                    ?.esopvalue
                                                    ?.proposed || 0,
                                                ),
                                            ),
                                          )}
                                        </Td>
                                      </Tr>

                                      <Tr>
                                        <Td className="p-[12px] border">
                                          %
                                          {companyDetails?.salaryDetail
                                            ? " increase on Total Fixed Pay"
                                            : " increase on CTC"}
                                        </Td>
                                        <Td className="p-[12px] border text-right">
                                          {renderValue("")}
                                        </Td>
                                        <Td className="p-[12px] border text-right">
                                          {renderValue(
                                            activeSalaryProposalCtc(),
                                          )}
                                        </Td>
                                      </Tr>

                                      <Tr>
                                        <Td className="p-[12px] border">
                                          %{" "}
                                          {companyDetails?.salaryDetail
                                            ? "increase on CTC"
                                            : "increase on TC"}
                                        </Td>
                                        <Td className="p-[12px] border text-right">
                                          {renderValue("")}
                                        </Td>
                                        <Td className="p-[12px] border text-right">
                                          {renderValue(
                                            activeSalaryProposalTc(),
                                          )}
                                        </Td>
                                      </Tr>
                                    </Tbody>
                                  </Table>
                                )}
                              </div>
                              <div className="text-[#444D63]">
                                <p className="mb-1"> Justification:</p>

                                <ul className="small-bullets list-disc pl-5">
                                  <li>{activeSalaryProposal?.justification}</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="bg-white p-4 mt-5">
                          <div className="flex justify-between">
                            <div className="flex gap-4 ">
                              <div
                                onClick={() => {
                                  // updateDocumentStatus(activeDocId,"Rejected");
                                  setTab("candidate");
                                  updateSalaryProposalStatus("Rejected");
                                  removeNotification();
                                  navigate("/jobs/candidates/about", {
                                    state: { uuid: uuid },
                                  });
                                  toast.error(
                                    "Salary proposal has been rejected ",
                                    { icon: <ToastIcon /> },
                                  );
                                }}
                              >
                                <ButtonHollowXs text="#F7284A" color="#FFFFFF">
                                  <CloseIcon /> Reject
                                </ButtonHollowXs>
                              </div>
                              <div
                                onClick={() => {
                                  setConfirmationModal("");
                                  setTab("candidate");
                                  // updateDocumentStatus(activeDocId, "Verified");
                                  removeNotification();
                                  updateSalaryProposalStatus("Approved");
                                  statusUpdate("Salary Proposal Approved");
                                  navigate("/jobs/candidates/about", {
                                    state: { uuid: uuid },
                                  });
                                  toast.success(
                                    "Salary proposal has been verified successfully ",
                                    { icon: <ToastIcon /> },
                                  );
                                }}
                              >
                                <ButtonXs color="#0DCD94" text="#FFFFFF">
                                  <TickIcon />
                                  Verify
                                </ButtonXs>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {openPlayer && (
                <div className="fixed   bg-black bg-opacity-60 backdrop-blur-lg p-4 h-screen w-screen text-white flex items-center justify-center  top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50">
                  <RxCross2
                    className="self-start text-3xl cursor-pointer z-90"
                    onClick={() => {
                      setOpenPlayer(false);
                    }}
                  ></RxCross2>
                  <div className="w-full h-[85%] px-4">
                    <p className="text-lg my-2 text-center">
                      Q{activeIndex + 1}. {activeQuestion}
                    </p>
                    {followUpAlert.visible && (
                      <div
                        className={`absolute transition-all duration-1000 ease-in-out bg-black/80 text-white p-4 rounded-xl text-center z-50 max-w-[80%] border border-[#148EFF] shadow-lg backdrop-blur-sm
                            ${followUpAlert.position === "center" ? "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-2xl" : "top-[10%] left-1/2 -translate-x-1/2 text-lg"}
                        `}
                      >
                        <p className="font-semibold text-[#148EFF] mb-2 uppercase text-sm tracking-widest">
                          Follow-up Question
                        </p>
                        {followUpAlert.text}
                      </div>
                    )}
                    <div className="flex w-full h-full justify-between items-center">
                      <button
                        onClick={() => {
                          setActiveIndex((prev) => prev - 1);
                        }}
                        disabled={activeIndex == 0}
                        className={
                          !(activeIndex == 0)
                            ? "bg-cyan-600 text-2xl text-white p-4 rounded-full"
                            : "bg-cyan-600 text-2xl text-white p-4 rounded-full opacity-50"
                        }
                      >
                        <MdOutlineNavigateNext className="rotate-180"></MdOutlineNavigateNext>
                      </button>
                      <CustomVideoPlayer
                        ref={videoRef}
                        src={url}
                        autoPlay={true}
                        title={activeQuestion}
                        onTimeUpdate={handleTimeUpdate}
                        markers={[
                          {
                            time: parseFloat(
                              interviews[0]?.chunk?.[activeIndex]
                                ?.FollowUpTimeOffset || 0,
                            ),
                            label:
                              interviews[0]?.chunk?.[activeIndex]
                                ?.FollowupQuestion || "Follow Up",
                          },
                        ]}
                      />
                      <button
                        className={
                          !(interviews[0]?.chunk?.length == activeIndex + 1)
                            ? "bg-cyan-600 text-2xl text-white p-4 rounded-full"
                            : "bg-cyan-600 text-2xl text-white p-4 rounded-full opacity-50"
                        }
                        disabled={interviews[0]?.chunk?.length == activeIndex + 1}
                        onClick={() => {
                          setActiveIndex((prev) => prev + 1);
                        }}
                      >
                        <MdOutlineNavigateNext></MdOutlineNavigateNext>
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="flex  justify-between items-center">
                <div className="flex  items-center ">
                  <img
                    onClick={() => {
                      navigate("/jobs/candidates/temp", {
                        state: { id: jobid },
                      });
                    }}
                    src={arrowleft}
                    className="w-[40px] cursor-pointer h-[40px] mr-4"
                    alt="back button"
                  />

                  <h1 className="text-[28px] font-medium">
                    Candidate Overview
                  </h1>
                </div>

                <div className="flex justify-center items-center gap-4 ">
                  <div className="flex gap-4 justify-center items-center">
                    <Tooltip tooltip="Previous Candidate">
                      <button
                        onClick={handlePrevCandidate}
                        disabled={!prevCandidate && !isOnPrevPage}
                        className="text-2xl text-gray-300 p-1 rounded-xl disabled:opacity-20"
                      >
                        <FaChevronLeft className="fill-black" />
                      </button>
                    </Tooltip>

                    <div>
                      <p className="text-sm font-medium text-gray-600">
                        {pageDetails.currentCandidateIndex} of{" "}
                        {pageDetails.statusCount}
                      </p>
                    </div>

                    <Tooltip tooltip="Next Candidate">
                      <button
                        onClick={handleNextCandidate}
                        disabled={!nextCandidate && !isOnNextPage}
                        className="text-2xl text-gray-300 p-1 rounded-xl disabled:opacity-20"
                      >
                        <FaChevronRight className="fill-black" />
                      </button>
                    </Tooltip>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between bg-white shadow-md  p-4 rounded-xl mt-8">
                <div className="flex items-center w-full  ">
                  {/* <img
              src="https://placehold.co/100"
              alt="Avatar"
              className="rounded-xl mr-4 border-2 border-slate-300"
            /> */}
                  <div className="w-[90%]">
                    <div className="flex gap-4 mb-2 items-center ">
                      <h2 className="text-[20px] font-medium flex items-center">
                        {applicant.name}
                      </h2>
                      <span className="text-[14px] font-medium flex items-center">
                        | &nbsp;{jobDetails.profilename}
                      </span>

                      <div className="relative ">
                        <div
                          className={
                            "p-px px-1 h-fit border border-gray-600 bg-[#D9D9D9] font-bold text-gray-600 text-xs rounded-lg"
                          }
                        >
                          <div className="flex items-center justify-between">
                            {applicant.status === "Pending"
                              ? jobDetails.aiinterviewenabled
                                ? "Pending AI Interview"
                                : "Pending"
                              : applicant.status === "Interviewed"
                                ? "AI Interview"
                                : applicant.status === "Selected"
                                  ? "Selected"
                                  : applicant.status === "Rejected"
                                    ? "Rejected"
                                    : applicant.status === "Onhold"
                                      ? "On-hold"
                                      : applicant.status?.includes(
                                        "Interviewed R",
                                      )
                                        ? "Round " +
                                        applicant.status.split("R")[1]
                                        : `${applicant.status}`}

                            {/* <img
                          src={arrow}
                          className={
                            !open
                              ? "-rotate-90 ml-4 h-2"
                              : "-rotate-270 ml-4 h-2"
                          }
                        ></img> */}
                          </div>
                        </div>
                      </div>
                      {/* <span className="inline-block bg-light-green border border-[#40B2B7] text-[#40B2B7] px-2 py-1 text-sm font-medium rounded-md">
                  High Match
                </span> */}
                    </div>

                    <div className="w-full mt-3">
                      <div className="flex gap-4 justify-start">
                        <p className="text-base  font-normal mb-1 w-1/2">
                          <span className=" font-medium">Email: </span>
                          <a
                            className="text-blue-400"
                            href="mailto:recipient@example.com"
                          >
                            {applicant.email}
                          </a>
                          &nbsp; | &nbsp;
                          <>
                            <span className=" font-medium">Phone: </span>{" "}
                            {getPhoneCode(companyCountryCode)} {applicant.phone}{" "}
                            &nbsp;
                            {applicant?.address?.length > 10 && (
                              <span>
                                <span className=" font-medium">Location: </span>
                                {applicant?.address?.split(",")[3]}, India
                              </span>
                            )}
                          </>
                        </p>
                        <p className="text-base  font-normal mb-1">
                          <span className=" font-medium">
                            Total Experience:{" "}
                          </span>
                          {applicant.totalexperience}
                        </p>
                      </div>
                      <p className=" flex items-baseline gap-4 text-base justify-start font-normal">
                        <p className="mb-1 font-medium w-1/2">
                          Education: {applicant.qualification}
                        </p>
                        <p className="text-base  font-normal mb-1 flex gap-2 items-center mt-2">
                          <span className=" font-medium">
                            Source:{" "}
                            {applicant.heardaboutus &&
                              /^northstarz(\.ai)?$/i.test(applicant.heardaboutus)
                              ? "Northstarz"
                              : applicant.heardaboutus}
                          </span>
                          {applicant.heardaboutus === "Employees referral" ? (
                            <span className="font-medium flex">
                              &nbsp; | &nbsp; Referred By:{" "}
                              <Tooltip tooltip={applicant.refferre_name}>
                                {" "}
                                <span className="text-ellipsis max-w-[200px] line-clamp-1">
                                  {applicant.refferre_name}
                                </span>{" "}
                              </Tooltip>
                            </span>
                          ) : applicant.heardaboutus ===
                            "Recruitment agency" ? (
                            <span className="font-medium flex">
                              &nbsp; | &nbsp; Agency Name:&nbsp;
                              <Tooltip tooltip={applicant.agency_name}>
                                {" "}
                                <span className="text-ellipsis max-w-[120px] line-clamp-1 ">
                                  {applicant.agency_name}
                                </span>{" "}
                              </Tooltip>
                            </span>
                          ) : null}
                        </p>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex gap-2 items-center">
                  {!applicant?.resumeurl?.length ? (
                    <>
                      <Button
                        onClick={submitNewResume}
                        size="sm"
                        className="text-xs"
                        disabled={resumeUploadText !== "Upload Resume"}
                      >
                        {resumeUploadText}
                      </Button>
                      <input
                        type="file"
                        accept=".pdf,.doc,.docx"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleResumeFileChange}
                      />
                    </>
                  ) : (
                    <Button onClick={() => showResume()}>Resume</Button>
                  )}
                  <div className="relative">
                    <Button
                      variant="icon"
                      size="iconSm"
                      className="h-10 w-10 p-0 rounded-lg border border-mutedGray flex items-center justify-center hover:bg-gray-50 bg-white"
                      onClick={() => setShowPdfMenu((prev) => !prev)}
                    >
                      <IoEllipsisVertical className="text-gray-600 text-lg" />
                    </Button>
                    {showPdfMenu && (
                      <>
                        <div
                          className="fixed inset-0 z-10"
                          onClick={() => setShowPdfMenu(false)}
                        />
                        <div className="absolute right-0 top-10 z-20 bg-white border border-gray-200 rounded-lg shadow-lg w-48">
                          <button
                            className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50 rounded-lg"
                            onClick={() => {
                              setShowPdfMenu(false);
                              downloadPDF();
                            }}
                          >
                            Download PDF
                          </button>
                          <button
                            className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50 rounded-lg"
                            onClick={() => {
                              setShowPdfMenu(false);
                              setCandidateEdit(true);
                            }}
                          >
                            Edit
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="flex items-center bg-white shadow-md  rounded-xl mt-6">
                <div className=" w-full ">
                  <h2 className="font-medium  relative  py-6  p-4 before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2">
                    Skills
                  </h2>
                  <hr className="border-[#E9EBFA] " />
                  <div className="flex flex-wrap gap-2 p-4">
                    {skillArray?.length > 0 && applicant?.skillset?.length > 0 ? (
                      skillArray.map((skills, index) => (
                        <span
                          key={index}
                          className="bg-[#f0f4fc] border-2 border-slate-300 font-medium px-3 py-1 rounded-lg"
                        >
                          {skills}
                        </span>
                      ))
                    ) : (
                      <span className="text-[14px]">No skills to display.</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4 ">
                {userPrivilege !== roleTypes.hiringManager ? (
                  <div className="flex items-center bg-white shadow-md rounded-xl mt-6">
                    <div className=" w-full ">
                      <div className="flex items-center gap-2 ">
                        <h2 className="font-medium relative py-6  p-4 leading-[20px] before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2">
                          Annual Salary
                        </h2>
                        <div className="text-sm font-medium">
                          {parseInt(
                            applicant?.expectedsalary
                              ?.split(" ")[1]
                              ?.replaceAll(",", ""),
                          ) < minSalary && (
                              <div className="bg-[#E9EBFA] border-[#8F94A1] text-[#8F94A1] py-1 px-2 rounded-lg">
                                <p>Below Range</p>
                              </div>
                            )}
                          {parseInt(
                            applicant?.expectedsalary
                              ?.split(" ")[1]
                              ?.replaceAll(",", ""),
                          ) >= minSalary &&
                            parseInt(
                              applicant?.expectedsalary
                                ?.split(" ")[1]
                                ?.replaceAll(",", ""),
                            ) <= maxSalary && (
                              <div className="bg-[#E9EBFA] border-[#40B2B7] border-2 text-[#40B2B7] py-1 px-2 rounded-lg">
                                <p>Within Range</p>
                              </div>
                            )}
                          {parseInt(
                            applicant?.expectedsalary
                              ?.split(" ")[1]
                              ?.replaceAll(",", ""),
                          ) > maxSalary && (
                              <div className="bg-[#E9EBFA] border-[#E95060] border-2 text-[#E95060] py-1 px-2 rounded-lg">
                                <p>Above Range</p>
                              </div>
                            )}
                        </div>
                      </div>
                      <hr className="border-[#E9EBFA] " />
                      <div className="flex gap-6 p-2 items-center flex-1 min-w-[220px]">
                        <h3 className="text-slate-600 text-[14px] flex gap-2">
                          <span>Current Salary:</span>
                          <span className="text-black font-medium">
                            {getCurrencySymbol(companyCountryCode)}
                            {formatSalary(currentSalary, companyCountryCode)}
                          </span>
                        </h3>

                        <h3 className="text-slate-600 text-[14px] flex gap-2">
                          <span>Expected Salary:</span>
                          <span className="text-black font-medium">
                            {getCurrencySymbol(companyCountryCode)}
                            {formatSalary(expectedSalary, companyCountryCode)}
                          </span>
                        </h3>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center bg-white shadow-md rounded-xl mt-6 opacity-60">
                    <div className=" w-full ">
                      <div className="flex items-center gap-2 ">
                        <h2 className="font-medium relative py-6  p-4 leading-[20px] before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2">
                          Annual Salary
                        </h2>
                        <div className="text-sm font-medium">
                          {parseInt(
                            applicant?.expectedsalary
                              ?.split(" ")[1]
                              ?.replaceAll(",", ""),
                          ) < minSalary && (
                              <div className="bg-[#E9EBFA] border-[#8F94A1] text-[#8F94A1] py-1 px-2 rounded-lg">
                                <p>Below Range</p>
                              </div>
                            )}
                          {parseInt(
                            applicant?.expectedsalary
                              ?.split(" ")[1]
                              ?.replaceAll(",", ""),
                          ) >= minSalary &&
                            parseInt(
                              applicant?.expectedsalary
                                ?.split(" ")[1]
                                ?.replaceAll(",", ""),
                            ) <= maxSalary && (
                              <div className="bg-[#E9EBFA] border-[#40B2B7] border-2 text-[#40B2B7] py-1 px-2 rounded-lg">
                                <p>Within Range</p>
                              </div>
                            )}
                          {parseInt(
                            applicant?.expectedsalary
                              ?.split(" ")[1]
                              ?.replaceAll(",", ""),
                          ) > maxSalary && (
                              <div className="bg-[#E9EBFA] border-[#E95060] border-2 text-[#E95060] py-1 px-2 rounded-lg">
                                <p>Above Range</p>
                              </div>
                            )}
                        </div>
                      </div>
                      <hr className="border-[#E9EBFA] " />
                      <div className="flex gap-6 p-2 items-center flex-1 min-w-[220px]">
                        <h3 className="text-slate-600 text-[14px] flex gap-2">
                          <span>Current Salary:</span>
                        </h3>

                        <h3 className="text-slate-600 text-[14px] flex gap-2">
                          <span>Expected Salary:</span>
                        </h3>
                      </div>
                    </div>
                  </div>
                )}
                <div className="flex items-center bg-white shadow-md  rounded-xl mt-6">
                  <div className="w-full">
                    <div className="flex gap-2 items-center py-3">
                      <h2 className="font-medium relative py-4 leading-[20px] p-4 before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2">
                        Time to Join
                      </h2>
                    </div>

                    <hr className="border-[#E9EBFA] " />
                    <div className="p-4">
                      <h3 className="text-slate-600">
                        Approximate time to join:{" "}
                        <span className="text-black">{joiningTime} days</span>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={
                  jobDetails.aiinterviewenabled
                    ? "flex items-center bg-white shadow-md  rounded-xl mt-6"
                    : "flex items-center bg-white shadow-md  rounded-xl mt-6 pointer-events-none"
                }
                onClick={toggleAi}
              >
                <div className=" w-full ">
                  <h2
                    className={`
    flex justify-between items-center cursor-pointer font-medium relative w-full py-6 p-4 leading-[20px]
    before:block before:w-1 before:content-[''] before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2
    ${applicant?.cheatpercent > 50 || applicant?.status === "Incomplete"
                        ? "text-red-600 before:bg-red-600"
                        : jobDetails.aiinterviewenabled
                          ? "before:bg-[#148EFF] text-black"
                          : "before:bg-gray-400 text-gray-400"
                      }
  `}
                  >
                    <span className="flex items-center gap-2">
                      {/* 🚩 Tooltip when cheat detected */}
                      {applicant?.cheatpercent > 50 && (
                        <div className="group relative flex items-center">
                          <span className="ml-1 h-4 w-4 flex items-center justify-center text-2xl font-bold cursor-pointer">
                            🚩
                          </span>
                          <div className="absolute text-gray-400 transition-all left-0 top-8 text-left p-3 z-50 border border-gray-300 scale-0 rounded-lg bg-white w-64 shadow-md text-[0.7rem] group-hover:scale-100 break-words leading-normal">
                            Northstarz Cheat Detection: We assess whether or not
                            candidates have taken any kind of unauthorised
                            support during the interview by measuring several
                            things like toggling the browser window, scanning
                            eyeball movement and level of AI usage in the
                            recorded answers.
                          </div>
                        </div>
                      )}
                      AI Interview
                      {/* Show expiry reason if status is Incomplete */}
                      {applicant?.status === "Incomplete" && (
                        <p className="ml-2 font-normal text-red-600">
                          {applicant?.expiryreason}
                        </p>
                      )}
                      {applicant?.cheatpercent > 50 && (
                        <p className=" font-normal text-red-600">
                          Unusual behaviour detected, check recorded interview
                          videos for potential cheating.
                        </p>
                      )}
                    </span>

                    <button
                      className="bg-transparent border-none text-white text-2xl mr-4"
                      disabled={!jobDetails.aiinterviewenabled}
                    >
                      {isAIVisible ? (
                        <IoIosArrowUp className="text-[#444D63] w-5 h-5" />
                      ) : (
                        <IoIosArrowDown className="text-[#444D63] w-5 h-5" />
                      )}
                    </button>
                  </h2>

                  {/* Extra warning text when cheating detected */}

                  <hr className="border-[#E9EBFA]" />
                  {isAIVisible && (
                    <div className="px-4 pb-4 pt-3">
                      {/* Top row */}
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                        <div className={isPendingAI ? "opacity-50 cursor-not-allowed" : ""}>
                          <p className="text-sm font-semibold text-gray-700 mb-1.5">Aggregate AI Score : <span className="text-[#148EFF]">{applicant.aggregate}</span></p>
                          <div className="w-full h-1.5 bg-[#E7F4FF] rounded-full"><div className="h-full bg-[#006FD6] rounded-full" style={{ width: `${applicant.aggregate || 0}%` }} /></div>
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-gray-700 mb-1.5">Resume Score : <span className="text-[#148EFF]">{applicant?.resumescore == -1 ? "N/A" : applicant?.resumescore}</span></p>
                          <div className="w-full h-1.5 bg-[#E7F4FF] rounded-full"><div className="h-full bg-[#006FD6] rounded-full" style={{ width: `${applicant?.resumescore > 0 ? applicant.resumescore : 0}%` }} /></div>
                        </div>
                        <div className={isPendingAI ? "opacity-50 cursor-not-allowed" : ""}>
                          <p className="text-sm font-semibold text-gray-700 mb-1.5">Voice Score : <span className="text-[#148EFF]">{applicant?.voiceanalysisscore}</span></p>
                          <div className="w-full h-1.5 bg-[#E7F4FF] rounded-full"><div className="h-full bg-[#006FD6] rounded-full" style={{ width: `${applicant?.voiceanalysisscore || 0}%` }} /></div>
                        </div>
                      </div>
                      {/* Bottom row — compact cards */}
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div
                          className={`border rounded-xl transition-all duration-200 ${isPendingAI ? "cursor-not-allowed opacity-50" : "cursor-pointer"} ${isTechExpanded ? "border-blue-400 shadow-sm" : "border-gray-200"}`}
                          onClick={isPendingAI ? undefined : (e) => { e.stopPropagation(); setIsTechExpanded(p => !p); setIsEmpExpanded(false); }}
                        >
                          <div className="flex justify-between items-center p-3">
                            <div className="flex-1 pr-4">
                              <p className={`text-sm font-semibold mb-1.5 ${isTechExpanded ? "text-gray-900" : isEmpExpanded ? "text-gray-400" : "text-gray-700"}`}>Technical Score : <span className="text-[#148EFF]">{applicant?.technicalscore}</span></p>
                              <div className="w-full h-1.5 bg-[#E7F4FF] rounded-full"><div className="h-full bg-[#006FD6] rounded-full" style={{ width: `${applicant?.technicalscore || 0}%` }} /></div>
                            </div>
                            {!isPendingAI && (isTechExpanded ? <IoIosArrowUp className="text-gray-500 flex-shrink-0" /> : <IoIosArrowDown className="text-gray-500 flex-shrink-0" />)}
                          </div>
                        </div>
                        <div
                          className={`border rounded-xl transition-all duration-200 ${isPendingAI ? "cursor-not-allowed opacity-50" : "cursor-pointer"} ${isEmpExpanded ? "border-blue-400 shadow-sm" : "border-gray-200"}`}
                          onClick={isPendingAI ? undefined : (e) => { e.stopPropagation(); setIsEmpExpanded(p => !p); setIsTechExpanded(false); }}
                        >
                          <div className="flex justify-between items-center p-3">
                            <div className="flex-1 pr-4">
                              <p className={`text-sm font-semibold mb-1.5 ${isEmpExpanded ? "text-gray-900" : isTechExpanded ? "text-gray-400" : "text-gray-700"}`}>Employability Score : <span className="text-[#148EFF]">{applicant?.aiscore}</span></p>
                              <div className="w-full h-1.5 bg-[#E7F4FF] rounded-full"><div className="h-full bg-[#006FD6] rounded-full" style={{ width: `${applicant?.aiscore || 0}%` }} /></div>
                            </div>
                            {!isPendingAI && (isEmpExpanded ? <IoIosArrowUp className="text-gray-500 flex-shrink-0" /> : <IoIosArrowDown className="text-gray-500 flex-shrink-0" />)}
                          </div>
                        </div>
                      </div>
                      {/* Expanded content — below both cards */}
                      {isTechExpanded && !isPendingAI && (
                        <div className="mt-4 border-t border-slate-200">
                          <div className="p-4">
                            <p className="text-sm font-semibold text-gray-700 mb-2">Summary</p>
                            {applicant?.technical_summary ? (
                              <div
                                className="text-sm text-gray-600 leading-relaxed ai-summary-html"
                                dangerouslySetInnerHTML={sanitizeHTML(applicant?.technical_summary)}
                              />
                            ) : (
                              <p className="text-sm text-gray-400">Interview summary is unavailable for this candidate.</p>
                            )}
                          </div>
                        </div>
                      )}
                      {isEmpExpanded && !isPendingAI && (
                        <div className="mt-4 border-t border-slate-200">
                          {interviews.length === 0 ? (
                            <p className="text-sm text-gray-500 text-center py-6">Interview summary is unavailable for this candidate.</p>
                          ) : (
                            <div style={{ display: "grid", gridTemplateColumns: "minmax(0,3fr) 1px minmax(0,2fr)" }}>
                              <div style={{ padding: "16px 8px 16px 16px", height: 420 }}>
                                <Radar data={radarData} options={radarChartOptions} />
                              </div>
                              <div style={{ background: "#e2e8f0", margin: "16px 0" }} />
                              <div style={{ padding: "20px 20px 20px 24px", display: "flex", flexDirection: "column", gap: 8, overflowY: "auto" }}>
                                <p style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 4 }}>Summary</p>
                                {applicant?.employability_summary ? (
                                  <div
                                    className="ai-summary-html"
                                    style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.6 }}
                                    dangerouslySetInnerHTML={sanitizeHTML(applicant?.employability_summary)}
                                  />
                                ) : (
                                  <p style={{ fontSize: 13, color: "#9ca3af", lineHeight: 1.6 }}>Interview summary is unavailable for this candidate.</p>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* <div className="flex items-center bg-white shadow-md  rounded-xl mt-6">
          <div className=" w-full  ">
            <div className="flex justify-between items-center w-full ">
              <h2 className=" flex justify-between mb-2  font-semibold relative w-full  mt-1 text-xl p-4 before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2">
                Interview Feedbacks
                <button
                  className="bg-transparent border-none text-white text-2xl mr-4"
                  onClick={toggleFeedback}
                >
                  {isFeedbackVisible ? (
                    <IoIosArrowUp className="text-[#444D63] w-5 h-5" />
                  ) : (
                    <IoIosArrowDown className="text-[#444D63] w-5 h-5" />
                  )}
                </button>
              </h2>
            </div>
            <hr className="border-[#E9EBFA] " />

            <div
              className={`max-w-[1300px]  m-auto overflow-hidden bg-white   ${
                isFeedbackVisible ? "max-h-[900px] mb-4 mt-4" : "max-h-0 "
              }`}
            >
              <SwipeFeedback />
            </div>
          </div>
        </div> */}

              <div
                className={
                  jobDetails.aiinterviewenabled
                    ? "flex items-center bg-white shadow-md  rounded-xl mt-6"
                    : "flex items-center bg-white shadow-md  rounded-xl mt-6 pointer-events-none"
                }
              >
                <div className=" w-full flex-row ">
                  <div
                    className="flex justify-between items-center w-full "
                    onClick={toggleDocument}
                  >
                    <p
                      className={
                        jobDetails.aiinterviewenabled
                          ? " flex justify-between cursor-pointer   font-medium relative w-full  py-6  p-4 leading-[20px] before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2"
                          : " flex justify-between cursor-pointer   font-medium relative w-full  py-6  p-4 leading-[20px] before:block before:bg-gray-400 text-gray-400 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2"
                      }
                    >
                      Recorded Interviews
                      <button
                        className="bg-transparent border-none text-white text-2xl mr-4"
                        disabled={!jobDetails.aiinterviewenabled}
                      >
                        {isDocumentVisible ? (
                          <IoIosArrowUp className="text-gray-800 w-5 h-5" />
                        ) : (
                          <IoIosArrowDown className="text-gray-800 w-5 h-5" />
                        )}
                      </button>
                    </p>
                  </div>
                  <hr className="border-gray-200 " />

                  <div
                    className={`max-w-[1300px]  m-auto overflow-hidden bg-white transition-max-h   ${isDocumentVisible ? "max-h-[900px] mb-4 mt-4" : "max-h-0 "
                      }`}
                  >
                    <Swipe />
                  </div>
                </div>
              </div>

              {(jobDetails.hackerrank_enabled || jobDetails.coderbyte_enabled) && (() => {
                const isCb = applicant.coderbyte_enabled || jobDetails.coderbyte_enabled;
                const testStatus = isCb ? applicant.coderbyte_test_status : applicant.hackerrank_test_status;
                const testScore = isCb ? applicant.coderbyte_score : applicant.hackerrank_score;
                const candidateId = isCb ? applicant.coderbyte_candidate_id : applicant.hackerrank_candidate_id;
                const providerName = isCb ? "Coderbyte" : "HackerRank";
                return (
                  <div
                    className={`flex items-center bg-white shadow-md rounded-2xl mt-6 ${!testStatus
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                      }`}
                    onClick={() => {
                      if (testStatus) toggleHackerRank();
                    }}
                  >
                    <div className="w-full flex-row">
                      <div className="flex justify-between items-center w-full">
                        <p className="flex justify-between cursor-pointer font-medium relative w-full py-6 p-4 leading-[20px] before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2">
                          {providerName} Assessment
                          <button className="bg-transparent border-none text-white text-2xl mr-4">
                            {hackerRankVisible ? (
                              <IoIosArrowUp className="text-gray-800 w-5 h-5" />
                            ) : (
                              <IoIosArrowDown className="text-gray-800 w-5 h-5" />
                            )}
                          </button>
                        </p>
                      </div>

                      <hr className="border-gray-200" />

                      {!testStatus ? (
                        <div className="w-full text-left text-gray-500 p-6">
                          {providerName} test is not triggered.
                        </div>
                      ) : (
                        <div
                          className={`w-full overflow-hidden bg-white transition-max-h ${hackerRankVisible
                            ? "max-h-[900px] mb-4 mt-4"
                            : "max-h-0"
                            }`}
                        >
                          <div className="grid grid-cols-1 md:grid-cols-4">
                            {/* Score Section */}
                            <div className="flex flex-col items-center p-4 gap-4">
                              <div className="flex items-center gap-2">
                                <FiBarChart2 className="text-blue-500 w-6 h-6" />
                                <h3 className="text-slate-600 text-base font-medium">
                                  Score
                                </h3>
                              </div>
                              <div>
                                <p className="text-black text-xl font-semibold">
                                  {testScore ?? "N/A"}
                                </p>
                              </div>
                            </div>

                            {/* Status Badge */}
                            <div className="flex flex-col items-center justify-center gap-4 bg-white p-4">
                              <div className="flex items-center gap-2">
                                <FiCheckCircle className="text-blue-500 w-6 h-6" />
                                <h3 className="text-slate-600 text-base font-medium">
                                  Status
                                </h3>
                              </div>
                              <div className="flex items-center gap-2">
                                <span
                                  className={`inline-block px-3 py-1 rounded-full text-sm font-medium capitalize ${getStatusColor(
                                    testStatus,
                                  )}`}
                                >
                                  {testStatus ?? "Unknown"}
                                </span>
                                <button
                                  disabled={
                                    testStatus === "Invited"
                                  }
                                  onClick={() =>
                                    showReport(candidateId)
                                  }
                                >
                                  <img
                                    src={Download}
                                    alt="Download"
                                    className="w-5 h-5 opacity-80 hover:opacity-100"
                                  />
                                </button>
                              </div>
                            </div>

                            {/* Completion Time */}
                            <div className="flex flex-col items-center p-4">
                              <div className="flex gap-2">
                                <FiClock className="text-blue-500 w-6 h-6" />
                                <h3 className="text-slate-600 text-base font-medium">
                                  Completion time
                                </h3>
                              </div>
                              <p className="text-black text-xl font-semibold">
                                {applicant.completion_time ?? "N/A"}
                              </p>
                            </div>

                            {/* Completion Date */}
                            <div className="flex flex-col items-center p-4 gap-4">
                              <div className="flex gap-2">
                                <FiCalendar className="text-blue-500 w-6 h-6" />
                                <h3 className="text-slate-600 text-base font-medium">
                                  Completion Date
                                </h3>
                              </div>
                              <p className="text-black text-xl font-semibold">
                                {(applicant.coderbyte_completed_at || applicant.attempt_date)
                                  ? formatToDDMMYYYY(applicant.coderbyte_completed_at || applicant.attempt_date)
                                  : "N/A"}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })()}

              <div className="flex items-center  bg-white shadow-md  rounded-xl mt-6">
                <div className=" w-full  ">
                  <div
                    onClick={() => {
                      setOpenInterviewFeedbacks((prev) => !prev);
                    }}
                    className="flex justify-between items-center w-full "
                  >
                    <h2 className=" flex justify-between cursor-pointer   font-medium relative w-full  py-6  p-4 leading-[20px] before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2">
                      Interview Feedbacks
                      <button className="bg-transparent border-none text-white text-2xl mr-4">
                        {openInterviewFeedbacks ? (
                          <IoIosArrowUp className="text-[#444D63] w-5 h-5" />
                        ) : (
                          <IoIosArrowDown className="text-[#444D63] w-5 h-5" />
                        )}
                      </button>
                    </h2>
                  </div>
                  <hr className="border-[#E9EBFA] " />
                  {openInterviewFeedbacks && (
                    <div className="py-5 max-w-[1300px]  m-auto overflow-hidden bg-white transition-max-h  ">
                      <SwipeFeedback
                        roundsinfo={applicant.roundsinfo}
                        isFromACFL={companyDetails?.from_acfl}
                      ></SwipeFeedback>
                    </div>
                  )}
                </div>
              </div>
              {(companyDetails?.from_acfl ||
                statusChecks.includes(applicant.status)) && (
                  <div
                    className={`flex items-center  bg-white shadow-md  rounded-xl mt-6`}
                  >
                    <div className=" w-full  ">
                      <div
                        onClick={() => {
                          setViewDocuments((prev) => !prev);
                        }}
                        className="flex justify-between items-center w-full "
                      >
                        <h2 className=" flex justify-between cursor-pointer   font-medium relative w-full  py-6  p-4 leading-[20px] before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2">
                          Documents
                          <button className="bg-transparent border-none text-white text-2xl mr-4">
                            {viewDocuments ? (
                              <IoIosArrowUp className="text-[#444D63] w-5 h-5" />
                            ) : (
                              <IoIosArrowDown className="text-[#444D63] w-5 h-5" />
                            )}
                          </button>
                        </h2>
                      </div>
                      <hr className="border-[#E9EBFA] " />
                      {viewDocuments && (
                        <div>
                          {allDocuments.length > 0 ? (
                            <div>
                              <div className="flex items-center justify-between p-4 pb-0">
                                <div
                                  onClick={fetchDocuments}
                                  className="cursor-pointer text-[#444D63] "
                                >
                                  <ReloadIcon></ReloadIcon>
                                </div>
                                {userPrivilege !== "Hiring Manager" && (
                                  <div className="flex gap-2 items-center">
                                    <div onClick={() => setTab("reqdoc")}>
                                      <ButtonXs
                                        color="#148EFF"
                                        text="#FFFFFF"
                                        size="xs"
                                      >
                                        Request Document
                                      </ButtonXs>
                                    </div>
                                    <div
                                      onClick={() => setConfirmationModal("adddoc")}
                                    >
                                      <ButtonHollowXs
                                        text="#148EFF"
                                        color="transparent"
                                        size="xs"
                                      >
                                        Add Document
                                      </ButtonHollowXs>
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="p-4">
                                <Table className="w-full text-[14px]">
                                  <Thead>
                                    <Tr className="text-center font-semibold">
                                      <Th className="p-4 border-y">Document</Th>
                                      <Th className="p-4 border-y">
                                        Uploaded By
                                      </Th>
                                      <Th className="p-4 border-y">
                                        Uploaded Date
                                      </Th>
                                      <Th className="p-4 border-y">
                                        Current Status
                                      </Th>
                                      <Th className="p-4 border-y">Actions</Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody className="text-center">
                                    {allDocuments
                                      .slice()
                                      .reverse()
                                      .map((d) => {
                                        return (
                                          <Tr className="text-[14px] text-center text-[#444D63]">
                                            <Td
                                              className={`p-4 ${d.status == "Pending"
                                                ? "text-[#444D63]"
                                                : "text-[#148EFF] cursor-pointer"
                                                } text-center border-y `}
                                            >
                                              <p
                                                className="flex flex-row items-center justify-center"
                                                onClick={() => {
                                                  setActiveDocUuid(d.parentUuid);
                                                  if (d.status == "Verified") {
                                                    setActiveDocId(d.documentid);
                                                    setActiveDocName(
                                                      d.document_name,
                                                    );
                                                    setActiveDocStatus(d.status);
                                                    setConfirmationModal(
                                                      "showdoc",
                                                    );
                                                  }
                                                  if (
                                                    d.status !== "Verified" &&
                                                    d.status !== "Pending"
                                                  ) {
                                                    setActiveDocId(d.documentid);
                                                    fetchDocumentUrl(
                                                      d.documentid,
                                                    );
                                                    setConfirmationModal(
                                                      "viewdoc",
                                                    );
                                                  }
                                                  if (
                                                    d.status == "Under Review"
                                                  ) {
                                                    setActiveDocId(d.documentid);
                                                    if (d.viewed == "new") {
                                                      updateDocumentViewStatus(
                                                        d.documentid,
                                                        d.parentUuid,
                                                      );
                                                    }
                                                    fetchDocumentUrl(
                                                      d.documentid,
                                                    );
                                                    setConfirmationModal(
                                                      "viewdoc",
                                                    );
                                                  }
                                                }}
                                              >
                                                <p> {d.document_name}</p>
                                                {d.viewed == "new" && (
                                                  <div className="bg-[#D9F0F1]  ml-1 text-[10px] w-fit font-medium border-[#40B2B7] border text-[#40B2B7] leading-[12px] py-[3px] px-[6px] rounded-[2px]">
                                                    <p>New</p>
                                                  </div>
                                                )}
                                              </p>
                                            </Td>
                                            <Td className="p-4 border-y">
                                              {renderValue(d.uploadedby)}
                                            </Td>
                                            <Td className="p-4 border-y">
                                              {d.uploadeddate
                                                ? formatDate(d.uploadeddate)
                                                : "-"}
                                            </Td>
                                            <Td
                                              className={`p-4 border-y font-medium ${d.status === "Under Review"
                                                ? "text-[#FE9933]"
                                                : d.status === "Rejected"
                                                  ? "text-[#E95060]"
                                                  : d.status === "Verified"
                                                    ? "text-[#40B2B7]"
                                                    : d.status === "Pending"
                                                      ? "text-[#444D63]"
                                                      : ""
                                                }`}
                                            >
                                              {d.status == "Pending"
                                                ? "Not Submitted"
                                                : d.status}
                                            </Td>
                                            <Td className="border-y w-[170px] text-[12px]">
                                              <div className="proposal-select flex justify-center cursor-pointer">
                                                <Select
                                                  className="single-action text-[12px] text-left w-[8rem]"
                                                  placeholder="Select Action"
                                                  value=""
                                                  onChange={(selectedOption) => {
                                                    setActiveDocId(d.documentid);
                                                    setActiveDocUuid(d.parentUuid);
                                                    setActiveDocName(
                                                      d.document_name,
                                                    );
                                                    setActiveDocStatus(d.status);
                                                    if (
                                                      selectedOption.label ==
                                                      "Show Document"
                                                    ) {
                                                      fetchDocumentUrl(
                                                        d.documentid,
                                                      );

                                                      setVisibleDocumentName(
                                                        d.document_name,
                                                      );
                                                      setConfirmationModal(
                                                        "viewdoc",
                                                      );
                                                      if (d.viewed == "new") {
                                                        updateDocumentViewStatus(
                                                          d.documentid,
                                                          d.parentUuid,
                                                        );
                                                      }
                                                      setDocumentAction(
                                                        selectedOption.value,
                                                      );
                                                    }
                                                    if (
                                                      selectedOption.label ==
                                                      "Download"
                                                    ) {
                                                      downloadDocumentUrl(
                                                        d.documentid,
                                                      );
                                                    }
                                                    if (
                                                      selectedOption.label ==
                                                      "Request Again"
                                                    ) {
                                                      setTab("reqdocagain");
                                                      setActiveDocId(
                                                        d.documentid,
                                                      );
                                                      setDocumentAction(
                                                        selectedOption.value,
                                                      );
                                                    }
                                                    if (
                                                      selectedOption.label ==
                                                      "Show Document" &&
                                                      d.status == "Verified"
                                                    ) {
                                                      setConfirmationModal(
                                                        "showdoc",
                                                      );
                                                    }
                                                  }}
                                                  options={
                                                    d.status === "Under Review" ||
                                                      d.status === "Verified"
                                                      ? underReviewActions
                                                      : rejectedActions
                                                  }
                                                ></Select>
                                              </div>
                                            </Td>
                                          </Tr>
                                        );
                                      })}
                                  </Tbody>
                                </Table>
                              </div>
                            </div>
                          ) : (
                            <div className="p-4 ">
                              <div className="m-auto w-fit flex flex-col items-center justify-center my-4">
                                <img
                                  src={emptydocs}
                                  className="w-[205px] h-[205px] mb-[10px]"
                                  alt="no proposal yet"
                                />
                                <p className="text-[16px] font-medium  mb-[20px] ">
                                  Documents have not been requested from the
                                  candidate yet.
                                </p>
                                {userPrivilege !== roleTypes.hiringManager && (
                                  <div onClick={() => setTab("reqdoc")}>
                                    <ButtonXs color="#148EFF" text="#FFFFFF">
                                      Request Documents
                                    </ButtonXs>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              {statusChecks.includes(applicant.status) && (
                <div
                  className={`flex items-center  bg-white shadow-md  rounded-xl mt-6 ${userPrivilege === roleTypes.hiringManager && "opacity-40"}`}
                >
                  <div className=" w-full  ">
                    <div
                      onClick={toggleProposals}
                      className="flex justify-between cursor-pointer items-center w-full "
                    >
                      <h2 className=" flex justify-between py-6  p-4 leading-[20px]  font-medium relative w-full   before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2">
                        Offer Proposal
                        <button className="bg-transparent border-none text-white text-2xl mr-4">
                          {isProposalsVisible ? (
                            <IoIosArrowUp className=" text-[#444D63] w-5 h-5" />
                          ) : (
                            <IoIosArrowDown className="text-[#444D63] w-5 h-5" />
                          )}
                        </button>
                      </h2>
                    </div>
                    <hr className="border-[#E9EBFA] " />
                    <div>
                      {isProposalsVisible && (
                        <>
                          {!(allSalaryProposal?.length > 0) && (
                            <div className="p-4 ">
                              <div className="m-auto w-fit flex flex-col items-center justify-center my-4">
                                <img
                                  src={proposalimage}
                                  className="w-[306px] h-[254px] mb-[10px]"
                                  alt="no proposal yet"
                                />
                                <p className="text-[16px] font-medium  mb-[20px] ">
                                  No proposals have been created yet.
                                </p>
                                {userPrivilege !== "Hiring Manager" && (
                                  <div
                                    onClick={() => {
                                      statusUpdate(
                                        "Salary Proposal In-progress",
                                        "proposal",
                                      );
                                    }}
                                  >
                                    <ButtonXs color="#148EFF" text="#FFFFFF">
                                      Create Salary Proposal
                                    </ButtonXs>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          {allSalaryProposal.length > 0 && (
                            <div>
                              <div className="p-4">
                                <Table className="w-full    text-[14px]">
                                  <Thead>
                                    <Tr className="text-center font-semibold">
                                      <Th className=" p-4 border-y">
                                        Document
                                      </Th>
                                      <Th className=" p-4  border-y">
                                        Created By
                                      </Th>
                                      <Th className=" p-4 border-y">
                                        Uploaded Date
                                      </Th>
                                      <Th className=" p-4 border-y">
                                        Current Status
                                      </Th>
                                      <Th className=" p-4 border-y">Actions</Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody className="text-center">
                                    {allOfferLetter.map((offer, index) => (
                                      <Tr key={index}>
                                        <Td
                                          onClick={() => {
                                            setTab("showDocument");
                                            setActiveOfferStatus(offer.status);
                                          }}
                                          className="p-4 cursor-pointer text-[#148EFF] border-y"
                                        >
                                          Offer Letter
                                        </Td>
                                        <Td className="p-4 border-y">
                                          {offer.createdby}
                                        </Td>
                                        <Td className="p-4 border-y">
                                          {formatDate(offer.createdat)}
                                        </Td>
                                        <Td
                                          className={`p-4 border-y font-medium ${offer.status === "Generated"
                                            ? "text-[#40B2B7]"
                                            : offer.status === "Draft"
                                              ? "text-[#444D63]"
                                              : ""
                                            }`}
                                        >
                                          {offer.status}
                                        </Td>
                                        <Td className="border-y w-[170px] text-[12px]">
                                          <div className="proposal-select flex justify-center cursor-pointer">
                                            <Select
                                              className="single-action text-left w-[8rem]"
                                              onChange={(option) => {
                                                setActiveOfferUuid(offer.uuid);
                                                setActiveOfferStatus(
                                                  offer.status,
                                                );
                                                setProposalFromLatest(
                                                  latestSalaryProposal,
                                                );
                                                if (option.value === "edit") {
                                                  setTab("offerletterdraft");
                                                  fetchEditOfferLetter(
                                                    offer.uuid,
                                                  );
                                                }
                                                if (
                                                  option.value ===
                                                  "showDocument"
                                                ) {
                                                  setTab("showDocument");
                                                }
                                                if (option.value == "delete") {
                                                  setConfirmationModal(
                                                    "odelete",
                                                  );
                                                }
                                                if (
                                                  option.value ==
                                                  "requestApproval"
                                                ) {
                                                  setConfirmationModal("offer");
                                                }
                                                if (option.value == "remind") {
                                                  setConfirmationModal("offer");
                                                  setRemindApproval(true);
                                                }
                                              }}
                                              options={
                                                offer.status === "Generated"
                                                  ? [
                                                    {
                                                      value: "showDocument",
                                                      label: "Show Document",
                                                    },
                                                    {
                                                      value:
                                                        "requestApproval",
                                                      label:
                                                        "Request Approval",
                                                    },
                                                    {
                                                      value: "edit",
                                                      label: "Edit",
                                                    },
                                                  ]
                                                  : offer.status === "Draft"
                                                    ? [
                                                      {
                                                        value: "edit",
                                                        label: "Edit",
                                                      },
                                                      {
                                                        value: "delete",
                                                        label: "Delete",
                                                      },
                                                    ]
                                                    : offer.status ===
                                                      "Approved"
                                                      ? [
                                                        {
                                                          value:
                                                            "showDocument",
                                                          label:
                                                            "Show Document",
                                                        },
                                                      ]
                                                      : offer.status ===
                                                        "Approval Pending"
                                                        ? [
                                                          {
                                                            value:
                                                              "showDocument",
                                                            label:
                                                              "Show Document",
                                                          },
                                                          {
                                                            value: "remind",
                                                            label: "Remind",
                                                          },
                                                        ]
                                                        : []
                                              }
                                              placeholder="Select Action"
                                            />
                                          </div>
                                        </Td>
                                      </Tr>
                                    ))}
                                    {allSalaryProposal
                                      .slice()
                                      .reverse()
                                      .map((proposal, index) => (
                                        <Tr key={proposal.uuid || index}>
                                          <Td className="p-4 cursor-pointer text-[#148EFF] border-y">
                                            <p
                                              onClick={() => {
                                                setActiveSProposalUuid(
                                                  proposal.uuid,
                                                );
                                                setHiringManagerId(
                                                  proposal.hiring_manager,
                                                );
                                                setActiveProposalStatus(
                                                  proposal.status,
                                                );
                                                setShowJustification(
                                                  proposal.justification,
                                                );
                                                if (
                                                  proposal.status == "Draft"
                                                ) {
                                                  fetchEditSalaryProposal(
                                                    proposal.uuid,
                                                  );
                                                  setTab("draft");
                                                } else {
                                                  fetchEditSalaryProposal(
                                                    proposal.uuid,
                                                  );
                                                  setTab("feedback");
                                                }
                                              }}
                                            >
                                              Salary Proposal
                                            </p>
                                          </Td>
                                          <Td className="p-4 border-y">
                                            {proposal.createdby}
                                          </Td>
                                          <Td className="p-4 border-y">
                                            {formatDate(proposal.createdat)}
                                          </Td>
                                          <Td
                                            className={`p-4 border-y font-medium ${proposal.status === "Approved"
                                              ? "text-[#40B2B7]"
                                              : proposal.status === "Rejected"
                                                ? "text-[#E95060]"
                                                : proposal.status === "Draft"
                                                  ? "text-[#444D63]"
                                                  : proposal.status ===
                                                    "Approval Pending"
                                                    ? "text-[#FE9933]"
                                                    : ""
                                              }`}
                                          >
                                            {proposal.status}
                                          </Td>
                                          <Td className="border-y w-[170px] text-[12px]">
                                            <div className="proposal-select flex justify-center cursor-pointer">
                                              <Select
                                                value=""
                                                className="single-action text-left w-[8rem]"
                                                onChange={(option) => {
                                                  setActiveSProposalUuid(
                                                    proposal.uuid,
                                                  );
                                                  setActiveProposalStatus(
                                                    proposal.status,
                                                  );
                                                  setHiringManagerId(
                                                    proposal.hiring_manager,
                                                  );

                                                  if (option.value === "edit") {
                                                    fetchEditSalaryProposal(
                                                      proposal.uuid,
                                                    );
                                                    setTab("draft");
                                                  }
                                                  if (
                                                    option.value ===
                                                    "showFeedback" ||
                                                    option.value ===
                                                    "showProposal"
                                                  ) {
                                                    fetchEditSalaryProposal(
                                                      proposal.uuid,
                                                    );
                                                    setTab("feedback");
                                                  }
                                                  if (
                                                    option.value === "delete"
                                                  ) {
                                                    setConfirmationModal(
                                                      "delete",
                                                    );
                                                  }
                                                  if (
                                                    option.value ===
                                                    "createAgain"
                                                  ) {
                                                    fetchEditSalaryProposal(
                                                      proposal.uuid,
                                                    );

                                                    setTab("proposal");
                                                  }
                                                }}
                                                options={
                                                  proposal.status ===
                                                    "Approval Pending"
                                                    ? [
                                                      {
                                                        value: "sendReminder",
                                                        label:
                                                          "Send Reminder",
                                                      },
                                                    ]
                                                    : proposal.status ===
                                                      "Approved"
                                                      ? [
                                                        {
                                                          value:
                                                            "showProposal",
                                                          label:
                                                            "Show Proposal",
                                                        },
                                                        {
                                                          value: "download",
                                                          label: "Download",
                                                        },
                                                      ]
                                                      : proposal.status ===
                                                        "Rejected" &&
                                                        allSalaryProposal.length <=
                                                        1
                                                        ? [
                                                          {
                                                            value:
                                                              "showFeedback",
                                                            label:
                                                              "Show Feedback",
                                                          },
                                                          {
                                                            value:
                                                              "createAgain",
                                                            label:
                                                              "Create Again",
                                                          },
                                                        ]
                                                        : proposal.status ===
                                                          "Rejected" &&
                                                          allSalaryProposal.length >
                                                          1
                                                          ? [
                                                            {
                                                              value:
                                                                "showFeedback",
                                                              label:
                                                                "Show Feedback",
                                                            },
                                                          ]
                                                          : proposal.status ===
                                                            "Draft"
                                                            ? [
                                                              {
                                                                value: "edit",
                                                                label: "Edit",
                                                              },
                                                              {
                                                                value:
                                                                  "delete",
                                                                label:
                                                                  "Delete",
                                                              },
                                                            ]
                                                            : []
                                                }
                                                placeholder="Select Action"
                                              />
                                            </div>
                                          </Td>
                                        </Tr>
                                      ))}
                                  </Tbody>
                                </Table>
                              </div>
                            </div>
                          )}

                          {latestSProposalUuid &&
                            allOfferLetter.length == 0 && (
                              <div className="mx-auto mb-4 w-fit flex items-center flex-col justify-center">
                                <p className="font-medium mb-[20px] mt-[40px] ">
                                  Your submitted salary proposal has been
                                  approved by the hiring manager.
                                </p>
                                <div
                                  onClick={() => {
                                    // toast.success(
                                    //   "Email to approve salary proposal has been sent to the hiring manager."
                                    // );
                                    statusUpdate(
                                      "Offer Letter In-progress",
                                      "offerletter",
                                    );
                                    setProposalFromLatest(latestSalaryProposal);
                                    setTab("offerletter");
                                  }}
                                >
                                  <ButtonXs text="#FFFFFF" color="#148EFF">
                                    Create Offer Letter
                                  </ButtonXs>
                                </div>
                              </div>
                            )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {tab == "showDocument" && (
            <div>
              <div className="flex gap-1 items-center text-3xl font-medium pb-2">
                <Button
                  variant="icon"
                  onClick={() =>
                    navigate("/jobs/candidates/about", {
                      state: { uuid: uuid },
                    })
                  }
                >
                  <IoArrowBackOutline className="w-7 cursor-pointer h-7 " />
                </Button>
                Offer Letter
              </div>
              <OfferLetter
                applicant={applicant}
                companyDetails={companyDetails}
                offerLetterDetails={allOfferLetter}
                jobDetails={jobDetails}
                showButton={false}
                offerstatus={activeOfferStatus}
                ref={offerRef}
              ></OfferLetter>
              <div className="flex  justify-between ">
                <div className="text-center mt-4">
                  <ButtonXs
                    onClick={() => {
                      offerRef.current?.convertToPdf();
                    }}
                    color="#0DCD94"
                    text="#FFFFFF"
                  >
                    Download PDF
                  </ButtonXs>
                </div>
                {applicant.status != "Accepted" && (
                  <div>
                    {companyDetails?.offerApproval === true &&
                      activeOfferStatus !== "Approved" &&
                      activeOfferStatus !== "Acceptance Awaited" ? (
                      // ✅ Show Request Approval Dropdown
                      <div className="relative inline-block mt-4">
                        {/* Main Button */}
                        <button
                          className={`py-[12px] px-[20px] text-[12px] bg-[#148EFF] text-white rounded-[4px] flex items-center justify-between min-w-[140px] ${isOpen ? "rounded-b-none" : ""
                            }`}
                          onClick={() => setIsOpen(!isOpen)}
                          disabled={isSendingOffer}
                        >
                          {isSendingOffer ? (
                            <TailSpin color="#FFFFFF" height={20} width={20} />
                          ) : activeOfferStatus == "Approval Pending" ? (
                            "Remind"
                          ) : (
                            "Request Approval"
                          )}
                          <img
                            src={arrow}
                            className={`ml-2 h-[6px] transition-transform ${isOpen ? "rotate-180" : ""
                              }`}
                          />
                        </button>

                        {/* Dropdown */}
                        {isOpen && !isSendingOffer && (
                          <div className="absolute left-0 mt-0 w-full text-[12px] bg-[#5AA7EF] text-white rounded-b-[4px] overflow-hidden shadow-md z-50 max-h-[100px] overflow-y-auto">
                            {(companyDetails.offerApproval
                              ? allUsers
                                ?.filter((user) => user.offer_letter_approver)
                                .map((user) => ({
                                  value: user.uuid,
                                  label: user.name,
                                }))
                              : adminUserLabels
                            ).map((user) => (
                              <button
                                key={user.value}
                                onClick={async () => {
                                  try {
                                    setIsSendingOffer(true);

                                    if (offerletterPending) {
                                      removeOfferLetterPendingNotification();
                                    }

                                    await sendOfferApproval(user.value);

                                    toast.success(
                                      `Offer letter Sent for Approval ${user.label}`,
                                    );
                                    setTimeout(() => {
                                      navigate("/jobs/candidates/about", {
                                        state: { uuid: uuid },
                                      });
                                    }, 3000);
                                  } catch (error) {
                                    toast.error(
                                      "Failed to generate offer letter",
                                    );
                                    console.error(error);
                                  } finally {
                                    setIsSendingOffer(false);
                                  }
                                }}
                                className="w-full flex items-center space-x-2 py-3 px-3 hover:bg-[#4a95d5]"
                              >
                                <p>{user.label}</p>
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        onClick={async () => {
                          try {
                            setIsSendingOffer(true);

                            if (offerletterPending) {
                              removeOfferLetterPendingNotification();
                            }

                            await sendOfferLetter();

                            toast.success(
                              `Offer letter Sent to ${applicant.name}`,
                              {},
                            );
                          } catch (error) {
                            toast.error("Failed to generate offer letter");
                            console.error(error);
                          } finally {
                            setIsSendingOffer(false);
                          }
                        }}
                        className="mt-4"
                      >
                        <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                          {isSendingOffer ? (
                            <TailSpin color="#148EFF" height={20} width={20} />
                          ) : activeOfferStatus == "Acceptance Awaited" ? (
                            "Remind"
                          ) : (
                            "Send Offer letter via email"
                          )}
                        </ButtonHollowXs>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {tab == "proposal" && (
            <div>
              <div className="mb-8  flex items-center">
                <img
                  onClick={() => {
                    setConfirmationModal("back");
                  }}
                  src={arrowleft}
                  className="w-[40px] cursor-pointer h-[40px] mr-4"
                  alt="back button"
                />
                <h2 className="font-medium text-[28px]">
                  Salary Proposal Creation
                </h2>
              </div>
              <div className="flex flex-col shadow-custom-shadow rounded-xl">
                <div className="flex w-full  rounded-lg ">
                  <div className="w-1/2 pt-[20px] pb-[4px] px-6 rounded-tl-xl  bg-white  ">
                    <div className="text-[14px] mb-[20px]">
                      <div className="  mb-1  font-semibold">
                        Email Template
                        <span className="text-red-400 justify start"> *</span>
                      </div>
                      <div id={errors.templateType && "error"}>
                        <div className="filter-container text-[14px]">
                          <Select
                            isClearable
                            options={salaryTemplatesOptions}
                            placeholder="Select salary template"
                            defaultValue={
                              salaryTemplatesOptions.find(
                                (o) => o.label === "Offer",
                              ) ?? null
                            }
                            value={selectedSalaryTemplate}
                            onChange={(newValue) => {
                              setTemplateType(newValue);
                              handleSalaryChangeEmailTemplate(newValue);
                              setSelectedSalaryTemplate(newValue);
                            }}
                          />
                        </div>
                        {errors.templateType && (
                          <div className="text-[#F7284A] mt-[6px] text-[12px]">
                            {errors.templateType}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className=" text-[14px] mb-[24px]">
                      <div className="  mb-1 font-semibold">
                        Send To
                        <span className="text-red-400 justify start"> *</span>
                      </div>
                      <div id={errors.hirManager && "error"}>
                        <div className="filter-container text-[14px]">
                          <Select
                            className=""
                            isClearable={true}
                            options={
                              companyDetails.offerApproval
                                ? [...allUsers]
                                  .filter((user) => user.salary_approver)
                                  .map((user) => ({
                                    value: user.uuid,
                                    label: user.name,
                                  }))
                                : userLabels
                            }
                            value={hirManager}
                            placeholder={
                              companyDetails.offerApproval
                                ? "Select Approver"
                                : "Select Hiring Manager"
                            }
                            onChange={(newValue) => setHirManager(newValue)}
                          ></Select>
                        </div>
                        {errors.hirManager && (
                          <div className="text-[#F7284A] mt-[6px] text-[12px]">
                            {errors.hirManager}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className=" text-[14px] mb-[20px]">
                      <div className="  mb-1 font-semibold">
                        Salary Proposal
                        <span className="text-red-400 justify start"> *</span>
                      </div>
                      <div className="border border-[#D2D4DA] rounded-[4px] mb-[20px] p-[2px]">
                        {companyDetails?.from_acfl ? (
                          <div className="p-4 grid grid-cols-2 gap-x-8 gap-y-4 bg-gray-50/30">
                            {acflFields.map((field, idx) => {
                              if (field.visible && !field.visible(proposal[1]))
                                return null;
                              return (
                                <div
                                  key={idx}
                                  className={`${field.fullWidth
                                    ? "col-span-2"
                                    : "col-span-1"
                                    } flex flex-col`}
                                >
                                  <label className="text-[12px] font-bold mb-1 uppercase text-gray-700">
                                    {field.label}
                                  </label>
                                  <div
                                    className={`flex items-center border border-[#D2D4DA] rounded p-2 mt-0.5 shadow-sm transition-all ${field.highlight
                                      ? "bg-[#FFFF00] border-yellow-400"
                                      : "bg-white"
                                      }`}
                                  >
                                    {field.prefix && (
                                      <span className="mr-1 font-semibold text-gray-600">
                                        {field.prefix}
                                      </span>
                                    )}
                                    {field.type === "textarea" ? (
                                      <textarea
                                        className="w-full bg-transparent outline-none resize-none text-[14px] leading-relaxed"
                                        name={field.name}
                                        value={proposal[1][field.name]}
                                        onChange={(e) => handleChange(1, e)}
                                        rows={3}
                                      />
                                    ) : field.type === "select" ? (
                                      <select
                                        className="w-full bg-transparent outline-none text-[14px] font-medium"
                                        name={field.name}
                                        value={proposal[1][field.name]}
                                        onChange={(e) => handleChange(1, e)}
                                      >
                                        <option value="" disabled>
                                          Select {field.label}
                                        </option>
                                        {field.options.map((opt, oIdx) => (
                                          <option key={oIdx} value={opt}>
                                            {opt}
                                          </option>
                                        ))}
                                      </select>
                                    ) : (
                                      <input
                                        type={field.type || "text"}
                                        className="w-full bg-transparent outline-none text-[14px] font-medium"
                                        name={field.name}
                                        value={proposal[1][field.name]}
                                        onChange={(e) => handleChange(1, e)}
                                        placeholder={field.placeholder || ""}
                                        readOnly={field.readOnly}
                                      />
                                    )}
                                    {field.suffix && (
                                      <span className="ml-1 font-semibold text-gray-600">
                                        {field.suffix}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <Table className="w-full">
                            <Thead>
                              <Tr className="text-right">
                                <Th className="w-1/3"></Th>
                                <Th className="w-1/3 px-[20px] py-4">
                                  Current
                                </Th>
                                <Th className="w-1/3 px-[20px] py-4">
                                  Proposed
                                </Th>
                              </Tr>
                            </Thead>

                            <Tbody>
                              {/* Total Fixed Pay */}
                              <Tr>
                                <Td className="px-[20px] py-3">
                                  Total Fixed Pay
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    className="w-full border-[#D2D4DA] p-[10px] border rounded text-right"
                                    name="totalfixedpay"
                                    value={proposal[0]["totalfixedpay"]}
                                    onChange={(e) => handleChange(0, e)}
                                    type="number"
                                    min="0"
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    onWheel={(e) => e.target.blur()}
                                  />
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    className="w-full border-[#D2D4DA] p-[10px] border rounded text-right"
                                    name="totalfixedpay"
                                    value={proposal[1]["totalfixedpay"]}
                                    onChange={(e) => handleChange(1, e)}
                                    type="number"
                                    min="0"
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    onWheel={(e) => e.target.blur()}
                                  />
                                </Td>
                              </Tr>

                              {/* Conditional rows */}
                              {salaryFields.map((field, idx) => (
                                <Tr key={idx}>
                                  <Td className="px-[20px] py-3">
                                    {field.label}
                                  </Td>
                                  <Td className="p-[2px]">
                                    <input
                                      className="w-full border-[#D2D4DA] p-[10px] border rounded text-right"
                                      name={field.name}
                                      value={proposal[0][field.name]}
                                      onChange={(e) => handleChange(0, e)}
                                    />
                                  </Td>
                                  <Td className="p-[2px]">
                                    <input
                                      className="w-full border-[#D2D4DA] p-[10px] border rounded text-right"
                                      name={field.name}
                                      value={proposal[1][field.name]}
                                      onChange={(e) => handleChange(1, e)}
                                    />
                                  </Td>
                                </Tr>
                              ))}

                              {/* Empty row */}
                              <Tr>
                                <Td className="px-[20px] py-3"></Td>
                                <Td className="p-[2px]">
                                  <input
                                    value=""
                                    className="w-full p-[10px] border border-[#D2D4DA] rounded text-right"
                                  />
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    value=""
                                    className="w-full p-[10px] border border-[#D2D4DA] rounded text-right"
                                  />
                                </Td>
                              </Tr>

                              {/* {companyDetails?.salaryDetail?"CTC":"Total Compensation"} */}
                              <Tr>
                                <Td className="px-[20px] font-semibold py-3">
                                  {companyDetails?.salaryDetail
                                    ? "CTC"
                                    : "Total Compensation"}
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    readOnly
                                    className="w-full p-[10px] font-semibold border border-[#D2D4DA] rounded text-right bg-gray-50"
                                    value={currentTotalComp()}
                                  />
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    readOnly
                                    className="w-full p-[10px] font-semibold border border-[#D2D4DA] rounded text-right bg-gray-50"
                                    value={proposedTotalComp()}
                                  />
                                </Td>
                              </Tr>

                              {/* %{companyDetails?.salaryDetail?" increase on Total Fixed Pay":" increase on CTC"} */}
                              <Tr>
                                <Td className="px-[20px] py-3">
                                  %
                                  {companyDetails?.salaryDetail
                                    ? " increase on Total Fixed Pay"
                                    : " increase on CTC"}
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    className="w-full p-[10px] border rounded border-[#D2D4DA] text-right"
                                    name="increaseonctc"
                                    value={increaseOnCtc()}
                                    onChange={(e) => handleChange(0, e)}
                                    type="number"
                                    min="0"
                                    onKeyDown={(e) =>
                                      ["e", "E", "+"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    onWheel={(e) => e.target.blur()}
                                  />
                                </Td>
                              </Tr>

                              {/* % {companyDetails?.salaryDetail?"increase on CTC":"increase on TC"} */}
                              <Tr>
                                <Td className="px-[20px] py-3">
                                  %{" "}
                                  {companyDetails?.salaryDetail
                                    ? "increase on CTC"
                                    : "increase on TC"}
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    className="w-full p-[10px] border border-[#D2D4DA] rounded text-right"
                                    name="increaseontc"
                                    value={increaseOnTc()}
                                    onChange={(e) => handleChange(0, e)}
                                    type="number"
                                    min="0"
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    onWheel={(e) => e.target.blur()}
                                  />
                                </Td>
                              </Tr>
                            </Tbody>
                          </Table>
                        )}
                        {errors.proposal && (
                          <div className="text-[#F7284A] mt-[6px] text-[12px]">
                            {errors.proposal}
                          </div>
                        )}
                      </div>
                      <div className=" text-[14px] mb-[20px]">
                        <div className="  mb-1 font-semibold">
                          Justification
                          <span className="text-red-400 justify start"> *</span>
                        </div>
                        <div>
                          <textarea
                            className="w-full p-[8px] border border-[#D2D4DA] rounded-[4px]"
                            placeholder="Justify your reason here.."
                            value={justification}
                            rows={4}
                            onChange={(e) => {
                              setJustification(e.target.value);
                            }}
                          ></textarea>
                          {errors.justification && (
                            <div className="text-[#F7284A] mt-[2px] text-[12px]">
                              {errors.justification}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className=" text-[14px] ">
                        <div className="  mb-2 font-semibold">
                          Email Customization
                        </div>
                        <div className="mb-[20px]">
                          <p className="mb-1 font-medium">Subject</p>
                          <input
                            placeholder="Subject"
                            value={salarysubject}
                            onChange={(e) => {
                              setSalarySubject(e.target.value);
                            }}
                            className="custom-placeholder text-[14px] w-full border  py-1 rounded-[4px]  h-[32px] px-2  border-[#D2D4DA] font-semibold text-[black] "
                            type="text"
                          ></input>
                        </div>

                        <div className=" text-[14px] mb-[20px]">
                          <div className="  mb-[6px] font-semibold">
                            Email Body
                          </div>
                          <div>
                            <ReactQuill
                              value={salarybody}
                              onChange={setSalaryBody}
                              rows="3"
                              theme="snow"
                              className="w-full"
                            />
                            {/* <ReactQuill
                  value={body}
                  onChange={setBody}
                  rows="3"
                  theme="snow"
                  className="w-full "
                ></ReactQuill> */}
                          </div>
                        </div>
                      </div>
                      <div className="">
                        <div className="  mb-[6px] font-semibold">
                          Attachments
                        </div>
                        <div className="flex items-center border pl-2 border-[#D2D4DA] rounded-[4px] ">
                          <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            className=" w-full h-full inputFile"
                          />
                          <button className="bg-light-blue whitespace-nowrap text-white px-4 p-2 ml-2">
                            Attach file
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/2 rounded-tr-lg">
                    <div className="p-6 pt-[20px] bg-[#F1F4FB] h-full flex flex-col    text-[12px]">
                      <h2 className="text-[14px] font-semibold mb-2">
                        Email Preview
                      </h2>
                      <div className="bg-white p-[12px] flex-1  pb-0 border border-[#D2D4DA] rounded-[8px]">
                        <div className="p-1">
                          <div className="mb-[6px] text-[14px] font-medium leading-4">
                            <div className="py-1 text-[14px] mb-3">
                              Subject: {previewSalarySubject}
                            </div>
                          </div>
                          <div className="mb-[6px] text-[#444D63] ">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: previewSalaryBody,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="border-[#E9EBFA] w-full border"></div>
                  <div className="p-6 flex justify-between bg-white rounded-b-xl">
                    <div className="flex gap-4 ">
                      <div
                        onClick={() => {
                          setConfirmationModal("cancel");
                        }}
                      >
                        <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                          Cancel
                        </ButtonHollowXs>
                      </div>
                      <div
                        onClick={() => {
                          createSalaryProposal("Draft");
                          toast.success(
                            "Draft of the salary proposal email has been saved.",
                            { icon: <ToastIcon /> },
                          );
                          setTab("candidate");
                          setIsSubmitted(false);
                          setTemplateType();
                          setHirManager();
                          setJustification("");
                          setErrors({});
                        }}
                      >
                        <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                          Save As Draft
                        </ButtonHollowXs>
                      </div>
                    </div>
                    <div
                      onClick={() => {
                        setFormType("salaryProposalForm");
                        setIsSubmitted(true);
                        const isValid = validate("salaryProposalForm");
                        if (isValid) {
                          createSalaryProposal("Approval Pending");
                          toast.success(
                            companyDetails.offerApproval
                              ? "Email to approve salary proposal has been sent to the approver."
                              : "Email to approve salary proposal has been sent to the hiring manager.",
                            { icon: <ToastIcon /> },
                          );
                          statusUpdate(
                            "Salary Proposal Pending Approval",
                            "candidate",
                          );
                          setIsSubmitted(false);
                          setTemplateType("");
                          setHirManager();
                          setJustification("");
                          setErrors({});
                        }
                        else {
                          alert("Please fill all the required fields")
                        }
                      }}
                    >
                      <ButtonXs text="#FFFFFF" color="#148EFF">
                        Send Proposal for Approval
                      </ButtonXs>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {tab == "draft" && (
            <div>
              <div className="mb-8  flex items-center">
                <img
                  onClick={() => {
                    setConfirmationModal("back");
                  }}
                  src={arrowleft}
                  className="w-[40px] cursor-pointer h-[40px] mr-4"
                  alt="back button"
                />
                <h2 className="font-medium text-[28px]">
                  Salary Proposal Creation
                </h2>
              </div>
              <div className="flex flex-col shadow-custom-shadow rounded-xl">
                <div className="flex w-full  rounded-lg ">
                  <div className="w-1/2 pt-[20px] pb-[4px] px-6 rounded-tl-xl  bg-white  ">
                    <div className="text-[14px] mb-[20px]">
                      <div className="  mb-1  font-semibold">
                        Email Template
                        <span className="text-red-400 justify start"> *</span>
                      </div>
                      <div id={errors.templateType && "error"}>
                        <div className="filter-container text-[14px]">
                          <Select
                            isClearable
                            options={salaryTemplatesOptions}
                            placeholder="Select salary template"
                            value={selectedSalaryTemplate}
                            defaultValue={
                              salaryTemplatesOptions.find(
                                (o) => o.label === "Offer",
                              ) ?? null
                            }
                            onChange={(newValue) => {
                              setTemplateType(newValue);
                              handleSalaryChangeEmailTemplate(newValue);
                              setSelectedSalaryTemplate(newValue);
                            }}
                          />
                        </div>
                        {errors.templateType && (
                          <div className="text-[#F7284A] mt-[6px] text-[12px]">
                            {errors.templateType}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className=" text-[14px] mb-[24px]">
                      <div className="  mb-1 font-semibold">
                        Send To
                        <span className="text-red-400 justify start"> *</span>
                      </div>
                      <div id={errors.hirManager && "error"}>
                        <div className="filter-container text-[14px]">
                          <Select
                            className=""
                            isClearable={true}
                            options={
                              companyDetails.offerApproval
                                ? [...allUsers]
                                  .filter((user) => user.salary_approver)
                                  .map((user) => ({
                                    value: user.uuid,
                                    label: user.name,
                                  }))
                                : userLabels
                            }
                            value={hirManager}
                            placeholder={
                              companyDetails.offerApproval
                                ? "Select Approver"
                                : "Select Hiring Manager"
                            }
                            onChange={(newValue) => setHirManager(newValue)}
                          ></Select>
                        </div>
                        {errors.hirManager && (
                          <div className="text-[#F7284A] mt-[6px] text-[12px]">
                            {errors.hirManager}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className=" text-[14px] mb-[20px]">
                      <div className="  mb-1 font-semibold">
                        Salary Proposal
                        <span className="text-red-400 justify start"> *</span>
                      </div>
                      <div className="border border-[#D2D4DA] rounded-[4px] mb-[20px] p-[2px]">
                        {companyDetails?.from_acfl ? (
                          <div className="p-4 grid grid-cols-2 gap-x-8 gap-y-4 bg-gray-50/30">
                            {acflFields.map((field, idx) => {
                              if (field.visible && !field.visible(proposal[1]))
                                return null;
                              return (
                                <div
                                  key={idx}
                                  className={`${field.fullWidth
                                    ? "col-span-2"
                                    : "col-span-1"
                                    } flex flex-col`}
                                >
                                  <label className="text-[12px] font-bold mb-1 uppercase text-gray-700">
                                    {field.label}
                                  </label>
                                  <div
                                    className={`flex items-center border border-[#D2D4DA] rounded p-2 mt-0.5 shadow-sm transition-all ${field.highlight
                                      ? "bg-[#FFFF00] border-yellow-400"
                                      : "bg-white"
                                      }`}
                                  >
                                    {field.prefix && (
                                      <span className="mr-1 font-semibold text-gray-600">
                                        {field.prefix}
                                      </span>
                                    )}
                                    {field.type === "textarea" ? (
                                      <textarea
                                        className="w-full bg-transparent outline-none resize-none text-[14px] leading-relaxed"
                                        name={field.name}
                                        value={proposal[1][field.name]}
                                        onChange={(e) => handleChange(1, e)}
                                        rows={3}
                                      />
                                    ) : field.type === "select" ? (
                                      <select
                                        className="w-full bg-transparent outline-none text-[14px] font-medium"
                                        name={field.name}
                                        value={proposal[1][field.name]}
                                        onChange={(e) => handleChange(1, e)}
                                      >
                                        <option value="" disabled>
                                          Select {field.label}
                                        </option>
                                        {field.options.map((opt, oIdx) => (
                                          <option key={oIdx} value={opt}>
                                            {opt}
                                          </option>
                                        ))}
                                      </select>
                                    ) : (
                                      <input
                                        type={field.type || "text"}
                                        className="w-full bg-transparent outline-none text-[14px] font-medium"
                                        name={field.name}
                                        value={proposal[1][field.name]}
                                        onChange={(e) => handleChange(1, e)}
                                        placeholder={field.placeholder || ""}
                                        readOnly={field.readOnly}
                                      />
                                    )}
                                    {field.suffix && (
                                      <span className="ml-1 font-semibold text-gray-600">
                                        {field.suffix}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <Table className="w-full">
                            <Thead>
                              <Tr className="text-right">
                                <Th className="w-1/3"></Th>
                                <Th className="w-1/3 px-[20px] py-4">
                                  Current
                                </Th>
                                <Th className="w-1/3 px-[20px] py-4">
                                  Proposed
                                </Th>
                              </Tr>
                            </Thead>

                            <Tbody>
                              {/* Total Fixed Pay */}
                              <Tr>
                                <Td className="px-[20px] py-3">
                                  Total Fixed Pay
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    className="w-full border-[#D2D4DA] p-[10px] border rounded text-right"
                                    name="totalfixedpay"
                                    value={proposal[0]["totalfixedpay"]}
                                    onChange={(e) => handleChange(0, e)}
                                    type="number"
                                    min="0"
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    onWheel={(e) => e.target.blur()}
                                  />
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    className="w-full border-[#D2D4DA] p-[10px] border rounded text-right"
                                    name="totalfixedpay"
                                    value={proposal[1]["totalfixedpay"]}
                                    onChange={(e) => handleChange(1, e)}
                                    type="number"
                                    min="0"
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    onWheel={(e) => e.target.blur()}
                                  />
                                </Td>
                              </Tr>

                              {/* Conditional rows */}
                              {salaryFields.map((field, idx) => (
                                <Tr key={idx}>
                                  <Td className="px-[20px] py-3">
                                    {field.label}
                                  </Td>
                                  <Td className="p-[2px]">
                                    <input
                                      className="w-full border-[#D2D4DA] p-[10px] border rounded text-right"
                                      name={field.name}
                                      value={proposal[0][field.name]}
                                      onChange={(e) => handleChange(0, e)}
                                      type="number"
                                      min="0"
                                      onKeyDown={(e) =>
                                        ["e", "E", "+", "-"].includes(e.key) &&
                                        e.preventDefault()
                                      }
                                      onWheel={(e) => e.target.blur()}
                                    />
                                  </Td>
                                  <Td className="p-[2px]">
                                    <input
                                      className="w-full border-[#D2D4DA] p-[10px] border rounded text-right"
                                      name={field.name}
                                      value={proposal[1][field.name]}
                                      onChange={(e) => handleChange(1, e)}
                                      type="number"
                                      min="0"
                                      onKeyDown={(e) =>
                                        ["e", "E", "+", "-"].includes(e.key) &&
                                        e.preventDefault()
                                      }
                                      onWheel={(e) => e.target.blur()}
                                    />
                                  </Td>
                                </Tr>
                              ))}

                              {/* Empty row */}
                              <Tr>
                                <Td className="px-[20px] py-3"></Td>
                                <Td className="p-[2px]">
                                  <input
                                    value=""
                                    className="w-full p-[10px] border border-[#D2D4DA] rounded text-right"
                                  />
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    value=""
                                    className="w-full p-[10px] border border-[#D2D4DA] rounded text-right"
                                  />
                                </Td>
                              </Tr>

                              {/* {companyDetails?.salaryDetail?"CTC":"Total Compensation"} */}
                              <Tr>
                                <Td className="px-[20px] font-semibold py-3">
                                  {companyDetails?.salaryDetail
                                    ? "CTC"
                                    : "Total Compensation"}
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    readOnly
                                    className="w-full p-[10px] font-semibold border border-[#D2D4DA] rounded text-right bg-gray-50"
                                    value={currentTotalComp()}
                                  />
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    readOnly
                                    className="w-full p-[10px] font-semibold border border-[#D2D4DA] rounded text-right bg-gray-50"
                                    value={proposedTotalComp()}
                                  />
                                </Td>
                              </Tr>

                              {/* %{companyDetails?.salaryDetail?" increase on Total Fixed Pay":" increase on CTC"} */}
                              <Tr>
                                <Td className="px-[20px] py-3">
                                  %
                                  {!companyDetails?.salaryDetail
                                    ? " increase on Total Fixed Pay"
                                    : " increase on CTC"}
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    className="w-full p-[10px] border rounded border-[#D2D4DA] text-right"
                                    name="increaseonctc"
                                    value={increaseOnCtc()}
                                    onChange={(e) => handleChange(0, e)}
                                    type="number"
                                    min="0"
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    onWheel={(e) => e.target.blur()}
                                  />
                                </Td>
                              </Tr>

                              {/* % {companyDetails?.salaryDetail?"increase on CTC":"increase on TC"} */}
                              <Tr>
                                <Td className="px-[20px] py-3">
                                  %{" "}
                                  {companyDetails?.salaryDetail
                                    ? "increase on CTC"
                                    : "increase on TC"}
                                </Td>
                                <Td className="p-[2px]">
                                  <input
                                    className="w-full p-[10px] border border-[#D2D4DA] rounded text-right"
                                    name="increaseontc"
                                    value={increaseOnTc()}
                                    onChange={(e) => handleChange(0, e)}
                                    type="number"
                                    min="0"
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    onWheel={(e) => e.target.blur()}
                                  />
                                </Td>
                              </Tr>
                            </Tbody>
                          </Table>
                        )}
                        {errors.proposal && (
                          <div className="text-[#F7284A] mt-[6px] text-[12px]">
                            {errors.proposal}
                          </div>
                        )}
                      </div>
                      <div className=" text-[14px] mb-[20px]">
                        <div className="  mb-1 font-semibold">
                          Justification
                          <span className="text-red-400 justify start"> *</span>
                        </div>
                        <div>
                          <textarea
                            className="w-full p-[8px] border border-[#D2D4DA] rounded-[4px]"
                            placeholder="Justify your reason here.."
                            value={justification}
                            rows={4}
                            onChange={(e) => {
                              setJustification(e.target.value);
                            }}
                          ></textarea>
                          {errors.justification && (
                            <div className="text-[#F7284A] mt-[2px] text-[12px]">
                              {errors.justification}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className=" text-[14px] ">
                        <div className="  mb-2 font-semibold">
                          Email Customization
                        </div>
                        <div className="mb-[20px]">
                          <p className="mb-1 font-medium">Subject</p>
                          <input
                            placeholder="Subject"
                            value={salarysubject}
                            onChange={(e) => {
                              setSalarySubject(e.target.value);
                            }}
                            className="custom-placeholder text-[14px] w-full border  py-1 rounded-[4px]  h-[32px] px-2  border-[#D2D4DA] font-semibold text-[black] "
                            type="text"
                          ></input>
                        </div>

                        <div className=" text-[14px] mb-[20px]">
                          <div className="  mb-[6px] font-semibold">
                            Email Body
                          </div>
                          <div>
                            <ReactQuill
                              value={salarybody}
                              onChange={setSalaryBody}
                              rows="3"
                              theme="snow"
                              className="w-full"
                            />
                            {/* <ReactQuill
                  value={body}
                  onChange={setBody}
                  rows="3"
                  theme="snow"
                  className="w-full "
                ></ReactQuill> */}
                          </div>
                        </div>
                      </div>
                      <div className="">
                        <div className="  mb-[6px] font-semibold">
                          Attachments
                        </div>
                        <div className="flex items-center border pl-2 border-[#D2D4DA] rounded-[4px] ">
                          <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            className=" w-full h-full inputFile"
                          />
                          <button className="bg-light-blue whitespace-nowrap text-white px-4 p-2 ml-2">
                            Attach file
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/2 rounded-tr-lg">
                    <div className="p-6 pt-[20px] bg-[#F1F4FB] h-full flex flex-col    text-[12px]">
                      <h2 className="text-[14px] font-semibold mb-2">
                        Email Preview
                      </h2>
                      <div className="bg-white p-[12px] flex-1  pb-0 border border-[#D2D4DA] rounded-[8px]">
                        <div className="p-1">
                          <div className="mb-[6px] text-[14px] font-medium leading-4">
                            <div className="py-1 text-[14px] mb-3">
                              Subject: {previewSalarySubject}
                            </div>
                          </div>
                          <div className="mb-[6px] text-[#444D63] ">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: previewSalaryBody,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="border-[#E9EBFA] w-full border"></div>
                  <div className="p-6 flex justify-between bg-white rounded-b-xl">
                    <div className="flex gap-4 ">
                      <div onClick={() => setConfirmationModal("reset")}>
                        <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                          Reset
                        </ButtonHollowXs>
                      </div>
                      <div
                        onClick={() => {
                          updateSalaryProposalDraft("Draft");
                          toast.success(
                            "Draft of the salary proposal email has been saved.",
                            { icon: <ToastIcon /> },
                          );
                          setTab("candidate");
                        }}
                      >
                        <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                          Save As Draft
                        </ButtonHollowXs>
                      </div>
                    </div>
                    <div
                      onClick={() => {
                        setFormType("salaryProposalForm");
                        setIsSubmitted(true);
                        const isValid = validate("salaryProposalForm");
                        if (isValid) {
                          if (activeProposalStatus == "Draft") {
                            updateSalaryProposalDraft("Approval Pending");
                          } else {
                            createSalaryProposal("Approval Pending");
                          }
                          toast.success(
                            "Email to approve salary proposal has been sent to the hiring manager.",
                            { icon: <ToastIcon /> },
                          );
                          setTab("candidate");

                          setTab("candidate");
                          setIsSubmitted(false);
                          setTemplateType("");
                          setHirManager();
                          setJustification("");
                          setErrors({});
                        }
                      }}
                    >
                      <ButtonXs text="#FFFFFF" color="#148EFF">
                        Send Proposal for Approval
                      </ButtonXs>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {tab == "feedback" && (
            <div>
              <div className="mb-8  flex items-center">
                <img
                  onClick={() => {
                    setTab("candidate");
                  }}
                  src={arrowleft}
                  className="w-[40px] cursor-pointer h-[40px] mr-4"
                  alt="back button"
                />
                <h2 className="font-medium text-[28px]">
                  Salary Proposal Feedback
                </h2>
              </div>
              <div className="flex shadow-custom-shadow flex-col rounded-xl ">
                <div className="flex w-full rounded-t-xl bg-white flex-col  p-4 ">
                  {activeProposalStatus == "Approved" && (
                    <div className="px-6 py-4 text-[14px] font-medium bg-[#CFF5EA] rounded-lg mb-4">
                      This Salary Proposal has been approved by{" "}
                      {hiringManagers.find((p) => p.value === hiringManagerId)
                        ?.label || "Not Found"}
                      .
                    </div>
                  )}
                  <div
                    className="border w-full text-[14px] p-4 border-[#D2D4DA] rounded-lg mb-4 "
                    ref={pdfgeneration}
                  >
                    <div className="mb-[6px] text-[#444D63]">
                      <p>
                        <span className="text-[#161A21] font-medium mb-[6px]">
                          Candidate Name:{" "}
                        </span>

                        {applicant.name ? applicant.name : "[Candidate Name]"}
                      </p>
                    </div>
                    <div className="mb-[6px] text-[#444D63] ">
                      <p>
                        <span className="text-[#161A21] font-medium mb-[6px]">
                          Job Title:{" "}
                        </span>
                        {jobDetails.profilename
                          ? jobDetails.profilename
                          : "[Job Title]"}
                      </p>
                    </div>
                    <div className="px-[6px] mb-[6px] py-[12px] ">
                      <p className="mb-[10px] font-medium leading-[21px]">
                        Salary Distribution
                      </p>
                      {companyDetails?.from_acfl ? (
                        <div className="p-4 grid grid-cols-2 gap-x-8 gap-y-4 bg-gray-50/30 border border-[#D2D4DA] rounded-lg">
                          {acflFields.map((field, idx) => {
                            if (field.visible && !field.visible(proposal[1]))
                              return null;
                            return (
                              <div
                                key={idx}
                                className={`${field.fullWidth ? "col-span-2" : "col-span-1"
                                  } flex flex-col`}
                              >
                                <label className="text-[12px] font-bold mb-1 uppercase text-gray-700">
                                  {field.label}
                                </label>
                                <div
                                  className={`flex items-center border border-[#D2D4DA] rounded p-2 mt-0.5 shadow-sm transition-all ${field.highlight
                                    ? "bg-[#FFFF00] border-yellow-400"
                                    : "bg-white"
                                    }`}
                                >
                                  {field.prefix && (
                                    <span className="mr-1 font-semibold text-gray-600">
                                      {field.prefix}
                                    </span>
                                  )}
                                  <div className="w-full bg-transparent outline-none text-[14px] font-medium py-1">
                                    {proposal[1][field.name] || "-"}
                                  </div>
                                  {field.suffix && (
                                    <span className="ml-1 font-semibold text-gray-600">
                                      {field.suffix}
                                    </span>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <Table className="w-full border border-[#D2D4DA] text-[12px]">
                          <Thead>
                            <Tr className="text-right">
                              <Th className="w-1/3 p-[9px] border"></Th>
                              <Th className="w-1/3 p-[9px] border">
                                Current Salary
                              </Th>
                              <Th className="w-1/3 p-[9px] border">
                                Proposed Salary
                              </Th>
                            </Tr>
                          </Thead>

                          <Tbody>
                            {/* Total Fixed Pay */}
                            <Tr>
                              <Td className="p-[9px] border">
                                Total Fixed Pay
                              </Td>
                              <Td className="p-[9px] border text-right">
                                {renderValue(proposal[0].totalfixedpay)}
                              </Td>
                              <Td className="p-[9px] border text-right">
                                {renderValue(proposal[1].totalfixedpay)}
                              </Td>
                            </Tr>

                            {/* Conditional rows */}
                            {companyDetails?.salaryDetail ? <>
                              <Tr>
                                <Td className="p-[9px] border">
                                  Medical/Life Insurance Premium
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(
                                    proposal[0].medicallifeinsurance,
                                  )}
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(
                                    proposal[1].medicallifeinsurance,
                                  )}
                                </Td>
                              </Tr>
                              <Tr>
                                <Td className="p-[9px] border">
                                  Joining/Relocation Bonus
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[0].relocationbonus)}
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[1].relocationbonus)}
                                </Td>
                              </Tr>
                              <Tr>
                                <Td className="p-[9px] border">
                                  ⁠⁠Performance/Sprint Bonus
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[0].sprintbonus)}
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[1].sprintbonus)}
                                </Td>
                              </Tr>
                            </> : <>
                              <Tr>
                                <Td className="p-[9px] border">
                                  Variable Pay
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[0].variablepay)}
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[1].variablepay)}
                                </Td>
                              </Tr>
                              <Tr>
                                <Td className="p-[9px] border">ESOP</Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[0].esop)}
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[1].esop)}
                                </Td>
                              </Tr>
                              <Tr>
                                <Td className="p-[9px] border">
                                  ESOP Value
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[0].esopvalue)}
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[1].esopvalue)}
                                </Td>
                              </Tr>
                            </>}

                            {/* Separator row */}
                            <Tr>
                              <Td className="p-[9px] border">-</Td>
                              <Td className="p-[9px] border text-right">-</Td>
                              <Td className="p-[9px] border text-right">-</Td>
                            </Tr>

                            {/* {companyDetails?.salaryDetail?"CTC":"Total Compensation"} */}
                            <Tr className="font-bold">
                              <Td className="p-[9px] border">
                                {!companyDetails?.salaryDetail
                                  ? "CTC"
                                  : "Total Compensation"}
                              </Td>
                              <Td className="p-[9px] border text-right">
                                {renderValue(
                                  companyDetails?.salaryDetail
                                    ? parseNumber(proposal[0].totalfixedpay) +
                                    parseNumber(
                                      proposal[0].medicallifeinsurance,
                                    ) +
                                    parseNumber(
                                      proposal[0].relocationbonus,
                                    ) +
                                    parseNumber(proposal[0].sprintbonus)
                                    : parseNumber(proposal[0].totalfixedpay) +
                                    parseNumber(proposal[0].variablepay) +
                                    parseNumber(proposal[0].esopvalue),
                                )}
                              </Td>
                              <Td className="p-[9px] border text-right">
                                {renderValue(
                                  companyDetails?.salaryDetail
                                    ? parseNumber(proposal[1].totalfixedpay) +
                                    parseNumber(
                                      proposal[1].medicallifeinsurance,
                                    ) +
                                    parseNumber(
                                      proposal[1].relocationbonus,
                                    ) +
                                    parseNumber(proposal[1].sprintbonus)
                                    : parseNumber(proposal[1].totalfixedpay) +
                                    parseNumber(proposal[1].variablepay) +
                                    parseNumber(proposal[1].esopvalue),
                                )}
                              </Td>
                            </Tr>

                            {/* %{companyDetails?.salaryDetail?" increase on Total Fixed Pay":" increase on CTC"} */}
                            <Tr>
                              <Td className="p-[9px] border">
                                %
                                {companyDetails?.salaryDetail
                                  ? " increase on Total Fixed Pay"
                                  : " increase on CTC"}
                              </Td>
                              <Td className="p-[9px] border text-right">
                                {renderValue("")}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {" "}
                                {renderValue(increaseOnCtc())}
                              </Td>
                            </Tr>

                            {/* % {companyDetails?.salaryDetail?"increase on CTC":"increase on TC"} */}
                            <Tr>
                              <Td className="p-[9px] border">
                                %{" "}
                                {companyDetails?.salaryDetail
                                  ? "increase on CTC"
                                  : "increase on TC"}
                              </Td>
                              <Td className="p-[9px] border text-right">
                                {renderValue("")}
                              </Td>
                              <Td className="p-[9px] border text-right">
                                {" "}
                                {renderValue(increaseOnTc())}
                              </Td>
                            </Tr>
                          </Tbody>
                        </Table>
                      )}
                    </div>
                    <div>
                      <p>
                        <span className="text-[#161A21] font-medium mb-[6px]">
                          Justificaton:{" "}
                        </span>
                        {justification}
                      </p>
                      <p className="font-medium leading-[20px]">
                        {/* {proposal.} */}
                        {proposal.createdby}
                      </p>
                    </div>
                  </div>
                  {/* <div className="rejectedFeedback border border-[#D2D4DA] rounded-lg bg-[#E9EBFA]">
                    <div
                      className={`flex justify-between items-center w-full p-4  pr-[12px] bg-[#E9EBFA] rounded-t-lg ${
                        !isRejectedFeedbackOpen && "rounded-b-lg"
                      } `}
                    >
                      <h3 className="font-medium text-base">Feedback</h3>
                      <button
                        className="bg-transparent border-none text-white  "
                        onClick={toggleRejected}
                      >
                        {isRejectedFeedbackOpen ? (
                          <IoIosArrowUp className="text-[#8F94A1] w-4 h-4" />
                        ) : (
                          <IoIosArrowDown className="text-[#8F94A1] w-4 h-4" />
                        )}
                      </button>
                    </div>
                    {isRejectedFeedbackOpen && (
                      <div className="p-4 bg-white rounded-b-lg">
                        <ul className="small-bullets list-disc pl-5 leading-5 text-[14px] text-[#444D63]">
                          <li>
                            The proposed base salary aligns well with industry
                            standards and our budget.
                          </li>
                          <li>
                            Consider adding a performance bonus component to
                            make the offer more attractive.
                          </li>
                          <li>
                            The benefits package is comprehensive; however, we
                            could highlight the stock options more prominently
                            to emphasize long-term incentives.
                          </li>
                          <li>
                            Please verify if the relocation assistance mentioned
                            is sufficient given the candidate’s current
                            location.
                          </li>
                        </ul>
                      </div>
                    )}
                  </div> */}
                </div>
                <div>
                  <div className="border-[#E9EBFA] w-full border"></div>
                  <div className="p-6 flex justify-between bg-white rounded-b-xl">
                    <div className="flex gap-4 ">
                      {latestSProposalUuid &&
                        activeProposalStatus == "Approved" && (
                          <div
                            onClick={() => {
                              toast.success(
                                "Salary Proposal has been successfully downloaded.",
                                { icon: <ToastIcon /> },
                              );
                              convertToPdf();
                            }}
                          >
                            <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                              Download
                            </ButtonHollowXs>
                          </div>
                        )}
                    </div>

                    {latestSProposalUuid &&
                      activeProposalStatus == "Approved" &&
                      allOfferLetter.length == 0 ? (
                      <div
                        onClick={() => {
                          if (userPrivilege !== "Hiring Manager") {
                            setProposalFromLatest(latestSalaryProposal);
                            statusUpdate(
                              "Offer Letter In-progress",
                              "offerletter",
                            );
                          }
                        }}
                      >
                        <ButtonXs
                          text="#FFFFFF"
                          color={
                            userPrivilege === "Hiring Manager"
                              ? "#A0AEC0"
                              : "#148EFF"
                          }
                          className={
                            userPrivilege === "Hiring Manager"
                              ? "cursor-not-allowed"
                              : "cursor-pointer"
                          }
                        >
                          Create Offer Letter
                        </ButtonXs>
                      </div>
                    ) : !latestSProposalUuid ? (
                      <div className="flex gap-4">
                        <div
                          onClick={() => {
                            if (userPrivilege !== "Hiring Manager") {
                              resetProposal();
                              setJustification("");
                              setHirManager("");
                              setTemplateType("");
                              setConfirmationModal("");
                              setSubject("");
                              setBody("");
                              setTab("proposal");
                            }
                          }}
                        >
                          <ButtonXs
                            text="#FFFFFF"
                            color={
                              userPrivilege === "Hiring Manager"
                                ? "#A0AEC0"
                                : "#148EFF"
                            }
                            className={
                              userPrivilege === "Hiring Manager"
                                ? "cursor-not-allowed"
                                : "cursor-pointer"
                            }
                          >
                            Create Proposal Again
                          </ButtonXs>
                        </div>

                        {/* Show Reject + Verify only if status is Approval Pending and user is hiring manager */}
                        {activeProposalStatus === "Approval Pending" &&
                          userid === hiringManagerId && (
                            <>
                              <div className="flex gap-4 ">
                                <div
                                  onClick={() => {
                                    // updateDocumentStatus(activeDocId,"Rejected");
                                    setTab("candidate");
                                    updateSalaryProposalStatus("Rejected");
                                    removeNotification();
                                    navigate("/jobs/candidates/about", {
                                      state: { uuid: uuid },
                                    });
                                    toast.error(
                                      "Salary proposal has been rejected ",
                                      { icon: <ToastIcon /> },
                                    );
                                  }}
                                >
                                  <ButtonHollowXs
                                    text="#F7284A"
                                    color="#FFFFFF"
                                  >
                                    <CloseIcon /> Reject
                                  </ButtonHollowXs>
                                </div>
                                <div
                                  onClick={() => {
                                    setConfirmationModal("");
                                    setTab("candidate");
                                    // updateDocumentStatus(activeDocId, "Verified");
                                    removeNotification();
                                    updateSalaryProposalStatus("Approved");
                                    statusUpdate("Salary Proposal Approved");
                                    navigate("/jobs/candidates/about", {
                                      state: { uuid: uuid },
                                    });
                                    toast.success(
                                      "Salary proposal has been verified successfully ",
                                      { icon: <ToastIcon /> },
                                    );
                                  }}
                                >
                                  <ButtonXs color="#0DCD94" text="#FFFFFF">
                                    <TickIcon />
                                    Verify
                                  </ButtonXs>
                                </div>
                              </div>
                            </>
                          )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {tab == "offerletter" && (
            <div>
              <div className="mb-8  flex items-center">
                <img
                  onClick={() => {
                    setConfirmationModal("oback");
                  }}
                  src={arrowleft}
                  className="w-[40px] cursor-pointer h-[40px] mr-4"
                  alt="back button"
                />
                <h2 className="font-medium text-[28px]">
                  Offer Letter Creation
                </h2>
              </div>
              <div className="flex shadow-custom-shadow flex-col rounded-xl ">
                <div className="flex w-full rounded-t-xl bg-white flex-col  pt-[20px] p-6 ">
                  <div>
                    <div className="w-full mb-[20px]">
                      <p className="font-semibold text-sm mb-1 ">
                        Template <span className="text-red-400">*</span>
                      </p>
                      <div id={errors.templateType && "error"}>
                        <div className="filter-container">
                          <Select
                            value={offerLetterTemplate}
                            className="text-[14px] "
                            menuPlacement="bottom"
                            options={emailTemplateOptions}
                            placeholder="Select Template"
                            onChange={(newValue) =>
                              setOfferLetterTemplate(newValue)
                            }
                          ></Select>
                        </div>
                        {errors.templateType && (
                          <div className="text-[#F7284A] mt-[6px] text-[12px]">
                            {errors.templateType}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-full mb-[20px]">
                      <p className="font-semibold text-sm mb-1 ">
                        Job Title <span className="text-red-400">*</span>
                      </p>
                      <input
                        placeholder="Enter Job Title"
                        value={jobDetails.profilename}
                        className="custom-placeholder text-[14px] w-full border  py-1 rounded-[4px]  h-[37px] px-2  border-[#D2D4DA]  text-black "
                        type="text"
                      ></input>
                    </div>
                    <div className="w-full mb-[20px] text-[14px]">
                      <div className="w-full flex gap-6 ">
                        <div className="w-1/2">
                          <div className="mb-1 font-medium">
                            Joining Date{" "}
                            <span className="text-red-400 justify start">
                              *
                            </span>
                          </div>
                          <div className="w-full">
                            <ModernDatePicker
                              value={joiningDate}
                              onChange={handleJoiningDateChange}
                              minDate={new Date()}
                              placeholder="Select Date"
                            />
                            {errors.joiningDate && (
                              <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                {errors.joiningDate}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="w-1/2">
                          <div className="mb-1 font-medium">
                            Offer Valid till{" "}
                            <span className="text-red-400 justify start">
                              *
                            </span>
                          </div>
                          <div className="w-full">
                            {companyDetails?.from_acfl ? (
                              <input
                                value={
                                  expiryDate
                                    ? new Date(expiryDate)
                                      .toLocaleDateString("en-GB")
                                      .replace(/\//g, "-")
                                    : ""
                                }
                                disabled
                                className="w-full h-11 px-3 border border-[#e2e8f0] bg-gray-100 text-[#8f94a1] rounded-[10px] text-[14px]"
                              />
                            ) : (
                              <ModernDatePicker
                                value={expiryDate}
                                onChange={handleExpiryDateChange}
                                minDate={new Date()}
                                placeholder="Select Date"
                              />
                            )}
                            {errors.expiryDate && (
                              <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                {errors.expiryDate}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full mb-[20px]">
                      <p className="font-semibold text-sm mb-1 ">
                        Candidate Address{" "}
                        <span className="text-red-400">*</span>
                      </p>
                      <div className="addressLine flex gap-3 mb-3">
                        <div className="w-1/2">
                          <input
                            placeholder={isGB ? "Address Line 1" : "Address Line 1"}
                            value={add1}
                            className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.add1
                              ? "border-[#F7284A]"
                              : "border-[#D2D4DA]"
                              } text-black`}
                            type="text"
                            onChange={(e) => {
                              setAdd1(e.target.value);
                            }}
                          />
                          {errors.add1 && (
                            <div className="text-[#F7284A] mt-[6px] text-[12px]">
                              {errors.add1}
                            </div>
                          )}
                        </div>
                        {/* change here */}
                        <div className="w-1/2">
                          <input
                            placeholder={isGB ? "Address Line 2 (Optional)" : "Address Line 2"}
                            value={add2}
                            className={`text-[14px] custom-placeholder w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.add2
                              ? "border-[#F7284A]"
                              : "border-[#D2D4DA]"
                              } text-black`}
                            type="text"
                            onChange={(e) => {
                              setAdd2(e.target.value);
                            }}
                          />
                          {errors.add2 && (
                            <div className="text-[#F7284A] mt-[6px] text-[12px]">
                              {errors.add2}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="addressLine2 flex gap-3">
                        {isGB ? (
                          <>
                            <div className="w-1/4">
                              <input
                                placeholder="Locality Name (Optional)"
                                value={state}
                                className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.state
                                  ? "border-[#F7284A]"
                                  : "border-[#D2D4DA]"
                                  } text-black`}
                                type="text"
                                onChange={(e) => {
                                  setState(e.target.value);
                                }}
                              />
                              {errors.state && (
                                <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                  {errors.state}
                                </div>
                              )}
                            </div>
                            <div className="w-1/4">
                              <input
                                placeholder="Town or City"
                                value={city}
                                className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.city
                                  ? "border-[#F7284A]"
                                  : "border-[#D2D4DA]"
                                  } text-black`}
                                type="text"
                                onChange={(e) => {
                                  setCity(e.target.value.toUpperCase());
                                }}
                              />
                              {errors.city && (
                                <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                  {errors.city}
                                </div>
                              )}
                            </div>
                            <div className="w-1/4">
                              <input
                                placeholder="Postcode"
                                value={pin}
                                className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.pincode
                                  ? "border-[#F7284A]"
                                  : "border-[#D2D4DA]"
                                  } text-black`}
                                type="text"
                                maxLength={10}
                                inputMode="text"
                                onChange={(e) => setPin(e.target.value)}
                              />
                              {errors.pincode && (
                                <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                  {errors.pincode}
                                </div>
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="w-1/4">
                              <input
                                placeholder="e.g. 560001"
                                value={pin}
                                className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.pincode
                                  ? "border-[#F7284A]"
                                  : "border-[#D2D4DA]"
                                  } text-black`}
                                type="text"
                                maxLength={6}
                                inputMode="numeric"
                                onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
                              />
                              {pinLoading && (
                                <span className="text-xs text-gray-500 mt-1 block">Looking up...</span>
                              )}
                              {errors.pincode && (
                                <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                  {errors.pincode}
                                </div>
                              )}
                            </div>
                            <div className="w-1/4">
                              <input
                                placeholder="City"
                                value={city}
                                className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.city
                                  ? "border-[#F7284A]"
                                  : "border-[#D2D4DA]"
                                  } text-black`}
                                type="text"
                                onChange={(e) => {
                                  setCity(e.target.value);
                                }}
                              />
                              {errors.city && (
                                <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                  {errors.city}
                                </div>
                              )}
                            </div>
                            <div className="w-1/4">
                              <input
                                placeholder="State"
                                value={state}
                                className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.state
                                  ? "border-[#F7284A]"
                                  : "border-[#D2D4DA]"
                                  } text-black`}
                                type="text"
                                onChange={(e) => {
                                  setState(e.target.value);
                                }}
                              />
                              {errors.state && (
                                <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                  {errors.state}
                                </div>
                              )}
                            </div>
                          </>
                        )}
                        <div className="w-1/4">
                          <input
                            placeholder={isGB ? "Country" : "Country"}
                            value={country}
                            className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.country
                              ? "border-[#F7284A]"
                              : "border-[#D2D4DA]"
                              } text-black`}
                            type="text"
                            onChange={(e) => {
                              setCountry(e.target.value);
                            }}
                          />
                          {errors.country && (
                            <div className="text-[#F7284A] mt-[6px] text-[12px]">
                              {errors.country}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-6 mb-6">
                      <div className="w-1/2">
                        <p className="font-semibold text-sm mb-1 ">
                          Joining Location{" "}
                          <span className="text-red-400">*</span>
                        </p>
                        <div id={errors.joiningLocation && "error"}>
                          <div className="filter-container">
                            <Select
                              value={joiningLocation}
                              className="text-[14px] "
                              menuPlacement="bottom"
                              options={joiningLocationOptions}
                              onChange={(newValue) => {
                                setJoiningLocation(newValue);
                              }}
                              placeholder="Select Joining Location"
                            ></Select>
                          </div>
                          {errors.joiningLocation && (
                            <div className="text-[#F7284A] mt-[6px] text-[12px]">
                              {errors.joiningLocation}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="w-1/2">
                        <p className="font-semibold text-sm mb-1 ">
                          Gender <span className="text-red-400">*</span>
                        </p>
                        <div className="flex items-start space-x-3 mt-2 justify-start">
                          <div className="w-full flex space-x-3 ">
                            <div className="flex space-x-2">
                              <input
                                className=" outline-none border px-2 py-1 rounded-lg "
                                type="radio"
                                checked={gender === "M"}
                                onClick={() => setGender("M")}
                              ></input>
                              <p>Male</p>
                            </div>
                            <div className="flex space-x-2">
                              <input
                                className=" outline-none border px-2 py-1 rounded-lg "
                                type="radio"
                                checked={gender === "F"}
                                onClick={() => setGender("F")}
                              ></input>
                              <p>Female</p>
                            </div>
                            <div className="flex space-x-2">
                              <input
                                className=" outline-none border px-2 py-1 rounded-lg "
                                type="radio"
                                checked={gender === "O"}
                                onClick={() => setGender("O")}
                              ></input>
                              <p>Others</p>
                            </div>
                          </div>
                        </div>
                        <div id={errors.gender && "error"}>
                          {errors.gender && (
                            <div className="text-[#F7284A] mt-[6px] text-[12px]">
                              {errors.gender}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {companyDetails?.from_acfl && (
                      <div className="flex gap-6 mb-6">
                        <div className="w-1/2">
                          <p className="font-semibold text-sm mb-1 ">
                            Controlling Officer{" "}
                            <span className="text-red-400">*</span>
                          </p>
                          <div id={errors.controllingOfficer && "error"}>
                            <input
                              placeholder="Enter Controlling Officer"
                              value={controllingOfficer}
                              className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 text-black ${errors.controllingOfficer ? "border-[#F7284A]" : "border-[#D2D4DA]"}`}
                              type="text"
                              onChange={(e) =>
                                setControllingOfficer(e.target.value)
                              }
                            />
                            {errors.controllingOfficer && (
                              <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                {errors.controllingOfficer}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="w-1/2">
                          <p className="font-semibold text-sm mb-1 ">
                            Probation Perio(in Months){" "}
                            <span className="text-red-400">*</span>
                          </p>
                          <div id={errors.probationPeriod && "error"}>
                            <input
                              placeholder="Enter Probation Period"
                              value={probationPeriod}
                              className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 text-black ${errors.probationPeriod ? "border-[#F7284A]" : "border-[#D2D4DA]"}`}
                              type="number"
                              onWheel={(e) => e.preventDefault()}
                              onInput={(e) => {
                                const value = e.target.value.replace(
                                  /[^0-9]/g,
                                  "",
                                );
                                setProbationPeriod(value);
                              }}
                            />
                            {errors.probationPeriod && (
                              <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                {errors.probationPeriod}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {!companyDetails?.from_acfl && (
                      <div className="text-[12px]">
                        <p className="mb-1 text-[14px] font-medium">
                          Salary Distribution
                        </p>
                        <Table className="w-full border border-[#D2D4DA]">
                          <Thead>
                            <Tr>
                              <Th className="w-1/3 p-[12px] border"></Th>
                              <Th className="w-1/3 p-[12px] text-right border">
                                Current Salary
                              </Th>
                              <Th className="w-1/3 p-[12px] text-right border">
                                Proposed Salary
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            <Tr>
                              <Td className="p-[12px] border">
                                Total Fixed Pay
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {renderValue(proposal[0]["totalfixedpay"])}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {renderValue(proposal[1]["totalfixedpay"])}
                              </Td>
                            </Tr>

                            {companyDetails?.salaryDetail ? <>
                              <Tr>
                                <Td className="p-[12px] border">
                                  Medical/Life Insurance Premium
                                </Td>
                                <Td className="p-[12px] border text-right">
                                  {renderValue(
                                    proposal[0]["medicallifeinsurance"],
                                  )}
                                </Td>
                                <Td className="p-[12px] border text-right">
                                  {renderValue(
                                    proposal[1]["medicallifeinsurance"],
                                  )}
                                </Td>
                              </Tr>
                              <Tr>
                                <Td className="p-[12px] border">
                                  Joining/Relocation Bonus
                                </Td>
                                <Td className="p-[12px] border text-right">
                                  {renderValue(proposal[0]["relocationbonus"])}
                                </Td>
                                <Td className="p-[12px] border text-right">
                                  {renderValue(proposal[1]["relocationbonus"])}
                                </Td>
                              </Tr>
                              <Tr>
                                <Td className="p-[12px] border">
                                  ⁠⁠Performance/Sprint Bonus
                                </Td>
                                <Td className="p-[12px] border text-right">
                                  {renderValue(proposal[0]["sprintbonus"])}
                                </Td>
                                <Td className="p-[12px] border text-right">
                                  {renderValue(proposal[1]["sprintbonus"])}
                                </Td>
                              </Tr>
                            </> : <>
                              <Tr>
                                <Td className="p-[9px] border">
                                  Variable Pay
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[0].variablepay)}
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[1].variablepay)}
                                </Td>
                              </Tr>
                              <Tr>
                                <Td className="p-[9px] border">ESOP</Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[0].esop)}
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[1].esop)}
                                </Td>
                              </Tr>
                              <Tr>
                                <Td className="p-[9px] border">
                                  ESOP Value
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[0].esopvalue)}
                                </Td>
                                <Td className="p-[9px] border text-right">
                                  {renderValue(proposal[1].esopvalue)}
                                </Td>
                              </Tr>
                            </>}

                            <Tr>
                              <Td className="p-[12px] border">-</Td>
                              <Td className="p-[12px] border text-right">-</Td>
                              <Td className="p-[12px] border text-right">-</Td>
                            </Tr>

                            <Tr className="font-bold">
                              <Td className="p-[12px] border">
                                {!companyDetails?.salaryDetail
                                  ? "CTC"
                                  : "Total Compensation"}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {renderValue(currentTotalComp())}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {renderValue(proposedTotalComp())}
                              </Td>
                            </Tr>

                            <Tr>
                              <Td className="p-[12px] border">
                                %
                                {companyDetails?.salaryDetail
                                  ? " increase on Total Fixed Pay"
                                  : " increase on CTC"}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {renderValue("")}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {" "}
                                {renderValue(increaseOnCtc())}
                              </Td>
                            </Tr>

                            <Tr>
                              <Td className="p-[12px] border">
                                %{" "}
                                {companyDetails?.salaryDetail
                                  ? "increase on CTC"
                                  : "increase on TC"}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {renderValue("")}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {" "}
                                {renderValue(increaseOnTc())}
                              </Td>
                            </Tr>
                          </Tbody>
                        </Table>
                      </div>
                    )}
                  </div>
                </div>
                <div className="border-[#E9EBFA] w-full border"></div>
                <div className="p-6 flex justify-between bg-white rounded-b-xl">
                  <div className="flex gap-4 ">
                    <div onClick={() => setConfirmationModal("ocancel")}>
                      <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                        Cancel
                      </ButtonHollowXs>
                    </div>
                    <div
                      onClick={() => {
                        if (!validate("offerForm")) return;
                        createOfferLetter("Draft");
                        toast.success(
                          "Draft of the offer letter has been saved.",
                        );
                        window.location.reload();
                        setIsSubmitted(false);
                        setTemplateType("");
                        setJoiningDate();
                        setExpiryDate();
                        setAdd1("");
                        setAdd2("");
                        setPin("");
                        setCity("");
                        setState("");
                        setCountry("");
                        setGender("");
                        setJoiningLocation();
                        setErrors({});
                        resetProposal();
                        setTab("candidate");
                      }}
                    >
                      <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                        Save as Draft
                      </ButtonHollowXs>
                    </div>
                  </div>
                  <div
                    onClick={async () => {
                      setFormType("offerForm");
                      const isValid = validate("offerForm");
                      if (!isValid) return;

                      let newOfferId = activeOfferUuid;
                      if (
                        activeOfferStatus == "Draft" ||
                        tab == "offerletterdraft"
                      ) {
                        newOfferId = await updateOfferDraft("Generated");
                      } else {
                        newOfferId = await createOfferLetter("Generated");
                      }
                      statusUpdate("Offer Letter Generated", "candidate");
                      createNotification(
                        companyID,
                        userid,
                        "todo",
                        "Send Offer email",
                        `Offer to be sent to ${applicant.name}`,
                        JSON.stringify({ id: applicant.uuid }),
                      );
                      if (isValid) {
                        setConfirmationModal("offer");
                        setIsSubmitted(false);
                        setErrors({});
                      }
                      send({
                        company_id: companyID,
                        template_id: offerLetterTemplate.value,
                        offer_id: newOfferId,
                        applicant_id: applicant.uuid,
                        variables: {
                          candidate_name: applicant.name,
                          candidate_first_name: applicant.name?.split(" ")?.[0],
                          address_line_1: add1,
                          address_line_2: add2,
                          city: city,
                          pin_code: pin,
                          state: state,
                          job_title: jobDetails?.profilename,
                          grade: jobDetails?.grade,
                          date_of_join: joiningDate,
                          date_of_offer_expiry: expiryDate,
                          location: joiningLocation?.label,
                          company_name: companyDetails?.companyname,
                          ...(companyDetails?.from_acfl && {
                            controlling_officer: controllingOfficer,
                            probation_period: probationPeriod,
                          }),
                        },
                      });
                    }}
                  >
                    <ButtonXs text="#FFFFFF" color="#148EFF">
                      Generate Offer Letter
                    </ButtonXs>
                  </div>
                </div>
              </div>
            </div>
          )}
          {tab == "offerletterdraft" && (
            <div>
              <div className="mb-8  flex items-center">
                <img
                  onClick={() => {
                    setConfirmationModal("oback");
                  }}
                  src={arrowleft}
                  className="w-[40px] cursor-pointer h-[40px] mr-4"
                  alt="back button"
                />
                <h2 className="font-medium text-[28px]">
                  Offer Letter Creation
                </h2>
              </div>
              <div className="flex shadow-custom-shadow flex-col rounded-xl ">
                <div className="flex w-full rounded-t-xl bg-white flex-col  pt-[20px] p-6 ">
                  <div>
                    <div className="w-full mb-[20px]">
                      <p className="font-semibold text-sm mb-1 ">
                        Template <span className="text-red-400">*</span>
                      </p>
                      <div id={errors.templateType && "error"}>
                        <div className="filter-container">
                          <Select
                            value={offerLetterTemplate}
                            className="text-[14px] "
                            menuPlacement="bottom"
                            options={emailTemplateOptions}
                            placeholder="Select Template"
                            onChange={(newValue) =>
                              setOfferLetterTemplate(newValue)
                            }
                          ></Select>
                        </div>
                        {errors.templateType && (
                          <div className="text-[#F7284A] mt-[6px] text-[12px]">
                            {errors.templateType}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-full mb-[20px]">
                      <p className="font-semibold text-sm mb-1 ">
                        Job Title <span className="text-red-400">*</span>
                      </p>
                      <input
                        placeholder="Enter Job Title"
                        value={jobDetails.profilename}
                        className="custom-placeholder text-[14px] w-full border  py-1 rounded-[4px]  h-[37px] px-2  border-[#D2D4DA]  text-black "
                        type="text"
                      ></input>
                    </div>
                    <div className="w-full mb-[20px] text-[14px]">
                      <div className="w-full flex gap-6 ">
                        <div className="w-1/2">
                          <div className="mb-1 font-medium">
                            Joining Date{" "}
                            <span className="text-red-400 justify start">
                              *
                            </span>
                          </div>
                          <div className="w-full">
                            <ModernDatePicker
                              value={joiningDate}
                              onChange={(date) => setJoiningDate(date)}
                              minDate={new Date()}
                              placeholder="Select Date"
                            />
                            {errors.joiningDate && (
                              <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                {errors.joiningDate}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="w-1/2">
                          <div className="mb-1 font-medium">
                            Expiry Date{" "}
                            <span className="text-red-400 justify start">
                              *
                            </span>
                          </div>
                          <div className="w-full">
                            {companyDetails?.from_acfl ? (
                              <input
                                value={
                                  expiryDate
                                    ? new Date(expiryDate)
                                      .toLocaleDateString("en-GB")
                                      .replace(/\//g, "-")
                                    : ""
                                }
                                disabled
                                className="w-full h-11 px-3 border border-[#e2e8f0] bg-gray-100 text-[#8f94a1] rounded-[10px] text-[14px]"
                              />
                            ) : (
                              <ModernDatePicker
                                value={expiryDate}
                                onChange={(date) => setExpiryDate(date)}
                                minDate={new Date()}
                                placeholder="Select Date"
                              />
                            )}
                            {errors.expiryDate && (
                              <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                {errors.expiryDate}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full mb-[20px]">
                      <p className="font-semibold text-sm mb-1 ">
                        Candidate Address{" "}
                        <span className="text-red-400">*</span>
                      </p>
                      <div className="addressLine flex gap-3 mb-3">
                        <div className="w-1/2">
                          <input
                            placeholder={isGB ? "Address Line 1" : "Address Line 1"}
                            value={add1}
                            className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.add1
                              ? "border-[#F7284A]"
                              : "border-[#D2D4DA]"
                              } text-black`}
                            type="text"
                            onChange={(e) => {
                              setAdd1(e.target.value);
                            }}
                          />
                          {errors.add1 && (
                            <div className="text-[#F7284A] mt-[6px] text-[12px]">
                              {errors.add1}
                            </div>
                          )}
                        </div>
                        <div className="w-1/2">
                          <input
                            placeholder={isGB ? "Address Line 2 (Optional)" : "Address Line 2"}
                            value={add2}
                            className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.add2
                              ? "border-[#F7284A]"
                              : "border-[#D2D4DA]"
                              } text-black`}
                            type="text"
                            onChange={(e) => {
                              setAdd2(e.target.value);
                            }}
                          />
                          {errors.add2 && (
                            <div className="text-[#F7284A] mt-[6px] text-[12px]">
                              {errors.add2}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="addressLine2 flex gap-3">
                        {isGB ? (
                          <>
                            <div className="w-1/4">
                              <input
                                placeholder="Locality Name (Optional)"
                                value={state}
                                className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.state
                                  ? "border-[#F7284A]"
                                  : "border-[#D2D4DA]"
                                  } text-black`}
                                type="text"
                                onChange={(e) => {
                                  setState(e.target.value);
                                }}
                              />
                              {errors.state && (
                                <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                  {errors.state}
                                </div>
                              )}
                            </div>
                            <div className="w-1/4">
                              <input
                                placeholder="Town or City"
                                value={city}
                                className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.city
                                  ? "border-[#F7284A]"
                                  : "border-[#D2D4DA]"
                                  } text-black`}
                                type="text"
                                onChange={(e) => {
                                  setCity(e.target.value.toUpperCase());
                                }}
                              />
                              {errors.city && (
                                <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                  {errors.city}
                                </div>
                              )}
                            </div>
                            <div className="w-1/4">
                              <input
                                placeholder="Postcode"
                                value={pin}
                                className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.pincode
                                  ? "border-[#F7284A]"
                                  : "border-[#D2D4DA]"
                                  } text-black`}
                                type="text"
                                maxLength={10}
                                inputMode="text"
                                onChange={(e) => setPin(e.target.value)}
                              />
                              {errors.pincode && (
                                <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                  {errors.pincode}
                                </div>
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="w-1/4">
                              <input
                                placeholder="e.g. 560001"
                                value={pin}
                                className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.pincode
                                  ? "border-[#F7284A]"
                                  : "border-[#D2D4DA]"
                                  } text-black`}
                                type="text"
                                maxLength={6}
                                inputMode="numeric"
                                onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
                              />
                              {pinLoading && (
                                <span className="text-xs text-gray-500 mt-1 block">Looking up...</span>
                              )}
                              {errors.pincode && (
                                <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                  {errors.pincode}
                                </div>
                              )}
                            </div>
                            <div className="w-1/4">
                              <input
                                placeholder="City"
                                value={city}
                                className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.city
                                  ? "border-[#F7284A]"
                                  : "border-[#D2D4DA]"
                                  } text-black`}
                                type="text"
                                onChange={(e) => {
                                  setCity(e.target.value);
                                }}
                              />
                              {errors.city && (
                                <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                  {errors.city}
                                </div>
                              )}
                            </div>
                            <div className="w-1/4">
                              <input
                                placeholder="State"
                                value={state}
                                className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.state
                                  ? "border-[#F7284A]"
                                  : "border-[#D2D4DA]"
                                  } text-black`}
                                type="text"
                                onChange={(e) => {
                                  setState(e.target.value);
                                }}
                              />
                              {errors.state && (
                                <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                  {errors.state}
                                </div>
                              )}
                            </div>
                          </>
                        )}
                        <div className="w-1/4">
                          <input
                            placeholder="Country"
                            value={country}
                            className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 ${errors.country
                              ? "border-[#F7284A]"
                              : "border-[#D2D4DA]"
                              } text-black`}
                            type="text"
                            onChange={(e) => {
                              setCountry(e.target.value);
                            }}
                          />
                          {errors.country && (
                            <div className="text-[#F7284A] mt-[6px] text-[12px]">
                              {errors.country}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-6 mb-6">
                      <div className="w-1/2">
                        <p className="font-semibold text-sm mb-1 ">
                          Joining Location{" "}
                          <span className="text-red-400">*</span>
                        </p>
                        <div id={errors.joiningLocation && "error"}>
                          <div className="filter-container">
                            <Select
                              value={joiningLocation}
                              className="text-[14px] "
                              menuPlacement="bottom"
                              options={joiningLocationOptions}
                              onChange={(newValue) => {
                                setJoiningLocation(newValue);
                              }}
                              placeholder="Select Joining Location"
                            ></Select>
                          </div>
                          {errors.joiningLocation && (
                            <div className="text-[#F7284A] mt-[6px] text-[12px]">
                              {errors.joiningLocation}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="w-1/2">
                        <p className="font-semibold text-sm mb-1 ">
                          Gender <span className="text-red-400">*</span>
                        </p>
                        <div className="flex items-start space-x-3 mt-2 justify-start">
                          <div className="w-full flex space-x-3 ">
                            <div className="flex space-x-2">
                              <input
                                className=" outline-none border px-2 py-1 rounded-lg "
                                type="radio"
                                checked={gender === "M"}
                                onClick={() => setGender("M")}
                              ></input>
                              <p>Male</p>
                            </div>
                            <div className="flex space-x-2">
                              <input
                                className=" outline-none border px-2 py-1 rounded-lg "
                                type="radio"
                                checked={gender === "F"}
                                onClick={() => setGender("F")}
                              ></input>
                              <p>Female</p>
                            </div>
                            <div className="flex space-x-2">
                              <input
                                className=" outline-none border px-2 py-1 rounded-lg "
                                type="radio"
                                checked={gender === "O"}
                                onClick={() => setGender("O")}
                              ></input>
                              <p>Others</p>
                            </div>
                          </div>
                        </div>
                        <div id={errors.gender && "error"}>
                          {errors.gender && (
                            <div className="text-[#F7284A] mt-[6px] text-[12px]">
                              {errors.gender}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {companyDetails?.from_acfl && (
                      <div className="flex gap-6 mb-6">
                        <div className="w-1/2">
                          <p className="font-semibold text-sm mb-1 ">
                            Controlling Officer{" "}
                            <span className="text-red-400">*</span>
                          </p>
                          <div id={errors.controllingOfficer && "error"}>
                            <input
                              placeholder="Enter Controlling Officer"
                              value={controllingOfficer}
                              className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 text-black ${errors.controllingOfficer ? "border-[#F7284A]" : "border-[#D2D4DA]"}`}
                              type="text"
                              onChange={(e) =>
                                setControllingOfficer(e.target.value)
                              }
                            />
                            {errors.controllingOfficer && (
                              <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                {errors.controllingOfficer}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="w-1/2">
                          <p className="font-semibold text-sm mb-1 ">
                            Probation Period (in Months){" "}
                            <span className="text-red-400">*</span>
                          </p>
                          <div id={errors.probationPeriod && "error"}>
                            <input
                              placeholder="Enter Probation Period"
                              value={probationPeriod}
                              className={`custom-placeholder text-[14px] w-full border py-1 rounded-[4px] h-[37px] px-2 text-black ${errors.probationPeriod ? "border-[#F7284A]" : "border-[#D2D4DA]"}`}
                              type="number"
                              onWheel={(e) => e.preventDefault()}
                              onChange={(e) => {
                                const val = e.target.value;

                                // Allow only digits
                                if (/^\d*$/.test(val)) {
                                  setProbationPeriod(val);
                                }
                              }}
                            />
                            {errors.probationPeriod && (
                              <div className="text-[#F7284A] mt-[6px] text-[12px]">
                                {errors.probationPeriod}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {!companyDetails?.from_acfl && (
                      <div className="text-[12px]">
                        <p className="mb-1 text-[14px] font-medium">
                          Salary Distribution
                        </p>
                        <Table className="w-full border border-[#D2D4DA]">
                          <Thead>
                            <Tr>
                              <Th className="w-1/3 p-[12px] border"></Th>
                              <Th className="w-1/3 p-[12px] text-right border">
                                Current Salary
                              </Th>
                              <Th className="w-1/3 p-[12px] text-right border">
                                Proposed Salary
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {/* Always show Total Fixed Pay */}
                            <Tr>
                              <Td className="p-[12px] border">
                                Total Fixed Pay
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {renderValue(proposal[0]["totalfixedpay"])}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {renderValue(proposal[1]["totalfixedpay"])}
                              </Td>
                            </Tr>

                            {/* Conditional rows based on salaryDetail */}
                            {companyDetails?.salaryDetail ? (
                              <>
                                <Tr>
                                  <Td className="p-[12px] border">
                                    Medical/Life Insurance Premium
                                  </Td>
                                  <Td className="p-[12px] border text-right">
                                    {renderValue(
                                      proposal[0]["medicallifeinsurance"],
                                    )}
                                  </Td>
                                  <Td className="p-[12px] border text-right">
                                    {renderValue(
                                      proposal[1]["medicallifeinsurance"],
                                    )}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="p-[12px] border">
                                    Joining/Relocation Bonus
                                  </Td>
                                  <Td className="p-[12px] border text-right">
                                    {renderValue(
                                      proposal[0]["relocationbonus"],
                                    )}
                                  </Td>
                                  <Td className="p-[12px] border text-right">
                                    {renderValue(
                                      proposal[1]["relocationbonus"],
                                    )}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="p-[12px] border">
                                    ⁠⁠Performance/Sprint Bonus
                                  </Td>
                                  <Td className="p-[12px] border text-right">
                                    {renderValue(proposal[0]["sprintbonus"])}
                                  </Td>
                                  <Td className="p-[12px] border text-right">
                                    {renderValue(proposal[1]["sprintbonus"])}
                                  </Td>
                                </Tr>
                              </>
                            ) : (
                              <>
                                <Tr>
                                  <Td className="p-[12px] border">
                                    Variable Pay
                                  </Td>
                                  <Td className="p-[12px] border text-right">
                                    {renderValue(proposal[0]["variablepay"])}
                                  </Td>
                                  <Td className="p-[12px] border text-right">
                                    {renderValue(proposal[1]["variablepay"])}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="p-[12px] border">ESOP</Td>
                                  <Td className="p-[12px] border text-right">
                                    {renderValue(proposal[0]["esop"])}
                                  </Td>
                                  <Td className="p-[12px] border text-right">
                                    {renderValue(proposal[1]["esop"])}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="p-[12px] border">
                                    ESOP Value
                                  </Td>
                                  <Td className="p-[12px] border text-right">
                                    {renderValue(proposal[0]["esopvalue"])}
                                  </Td>
                                  <Td className="p-[12px] border text-right">
                                    {renderValue(proposal[1]["esopvalue"])}
                                  </Td>
                                </Tr>
                              </>
                            )}

                            {/* Spacer row */}
                            <Tr>
                              <Td className="p-[12px] border">-</Td>
                              <Td className="p-[12px] border text-right">-</Td>
                              <Td className="p-[12px] border text-right">-</Td>
                            </Tr>

                            {/* {companyDetails?.salaryDetail?"CTC":"Total Compensation"} */}
                            <Tr className="font-bold">
                              <Td className="p-[12px] border">
                                {!companyDetails?.salaryDetail
                                  ? "CTC"
                                  : "Total Compensation"}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {renderValue(
                                  parseFloat(proposal[0].totalfixedpay || 0) +
                                  (companyDetails?.salaryDetail
                                    ? parseFloat(
                                      proposal[0].medicallifeinsurance || 0,
                                    ) +
                                    parseFloat(
                                      proposal[0].relocationbonus || 0,
                                    ) +
                                    parseFloat(proposal[0].sprintbonus || 0)
                                    : parseFloat(
                                      proposal[0].variablepay || 0,
                                    ) +
                                    parseFloat(proposal[0].esopvalue || 0)),
                                )}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {renderValue(
                                  parseFloat(proposal[1].totalfixedpay || 0) +
                                  (companyDetails?.salaryDetail
                                    ? parseFloat(
                                      proposal[1].medicallifeinsurance || 0,
                                    ) +
                                    parseFloat(
                                      proposal[1].relocationbonus || 0,
                                    ) +
                                    parseFloat(proposal[1].sprintbonus || 0)
                                    : parseFloat(
                                      proposal[1].variablepay || 0,
                                    ) +
                                    parseFloat(proposal[1].esopvalue || 0)),
                                )}
                              </Td>
                            </Tr>

                            {/* % Increase Rows */}
                            {/* %{companyDetails?.salaryDetail?" increase on Total Fixed Pay":" increase on CTC"} */}
                            <Tr>
                              <Td className="p-[12px] border">
                                %
                                {companyDetails?.salaryDetail
                                  ? " increase on Total Fixed Pay"
                                  : " increase on CTC"}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {renderValue("")}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {" "}
                                {renderValue(increaseOnCtc())}
                              </Td>
                            </Tr>

                            {/* % {companyDetails?.salaryDetail?"increase on CTC":"increase on TC"} */}
                            <Tr>
                              <Td className="p-[12px] border">
                                %{" "}
                                {companyDetails?.salaryDetail
                                  ? "increase on CTC"
                                  : "increase on TC"}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {renderValue("")}
                              </Td>
                              <Td className="p-[12px] border text-right">
                                {" "}
                                {renderValue(increaseOnTc())}
                              </Td>
                            </Tr>
                          </Tbody>
                        </Table>
                      </div>
                    )}
                  </div>
                </div>
                <div className="border-[#E9EBFA] w-full border"></div>
                <div className="p-6 flex justify-between bg-white rounded-b-xl">
                  <div className="flex gap-4 ">
                    <div onClick={() => setConfirmationModal("oreset")}>
                      <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                        Reset
                      </ButtonHollowXs>
                    </div>
                    <div
                      onClick={() => {
                        updateOfferDraft("Draft");

                        toast.success(
                          "Draft of the offer letter has been saved.",
                        );
                        setIsSubmitted(false);
                        setTemplateType("");
                        setJoiningDate();
                        setExpiryDate();
                        setAdd1("");
                        setAdd2("");
                        setGender("");
                        setPin("");
                        setCity("");
                        setState("");
                        setCountry("");
                        setJoiningLocation();
                        setErrors({});
                        createNotification(
                          companyID,
                          userid,
                          "todo",
                          "Send Offer email",
                          `Offer to be sent to ${applicant.name}`,
                          JSON.stringify({ id: applicant.uuid }),
                        );

                        setTab("candidate");
                      }}
                    >
                      <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                        Save as Draft
                      </ButtonHollowXs>
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      setFormType("offerForm");
                      setIsSubmitted(true);
                      const isValid = validate("offerForm");
                      if (!isValid) {
                        return;
                      }
                      statusUpdate("Offer Letter Generated", "candidate");
                      if (isValid) {
                        setConfirmationModal("offer");
                        const offerLetterData = {
                          company_id: companyID,
                          template_id: offerLetterTemplate.value,
                          offer_id: activeOfferUuid,
                          applicant_id: applicant.uuid,
                          variables: {
                            candidate_name: applicant.name,
                            candidate_first_name:
                              applicant.name?.split(" ")?.[0],
                            address_line_1: add1,
                            address_line_2: add2,
                            city: city,
                            pin_code: pin,
                            state: state,
                            job_title: jobDetails?.profilename,
                            grade: jobDetails?.grade,
                            date_of_join: joiningDate,
                            date_of_offer_expiry: expiryDate,
                            location: joiningLocation?.label,
                            company_name: companyDetails?.companyname,
                            ...(companyDetails?.from_acfl && {
                              controlling_officer: controllingOfficer,
                              probation_period: probationPeriod,
                            }),
                          },
                        };
                        send(offerLetterData);
                        setIsSubmitted(false);
                        setErrors({});
                      }
                    }}
                  >
                    <ButtonXs text="#FFFFFF" color="#148EFF">
                      Generate Offer Letter
                    </ButtonXs>
                  </div>
                </div>
              </div>
            </div>
          )}
          {tab == "reqdoc" && (
            <div>
              <div className="mb-8  flex items-center">
                <img
                  onClick={() => {
                    setConfirmationModal("back");
                    setTemplateType("");
                    setRequiredDocuments([]);
                    setIsSubmitted(false);

                    setErrors({});
                  }}
                  src={arrowleft}
                  className="w-[40px] cursor-pointer h-[40px] mr-4"
                  alt="back button"
                />
                <h2 className="font-medium text-[28px]">
                  Documents Request Email to Candidate
                </h2>
              </div>
              <div className="flex flex-col shadow-custom-shadow rounded-xl">
                <div className="flex w-full  rounded-lg ">
                  <div className="w-1/2 pt-[20px] pb-[4px] px-6 rounded-tl-xl  bg-white  ">
                    <div className="text-[14px] mb-[24px]">
                      <div className="  mb-1  font-semibold">
                        Email Template
                        <span className="text-red-400 justify start"> *</span>
                      </div>
                      <div id={errors.templateType && "error"}>
                        <div className="filter-container text-[14px]">
                          <Select
                            isClearable
                            options={DocTemplatesOptions}
                            placeholder="Select doc request template"
                            value={selectedDocTemplate}
                            onChange={(newValue) => {
                              setTemplateType(newValue);
                              handleDocChangeEmailTemplate(newValue);
                              setSelectedDocTemplate(newValue);
                            }}
                          />
                        </div>
                        {errors.templateType && (
                          <div className="text-[#F7284A] mt-[6px] text-[12px]">
                            {errors.templateType}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className=" text-[14px] mb-[24px]">
                      <div className="  mb-2 font-semibold">
                        Documents Required
                        <span className="text-red-400 justify start"> *</span>
                      </div>
                      <div className="flex mb-2 flex-wrap w-full gap-3 ">
                        {displayedDocuments.map((d) => {
                          return (
                            <button
                              onClick={() => {
                                requiredDocuments.includes(d)
                                  ? setRequiredDocuments((prevArray) =>
                                    prevArray.filter((doc) => doc !== d),
                                  )
                                  : setRequiredDocuments((prevArray) => [
                                    ...prevArray,
                                    d,
                                  ]);
                              }}
                              className={
                                requiredDocuments.includes(d)
                                  ? "bg-[#148EFF33] border-[1.2px] border-[#148EFF] leading-4 text-[#148EFF] px-[6px]  p-[4px] font-medium text-sm rounded-lg"
                                  : "bg-[#8F94A133] border-[1.2px] border-[#8F94A1] leading-4 text-[#8F94A1]  px-[6px] p-[4px] font-medium text-sm rounded-lg"
                              }
                            >
                              {d}
                            </button>
                          );
                        })}
                      </div>
                      {!showInput ? (
                        <button
                          className="text-[#148EFF] text-xs font-semibold"
                          onClick={() => {
                            setShowInput(true);
                          }}
                        >
                          + Add More
                        </button>
                      ) : (
                        <div className="h-fit flex items-center pt-1">
                          <input
                            placeholder="Type here "
                            value={addedDocumentType}
                            onChange={(e) =>
                              setAddedDocumentType(e.target.value)
                            }
                            className="custom-placeholder mr-2 flex-grow text-[14px] border py-1 rounded-[4px] h-[33px] px-2 border-[#D2D4DA] font-semibold text-black"
                            type="text"
                          />
                          <div onClick={handleAddDocument}>
                            <ButtonXs color="#148EFF" text="#FFFFFF" size="xs">
                              Add
                            </ButtonXs>
                          </div>
                          <div
                            className="ml-2"
                            onClick={() => setShowInput(false)}
                          >
                            <ButtonHollowXs
                              color="#FFFFFF"
                              text="#148EFF"
                              size="xs"
                            >
                              Cancel
                            </ButtonHollowXs>
                          </div>
                        </div>
                      )}
                      {errors.requiredDocuments && (
                        <div className="text-[#F7284A] mt-[6px] text-[12px]">
                          {errors.requiredDocuments}
                        </div>
                      )}
                    </div>

                    <div className=" text-[14px] mb-[20px]">
                      <div className=" text-[14px] ">
                        <div className="  mb-2 font-semibold">
                          Email Customization
                        </div>
                        <div className="mb-[20px]">
                          <p className="mb-1 font-medium">Subject</p>
                          <input
                            placeholder="Subject"
                            value={Docsubject}
                            onChange={(e) => {
                              setDocSubject(e.target.value);
                            }}
                            className="custom-placeholder text-[14px] w-full border  py-1 rounded-[4px]  h-[32px] px-2  border-[#D2D4DA] font-semibold text-[black] "
                            type="text"
                          ></input>
                        </div>

                        <div className=" text-[14px] mb-[20px]">
                          <div className="  mb-[6px] font-semibold">
                            Email Body
                          </div>
                          <div>
                            {/* <textarea
                              className="w-full p-[8px] border border-gray-300 rounded-[4px]"
                              placeholder="Email body here..."
                              rows={5}
                              value={body}
                              onChange={(e) => {
                                setBody(e.target.value);
                              }}
                            ></textarea> */}
                            <ReactQuill
                              value={Docbody}
                              onChange={setDocBody}
                              rows="3"
                              theme="snow"
                              className="w-full"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="">
                        <div className="  mb-[6px] font-semibold">
                          Attachments
                        </div>
                        <div className="flex items-center border pl-2 border-[#D2D4DA] rounded-[4px] ">
                          <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            className=" w-full h-full"
                          />
                          <button className="bg-light-blue whitespace-nowrap text-white px-4 p-2 ml-2">
                            Attach file
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/2 rounded-tr-lg">
                    <div className="p-6 pt-[20px] bg-[#F1F4FB] h-full flex flex-col    text-[12px]">
                      <h2 className="text-[14px] font-semibold mb-2">
                        Email Preview
                      </h2>
                      <div className="bg-white p-[12px] flex-1  pb-0 shadow-md rounded-[8px]">
                        <div className="p-1">
                          <div className="mb-[6px] text-[14px] font-medium leading-4">
                            <div className="py-1 text-[14px] mb-3">
                              Subject: {previewDocSubject}
                            </div>
                          </div>
                          <div className="mb-[6px] text-[#444D63] ">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: previewDocBody,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="border-[#E9EBFA] w-full border"></div>
                  <div className="p-6 flex justify-between bg-white rounded-b-xl">
                    <div className="flex gap-4 "></div>
                    <div
                      onClick={() => {
                        setFormType("reqDocForm");
                        setIsSubmitted(true);
                        const isValid = validate("reqDocForm");
                        console.log("isValid", isValid);
                        console.log("errors", errors);
                        if (isValid) {
                          setTab("candidate");
                          createDocument();
                          setIsSubmitted(false);
                          setTemplateType("");
                          setRequiredDocuments([]);
                          setErrors({});
                          toast.success(
                            "Document request email has been successfully sent to the candidate.",
                            { icon: <ToastIcon /> },
                          );
                        }
                      }}
                    >
                      <ButtonXs text="#FFFFFF" color="#148EFF">
                        Send Email
                      </ButtonXs>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {pendingModal && (
            <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
              <div className="fixed -translate-x-1/2 w-1/3 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
                <p className="text-center font-semibold">
                  Would like to send the offer
                </p>
                <div className="flex justify-between items-center mt-5">
                  <button
                    onClick={() => {
                      setPendingModal(false);
                    }}
                    className="px-6 py-2 rounded-lg border border-[#148EFF] text-[#148EFF] bg-white"
                  >
                    No
                  </button>
                  <button
                    onClick={async () => {
                      setTab("candidate");
                      await sendOfferLetter();

                      toast.success(
                        `${applicant.name}'s Offer Letter has been successfully sent.`,
                        { icon: <ToastIcon /> },
                      );
                      setPendingModal(false);
                    }}
                    className="px-6 py-2 rounded-lg border bg-[#148EFF]  text-white"
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          )}
          {tab == "reqdocagain" && (
            <div>
              <div className="mb-8  flex items-center">
                <img
                  onClick={() => {
                    setConfirmationModal("back");
                  }}
                  src={arrowleft}
                  className="w-[40px] cursor-pointer h-[40px] mr-4"
                  alt="back button"
                />
                <h2 className="font-medium text-[28px]">
                  Documents Request Email to Candidate
                </h2>
              </div>
              <div className="flex flex-col shadow-custom-shadow rounded-xl">
                <div className="flex w-full  rounded-lg ">
                  <div className="w-1/2 pt-[20px] pb-[4px] px-6 rounded-tl-xl  bg-white  ">
                    <div className="text-[14px] mb-[24px]">
                      <div className="  mb-1  font-semibold">
                        Email Template
                        <span className="text-red-400 justify start"> *</span>
                      </div>
                      <div id={errors.templateType && "error"}>
                        <div className="filter-container text-[14px]">
                          <Select
                            isClearable
                            options={DocRejectTemplatesOptions}
                            placeholder="Select doc request template"
                            value={selectedDocRejectTemplate}
                            onChange={(newValue) => {
                              setTemplateType(newValue);
                              handleDocRejectChangeEmailTemplate(newValue);
                              setSelectedDocRejectTemplate(newValue);
                            }}
                          />
                        </div>
                        {errors.templateType && (
                          <div className="text-[#F7284A] mt-[6px] text-[12px]">
                            {errors.templateType}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className=" text-[14px] mb-[24px]">
                      <div className="  mb-2 font-semibold">
                        Documents Required
                        <span className="text-red-400 justify start"> *</span>
                      </div>
                      <div className="flex mb-2 flex-wrap w-full gap-3 ">
                        <button
                          className={
                            "bg-[#148EFF33] border-[1.2px] border-[#148EFF] leading-4 text-[#148EFF] px-[6px]  p-[4px] font-medium text-sm rounded-lg"
                          }
                        >
                          {activeDocName}
                        </button>
                      </div>
                    </div>
                    <div className=" text-[14px] mb-[20px]">
                      <div className=" text-[14px] ">
                        <div className="  mb-2 font-semibold">
                          Email Customization
                        </div>
                        <div className="mb-[20px]">
                          <p className="mb-1 font-medium">Subject</p>
                          <input
                            placeholder="Subject"
                            value={docRejectSubject}
                            onChange={(e) => {
                              setDocRejectSubject(e.target.value);
                            }}
                            className="custom-placeholder text-[14px] w-full border  py-1 rounded-[4px]  h-[32px] px-2  border-[#D2D4DA] font-semibold text-[black] "
                            type="text"
                          ></input>
                        </div>

                        <div className=" text-[14px] mb-[20px]">
                          <div className="  mb-[6px] font-semibold">
                            Email Body
                          </div>
                          <div>
                            <ReactQuill
                              value={docRejectBody}
                              onChange={setDocRejectBody}
                              rows="3"
                              theme="snow"
                              className="w-full"
                            />
                            {/* <ReactQuill
                  value={body}
                  onChange={setBody}
                  rows="3"
                  theme="snow"
                  className="w-full "
                ></ReactQuill> */}
                          </div>
                        </div>
                      </div>
                      <div className="">
                        <div className="  mb-[6px] font-semibold">
                          Attachments
                        </div>
                        <div className="flex items-center border pl-2 border-[#D2D4DA] rounded-[4px] ">
                          <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            className=" w-full h-full"
                          />
                          <button className="bg-light-blue whitespace-nowrap text-white px-4 p-2 ml-2">
                            Attach file
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/2 rounded-tr-lg">
                    <div className="p-6 pt-[20px] bg-[#F1F4FB] h-full flex flex-col    text-[12px]">
                      <h2 className="text-[14px] font-semibold mb-2">
                        Email Preview
                      </h2>
                      <div className="bg-white p-[12px] flex-1  pb-0 shadow-md rounded-[8px]">
                        <div className="p-1">
                          <div className="mb-[6px] text-[14px] font-medium leading-4">
                            <div className="py-1 text-[14px] mb-3">
                              Subject: {previewDocRejectSubject}
                            </div>
                          </div>
                          <div className="mb-[6px] text-[#444D63] ">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: previewDocRejectBody,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="border-[#E9EBFA] w-full border"></div>
                  <div className="p-6 flex justify-between bg-white rounded-b-xl">
                    <div className="flex gap-4 "></div>
                    <div
                      onClick={() => {
                        setFormType("reqDocAgainForm");
                        console.log("Filling Form");
                        setIsSubmitted(true);
                        const isValid = validate("reqDocAgainForm");
                        console.log("isValid", isValid);
                        console.log("errors", errors);
                        if (isValid) {
                          if (activeDocStatus == "Rejected") {
                            uploadAgainDocument(true);
                          } else if (activeDocStatus == "Pending")
                            console.log("none");

                          toast.success(
                            "Document request email has been successfully sent to the candidate.",
                            { icon: <ToastIcon /> },
                          );
                          setTab("candidate");
                          setIsSubmitted(false);
                          setTemplateType("");
                          setErrors({});
                        }
                      }}
                    >
                      <ButtonXs text="#FFFFFF" color="#148EFF">
                        Send Email
                      </ButtonXs>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <Copyright />
          <ToastContainer
            autoClose={3000}
            toastClassName={(context) =>
              " relative flex p-1  min-h-10 rounded-[8px]  bg-white   flex-row justify-between border-2 border-[#0DCD94] overflow-hidden cursor-pointer"
            }
            bodyClassName={() =>
              "text-[14px] gap-3 flex text-[#161A21] font-medium  p-3  pr-1"
            }
          />
          {confirmationModal && confirmationModal != "offer" && (
            <>
              <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-30 flex items-center justify-center">
                <div className="bg-white border-[#D2D4DA] border-[1.4px]  fixed rounded-[8px] shadow-xl z-50  left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="p-8">
                    {confirmationModal == "back" && (
                      <>
                        <div className="font-medium mb-6 leading-6">
                          Going back will not save your work as a draft. <br />
                          Do you still want to go back?
                        </div>
                        <div className="flex justify-center gap-8">
                          <div
                            onClick={() => {
                              setConfirmationModal("");
                            }}
                          >
                            {" "}
                            <ButtonHollowXs color="#FFFFFF" text="#148EFF">
                              No, Stay Here
                            </ButtonHollowXs>
                          </div>
                          <div
                            onClick={() => {
                              if (tab == "reqdoc" || tab == "reqdocagain") {
                                setTemplateType("");
                                setRequiredDocuments([]);
                                setIsSubmitted(false);
                                setTab("candidate");
                                setConfirmationModal("");
                                setErrors({});
                              } else if (tab == "proposal") {
                                setIsSubmitted(false);
                                setTemplateType();
                                setHirManager();
                                setJustification("");
                                setErrors({});
                                resetProposal();
                                setConfirmationModal("");
                                setTab("candidate");
                              } else {
                                setConfirmationModal("");
                                setTab("candidate");
                              }
                            }}
                          >
                            {" "}
                            <ButtonXs text="#FFFFFF" color="#148EFF">
                              Yes, Go Back
                            </ButtonXs>
                          </div>
                        </div>
                      </>
                    )}
                    {confirmationModal == "oback" && (
                      <>
                        <div className="font-medium mb-6 leading-6">
                          Going back will not save your work as a draft. <br />
                          Do you still want to go back?
                        </div>
                        <div className="flex justify-between">
                          <div
                            onClick={() => {
                              setConfirmationModal("");
                            }}
                          >
                            {" "}
                            <ButtonHollowXs color="#FFFFFF" text="#148EFF">
                              No, Stay Here
                            </ButtonHollowXs>
                          </div>
                          <div
                            onClick={() => {
                              setIsSubmitted(false);
                              setTemplateType("");
                              setJoiningDate();
                              setExpiryDate();
                              setAdd1("");
                              setAdd2("");
                              setGender("");
                              setPin("");
                              setCity("");
                              setState("");
                              setCountry("");
                              setJoiningLocation();
                              setErrors({});
                              resetProposal();
                              setConfirmationModal("");
                              setTab("candidate");
                            }}
                          >
                            {" "}
                            <ButtonXs text="#FFFFFF" color="#148EFF">
                              Yes, Go Back
                            </ButtonXs>
                          </div>
                        </div>
                      </>
                    )}
                    {confirmationModal == "cancel" && (
                      <>
                        <div className="font-medium mb-6 leading-6">
                          If you cancel, your created email will not be saved as
                          a draft. <br />
                          Do you still want to cancel?
                        </div>
                        <div className="flex justify-center gap-8">
                          <div
                            onClick={() => {
                              createSalaryProposal("Draft");
                              toast.success(
                                "Draft of the salary proposal email has been saved.",
                                { icon: <ToastIcon /> },
                              );
                              setTab("candidate");
                              setIsSubmitted(false);
                              setTemplateType();
                              setHirManager();
                              setJustification("");
                              resetProposal();
                              setErrors({});
                              setConfirmationModal("");
                              setTab("candidate");
                            }}
                          >
                            {" "}
                            <ButtonHollowXs color="#FFFFFF" text="#148EFF">
                              No, Save Draft
                            </ButtonHollowXs>
                          </div>
                          <div
                            onClick={() => {
                              setIsSubmitted(false);
                              setTemplateType();
                              setHirManager();
                              setJustification("");
                              setErrors({});
                              resetProposal();

                              setConfirmationModal("");
                              setTab("candidate");
                            }}
                          >
                            {" "}
                            <ButtonXs text="#FFFFFF" color="#148EFF">
                              Yes, Cancel
                            </ButtonXs>
                          </div>
                        </div>
                      </>
                    )}
                    {confirmationModal == "ocancel" && (
                      <>
                        <div className="font-medium mb-6 leading-6">
                          If you cancel, your work will not be saved as a draft.{" "}
                          <br />
                          Do you still want to cancel?
                        </div>
                        <div className="flex justify-center gap-8">
                          <div
                            onClick={() => {
                              setTab("candidate");
                              createOfferLetter("Draft");
                              toast.success(
                                "Draft of the offer letter has been saved.",
                              );
                              setIsSubmitted(false);
                              setTemplateType("");
                              setJoiningDate();
                              setExpiryDate();
                              setAdd1("");
                              setAdd2("");
                              setGender("");
                              setPin("");
                              setCity("");
                              setState("");
                              setCountry("");
                              setJoiningLocation();
                              setErrors({});
                              resetProposal();
                              setConfirmationModal();
                              setTab("candidate");
                              window.location.reload();
                            }}
                          >
                            {" "}
                            <ButtonHollowXs color="#FFFFFF" text="#148EFF">
                              No, Save Draft
                            </ButtonHollowXs>
                          </div>
                          <div
                            onClick={() => {
                              setIsSubmitted(false);
                              setTemplateType("");
                              setJoiningDate();
                              setExpiryDate();
                              setAdd1("");
                              setAdd2("");
                              setGender("");
                              setPin("");
                              setCity("");
                              setState("");
                              setCountry("");
                              setJoiningLocation();
                              setErrors({});
                              resetProposal();
                              setConfirmationModal("");
                              setTab("candidate");
                            }}
                          >
                            {" "}
                            <ButtonXs text="#FFFFFF" color="#148EFF">
                              Yes, Cancel
                            </ButtonXs>
                          </div>
                        </div>
                      </>
                    )}
                    {confirmationModal == "reset" && (
                      <>
                        <div className="font-medium mb-6 leading-6">
                          Resetting will delete all the filled data. <br />
                          Are you sure you want to proceed with this action?
                        </div>
                        <div className="flex justify-between">
                          <div onClick={() => setConfirmationModal("")}>
                            {" "}
                            <ButtonHollowXs color="#FFFFFF" text="#148EFF">
                              Cancel
                            </ButtonHollowXs>
                          </div>
                          <div
                            onClick={() => {
                              resetProposal();
                              setJustification("");
                              setHirManager("");
                              setTemplateType("");
                              setConfirmationModal("");
                              setSubject("");
                              setBody("");
                            }}
                          >
                            {" "}
                            <ButtonXs text="#FFFFFF" color="#148EFF">
                              Yes, Reset
                            </ButtonXs>
                          </div>
                        </div>
                      </>
                    )}
                    {confirmationModal == "oreset" && (
                      <>
                        <div className="font-medium mb-6 leading-6">
                          Resetting will delete all the filled data. <br />
                          Are you sure you want to proceed with this action?
                        </div>
                        <div className="flex justify-center gap-8">
                          <div onClick={() => setConfirmationModal("")}>
                            {" "}
                            <ButtonHollowXs color="#FFFFFF" text="#148EFF">
                              Cancel
                            </ButtonHollowXs>
                          </div>
                          <div
                            onClick={() => {
                              setIsSubmitted(false);
                              setTemplateType("");
                              setJoiningDate();
                              setExpiryDate();
                              setAdd1("");
                              setGender("");
                              setAdd2("");
                              setPin("");
                              setCity("");
                              setState("");
                              setCountry("");
                              setJoiningLocation("");
                              setErrors({});
                              setConfirmationModal("");
                            }}
                          >
                            {" "}
                            <ButtonXs text="#FFFFFF" color="#148EFF">
                              Yes, Reset
                            </ButtonXs>
                          </div>
                        </div>
                      </>
                    )}
                    {confirmationModal == "delete" && (
                      <>
                        <div className="font-medium mb-6 leading-6">
                          This action will remove everything you have created.
                          <br />
                          Are you sure you want to delete your saved draft?
                        </div>
                        <div className="flex justify-center gap-8">
                          <div onClick={() => setConfirmationModal("")}>
                            {" "}
                            <ButtonHollowXs color="#FFFFFF" text="#148EFF">
                              Cancel
                            </ButtonHollowXs>
                          </div>
                          <div
                            onClick={() => {
                              deleteSalaryProposalDraft();

                              setConfirmationModal("");
                              toast.success(
                                "Saved salary proposal draft has been successfully deleted.",
                                { icon: <ToastIcon /> },
                              );
                            }}
                          >
                            <ButtonXs text="#FFFFFF" color="#148EFF">
                              Yes, Delete
                            </ButtonXs>
                          </div>
                        </div>
                      </>
                    )}
                    {confirmationModal == "odelete" && (
                      <>
                        <div className="font-medium mb-6 leading-6">
                          This action will remove everything you have created.
                          <br />
                          Are you sure you want to delete your saved draft?
                        </div>
                        <div className="flex justify-center gap-8">
                          <div onClick={() => setConfirmationModal("")}>
                            {" "}
                            <ButtonHollowXs color="#FFFFFF" text="#148EFF">
                              Cancel
                            </ButtonHollowXs>
                          </div>
                          <div
                            onClick={() => {
                              setConfirmationModal("");
                              deleteOfferDraft(activeOfferUuid);
                              toast.success(
                                "Saved offer letter draft has been successfully deleted.",
                                { icon: <ToastIcon /> },
                              );
                            }}
                          >
                            {" "}
                            <ButtonXs text="#FFFFFF" color="#148EFF">
                              Yes, Delete
                            </ButtonXs>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
          {confirmationModal == "externalOffer" && (
            <>
              <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-30 flex items-center justify-center">
                <div className="bg-white border-[#D2D4DA] border-[1.4px] fixed rounded-[8px] shadow-xl z-50 w-[60%] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="card-header flex justify-between p-6">
                    <div className="text-2xl font-medium">Offer Letter</div>
                    <button
                      onClick={() => {
                        setConfirmationModal("");
                      }}
                    >
                      <IoMdClose className="w-6 h-6" />
                    </button>
                  </div>
                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className="card-body p-6 bg-[#F1F4FB] flex flex-col  h-[500px]">
                    <div className="h-[500px] overflow-y-auto">
                      <OfferLetter
                        applicant={applicant}
                        companyDetails={companyDetails}
                        offerLetterDetails={allOfferLetter}
                        jobDetails={jobDetails}
                        showButton={false}
                        offerstatus={activeOfferStatus}
                        ref={offerRef}
                      />
                    </div>
                  </div>
                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className="card-footer p-6 relative">
                    <div className="flex justify-between">
                      <div
                        onClick={() => {
                          offerRef.current?.convertToPdf();
                          toast.success(
                            "Generated offer letter has been successfully downloaded.",
                          );
                        }}
                      >
                        <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                          Download Now
                        </ButtonHollowXs>
                      </div>
                      <div
                        onClick={async () => {
                          setConfirmationModal("");
                          setTab("candidate");
                          await sendOfferLetter();

                          toast.success(
                            `${applicant.name}'s Offer Letter has been successfully sent.`,
                            { icon: <ToastIcon /> },
                          );
                          setIsSubmitted(false);
                          setTemplateType("");
                          setJoiningDate();
                          setExpiryDate();
                          setAdd1("");
                          setAdd2("");
                          setGender("");
                          setPin("");
                          setCity("");
                          setState("");
                          setCountry("");
                          setJoiningLocation();
                          setErrors({});
                        }}
                      >
                        <ButtonXs color="#148EFF" text="#FFFFFF">
                          Submit
                        </ButtonXs>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {confirmationModal == "offer" && (
            <>
              <div className="fixed py-12 bg-black bg-opacity-60  p-4 h-screen w-screen text-black flex items-center justify-center  top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50">
                <div className="bg-white border-[#D2D4DA] border-[1.4px]  rounded-[8px] shadow-xl z-80 w-[60%] ">
                  <div className="card-header flex justify-between p-6">
                    <div className="text-2xl font-medium">Offer Letter</div>
                    <button
                      onClick={() => {
                        if (!offerletterPending) {
                          createNotification(
                            companyID,
                            userid,
                            "todo",
                            "Send Offer email",
                            `Offer to be sent to ${applicant.name}`,
                            JSON.stringify({ id: applicant.uuid }),
                          );
                        }

                        setConfirmationModal("");
                        setTab("candidate");
                      }}
                    >
                      <IoMdClose className="w-6 h-6" />
                    </button>
                  </div>
                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className="card-body p-6 bg-[#F1F4FB] flex flex-col  h-[500px]">
                    <div className="h-[500px] overflow-y-auto">
                      <OfferLetter
                        applicant={applicant}
                        companyDetails={companyDetails}
                        offerLetterDetails={allOfferLetter}
                        jobDetails={jobDetails}
                        offerstatus={activeOfferStatus}
                        showButton={false}
                        ref={offerRef}
                      />
                    </div>
                  </div>
                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className="card-footer p-6 relative">
                    <div className="flex justify-between">
                      <div
                        onClick={() => {
                          offerRef.current?.convertToPdf();
                          toast.success(
                            "Generated offer letter has been successfully downloaded.",
                          );
                        }}
                      >
                        <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                          Download Now
                        </ButtonHollowXs>
                      </div>
                      {!companyDetails?.offerApproval ? (
                        <div
                          onClick={async () => {
                            try {
                              setIsSendingOffer(true); // start loader

                              if (offerletterPending) {
                                removeOfferLetterPendingNotification();
                              }

                              await sendOfferLetter(); // wait till finished

                              toast.success(
                                `Offer letter Sent to ${applicant.name}`,
                              );

                              setConfirmationModal("");
                              setTab("candidate");

                              // reset fields after successful send
                              setIsSubmitted(false);
                              setTemplateType("");
                              setJoiningDate();
                              setExpiryDate();
                              setAdd1("");
                              setAdd2("");
                              setGender("");
                              setPin("");
                              setCity("");
                              setState("");
                              setCountry("");
                              setJoiningLocation();
                              setErrors({});
                            } catch (error) {
                              toast.error("Failed to generate offer letter");
                              console.error(error);
                            } finally {
                              setIsSendingOffer(false); // stop loader
                            }
                          }}
                        >
                          <ButtonXs color="#148EFF" text="#FFFFFF">
                            {isSendingOffer ? (
                              <TailSpin
                                color="#148EFF"
                                height={20}
                                width={20}
                              />
                            ) : (
                              "Send Offer Letter"
                            )}
                          </ButtonXs>
                        </div>
                      ) : (
                        <div className="relative inline-block">
                          {/* Main Button */}
                          <button
                            className={`py-[12px] px-[20px] text-[12px] bg-[#148EFF] text-white rounded-[4px] flex items-center justify-between min-w-[140px] ${isOpen ? "rounded-b-none" : ""
                              }`}
                            onClick={() => setIsOpen(!isOpen)}
                            disabled={isSendingOffer}
                          >
                            {isSendingOffer ? (
                              <TailSpin
                                color="#FFFFFF"
                                height={20}
                                width={20}
                              />
                            ) : remindApproval ? (
                              "Remind"
                            ) : (
                              "Request Approval"
                            )}
                            <img
                              src={arrow} // same arrow icon you use for Add Job
                              className={`ml-2 h-[6px] transition-transform ${isOpen ? "rotate-180" : ""
                                }`}
                            />
                          </button>

                          {/* Dropdown */}
                          {isOpen && !isSendingOffer && (
                            <div className="absolute left-0 mt-0 w-full text-[12px] bg-[#5AA7EF] text-white rounded-b-[4px] shadow-md overflow-hidden z-50 max-h-[90px] overflow-y-auto">
                              {companyDetails.offerApproval
                                ? allUsers
                                  ?.filter(
                                    (user) => user.offer_letter_approver,
                                  )
                                  ?.map((user) => {
                                    return (
                                      <button
                                        key={user.uuid}
                                        onClick={() =>
                                          handleUserSelect({
                                            value: user.uuid,
                                            label: user.name,
                                          })
                                        }
                                        className="w-full flex items-center space-x-2 py-3 px-3 hover:bg-[#4a95d5]"
                                      >
                                        <p>{user.name}</p>
                                      </button>
                                    );
                                  })
                                : adminUserLabels.map((user) => (
                                  <button
                                    key={user.value}
                                    onClick={() => handleUserSelect(user)}
                                    className="w-full flex items-center space-x-2 py-3 px-3 hover:bg-[#4a95d5]"
                                  >
                                    <p>{user.label}</p>
                                  </button>
                                ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {confirmationModal == "showdoc" && (
            <>
              <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-30 flex items-center justify-center">
                <div className="bg-white border-[#D2D4DA] border-[1.4px] fixed rounded-[8px] shadow-xl z-50 w-[60%] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="card-header  flex justify-between p-6">
                    <div className="text-2xl font-medium">{activeDocName}</div>
                    <button
                      onClick={() => {
                        setConfirmationModal("");
                      }}
                    >
                      <IoMdClose className="w-6 h-6" />
                    </button>
                  </div>
                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className="card-body p-6 bg-[#F1F4FB] flex flex-col max-h-[55vh] h-[500px]">
                    <div className="p-4 rounded-xl bg-white flex-1  overflow-auto ">
                      <div className="  ">
                        {/* <img
                        src={adhar}
                        className="block  object-contain"
                        alt="document"
                      /> */}
                        <div>
                          {" "}
                          <iframe
                            src={documenturl}
                            className="h-[40rem] w-full"
                          ></iframe>
                          {/* <PdfRenderer pdfFile={documenturl} /> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className="card-footer p-6  relative">
                    <div className="flex justify-end">
                      <div
                        onClick={() => {
                          setConfirmationModal("");
                          toast.success(
                            `${applicant.name}'s ${activeDocName} has been successfully downloaded.`,
                            { icon: <ToastIcon /> },
                          );
                        }}
                      >
                        <ButtonXs text="#FFFFFF" color="#148EFF">
                          Download Now
                        </ButtonXs>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {confirmationModal == "viewdoc" && (
            <>
              <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-30 flex items-center justify-center">
                <div className="bg-white border-[#D2D4DA] border-[1.4px] fixed rounded-[8px] shadow-xl z-50 w-[60%] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="card-header  flex justify-between p-6">
                    <div className="text-2xl font-medium">
                      {visibleDocumentName}
                    </div>
                    <button
                      onClick={() => {
                        setConfirmationModal("");
                      }}
                    >
                      <IoMdClose className="w-6 h-6" />
                    </button>
                  </div>
                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className="card-body p-6 bg-[#F1F4FB] flex flex-col h-[500px]">
                    <div className="p-4 rounded-xl bg-white flex-1  overflow-auto ">
                      <div className="  ">
                        {/* <img
                        src={adhar}
                        className="block  object-contain"
                        alt="document"
                      /> */}
                        <div>
                          {" "}
                          <iframe
                            src={documenturl}
                            className="h-[40rem] max-h-[65vh] max-h-[65vh] w-full"
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className="card-footer p-6  relative">
                    <div className="flex justify-between">
                      <div
                        onClick={() => {
                          setConfirmationModal("");
                          toast.success(
                            `${applicant.name} 's ${visibleDocumentName} has been successfully downloaded.`,
                            { icon: <ToastIcon /> },
                          );
                          window.location.href = documenturl;
                        }}
                      >
                        <ButtonHollowXs text="#148EFF" color="#FFFFFF">
                          Download Now
                        </ButtonHollowXs>
                      </div>
                      <div className="flex gap-4 ">
                        <div
                          onClick={() => {
                            // updateDocumentStatus(activeDocId,"Rejected");
                            setConfirmationModal("rejectdoc");
                          }}
                        >
                          <ButtonHollowXs text="#F7284A" color="#FFFFFF">
                            <CloseIcon /> Reject
                          </ButtonHollowXs>
                        </div>
                        <div
                          onClick={() => {
                            setConfirmationModal("");
                            setTab("candidate");
                            updateDocumentStatus(activeDocId, "Verified");
                            toast.success(
                              "Document submitted by the candidate verified successfully ",
                              { icon: <ToastIcon /> },
                            );
                          }}
                        >
                          <ButtonXs color="#0DCD94" text="#FFFFFF">
                            <TickIcon />
                            Verify
                          </ButtonXs>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {confirmationModal == "previewdoc" && (
            <>
              <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-30 flex items-center justify-center">
                <div className="bg-white border-[#D2D4DA] border-[1.4px] fixed rounded-[8px] shadow-xl z-50 w-[60%] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="card-header  flex justify-between p-6">
                    <div className="text-2xl font-medium">{uploadDocType}</div>
                    <button
                      onClick={() => {
                        setConfirmationModal("");
                        setPreviewUrl("");
                        setDocFiles([]);
                        setUploadDocType();
                        setFileTypeError("");
                      }}
                    >
                      <IoMdClose className="w-6 h-6" />
                    </button>
                  </div>
                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className="card-body p-6 bg-[#F1F4FB] flex flex-col h-[500px]">
                    <Dropzone
                      maxSize={2097152}
                      accept=".pdf,.jpeg,.jpg,.png"
                      className={docFiles.length === 0 ? "" : "h-[0px]"}
                      ref={dropzoneRef}
                      onDrop={onDrop}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section className="container  cursor-pointer">
                          <div
                            {...getRootProps({
                              className:
                                "dropzone  flex justify-center items-center",
                            })}
                          >
                            <input {...getInputProps()} />
                          </div>
                        </section>
                      )}
                    </Dropzone>
                    <div className="p-4 rounded-xl bg-white flex-1 overflow-auto ">
                      <div className="   ">
                        {/* <img
                        src={adhar}
                        className="block  object-contain"
                        alt="document"
                      /> */}

                        {previewUrl && docFiles[0].name.endsWith(".pdf") ? (
                          <div>
                            {" "}
                            <iframe
                              src={previewUrl}
                              className="h-[40rem] max-h-[65vh] w-full"
                            ></iframe>
                            {/* <PdfRenderer pdfFile={previewUrl} /> */}
                          </div>
                        ) : (
                          <img
                            src={previewUrl}
                            className="block  object-contain"
                            alt="Preview"
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className="card-footer p-6  relative">
                    <div className="flex justify-between">
                      <div onClick={openDialog}>
                        <ButtonXs text="#FFFFFF" color="#148EFF">
                          Replace
                        </ButtonXs>
                      </div>
                      <div className="flex gap-4 ">
                        <div
                          onClick={() => {
                            setConfirmationModal("");
                            setTab("candidate");
                            setPreviewUrl("");
                            setDocFiles([]);
                            setUploadDocType();
                            setFileTypeError("");
                            uploadDocument();
                            toast.success(
                              "Your document has been uploaded and verified successfully.",
                              { icon: <ToastIcon /> },
                            );
                          }}
                        >
                          <ButtonXs color="#0DCD94" text="#FFFFFF">
                            Verify & Upload
                          </ButtonXs>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {confirmationModal == "rejectdoc" && (
            <>
              <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-30 flex items-center justify-center">
                <div className="bg-white border-[#D2D4DA] border-[1.4px]  fixed rounded-[8px] shadow-xl z-50 w-1/2 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="card-header flex justify-between pt-6 px-6 pb-6">
                    <div className="text-2xl font-medium">
                      Document Rejection
                    </div>
                    <button
                      className=""
                      onClick={() => {
                        setIsSubmitted(false);
                        setFormType("");
                        setErrors({});
                        setDocRejectReason(null);
                        setComment("");

                        setConfirmationModal("viewdoc");
                      }}
                    >
                      <IoMdClose className="w-6 h-6" />
                    </button>
                  </div>
                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className="card-body p-6 pb-0 flex flex-col ">
                    <div className="flex text-[14px] mb-4 flex-col ">
                      <div className=" font-semibold mb-[6px]">
                        Why are you rejecting the document?{" "}
                        <span className="text-red-400 justify start">*</span>
                      </div>
                      <div className="w-full">
                        <div id={errors.docRejectReason && "error"}>
                          <div className="filter-container">
                            <Select
                              className=""
                              value={docRejectReason}
                              isClearable={true}
                              options={[
                                {
                                  value: "Incorrect Document",
                                  label: "Incorrect Document",
                                },
                                {
                                  value: "Document unclear/unreadable",
                                  label: "Document unclear/unreadable",
                                },
                                {
                                  value: "Incomplete Document",
                                  label: "Incomplete Document",
                                },
                                { value: "Others", label: "Others" },
                              ]}
                              placeholder="Select Reason"
                              onChange={(newValue) => {
                                setDocRejectReason(newValue);
                              }}
                            ></Select>
                          </div>
                          {errors.docRejectReason && (
                            <div className="text-[#F7284A] mt-[6px] text-[12px]">
                              {errors.docRejectReason}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col text-[14px]  mb-[18px]">
                      <div className=" font-semibold  mb-[6px]">Comment</div>
                      <div>
                        <textarea
                          className="w-full p-[8px] border border-gray-300 rounded-[4px]"
                          placeholder="Comment here..."
                          value={comment}
                          rows={4}
                          onChange={(e) => {
                            setComment(e.target.value);
                          }}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className=" card-footer py-6 px-6   relative">
                    <div className="flex justify-end">
                      <div
                        onClick={() => {
                          setFormType("docRejectForm");
                          setIsSubmitted(true);
                          const isValid = validate("docRejectForm");
                          console.log("valid", isValid);
                          console.log("errors", errors);
                          if (isValid) {
                            updateDocumentStatus(activeDocId, "Rejected");
                            setIsSubmitted(false);
                            setConfirmationModal("");
                            toast.success(
                              "Mail for document rejection along with re-upload link has been sent successfully.",
                              { icon: <ToastIcon /> },
                            );
                            setFormType("");
                            setDocRejectReason();
                            setErrors({});
                            setComment("");
                            setTab("reqdocagain");
                          }
                        }}
                      >
                        <ButtonXs color="#148EFF" text="#FFFFFF">
                          Send Email with Re-upload Link
                        </ButtonXs>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {confirmationModal == "adddoc" && (
            <>
              <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-30 flex items-center justify-center">
                <div className="bg-white border-[#D2D4DA] border-[1.4px]  fixed rounded-[8px] shadow-xl z-50 w-1/2 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="card-header flex justify-between pt-6 px-6 pb-6">
                    <div className="text-2xl font-medium">Add Document</div>
                    <button
                      className=""
                      onClick={() => {
                        setPreviewUrl(null);
                        setConfirmationModal("");
                        setUploadDocType();
                        setIsSubmitted(false);
                        setDocFiles([]);
                        setFileTypeError("");
                        setErrors({});
                      }}
                    >
                      <IoMdClose className="w-6 h-6" />
                    </button>
                  </div>
                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className="card-body p-6 pb-0 flex flex-col ">
                    <div className="flex text-[14px] mb-[20px] flex-col ">
                      <div className=" font-semibold mb-[6px]">
                        Document Type
                        <span className="text-red-400 justify start">*</span>
                      </div>
                      <div
                        id={errors.uploadDocType && "error"}
                        className="w-full"
                      >
                        <div className="filter-container">
                          <CreatableSelect
                            options={displayedDocOptions}
                            onChange={(selectedOption) => {
                              setUploadDocType(
                                selectedOption ? selectedOption.label : null,
                              );
                            }}
                            placeholder="Select or type to add a document type"
                          />
                          {/* <Select
                            className=""
                            options={[
                              { label: "Photo", value: "photo" },
                              { label: "Aadhar Card", value: "aadharcard" },
                              { label: "Pan Card", value: "pancard" },
                              { label: "3 months salary slip", value: "salaryslip" },
                              { label: "Education Certificate", value: "educationcertificate" },
                            ]}
                            
                            onChange={(selectedOption)=>setUploadDocType(selectedOption.value)}
                            placeholder="Select Reason"
                          ></Select> */}
                        </div>

                        {errors.uploadDocType && (
                          <div className="text-[#F7284A] mt-[6px] text-[12px]">
                            Document type is required.
                          </div>
                        )}
                      </div>
                    </div>
                    {fileTypeError && (
                      <div className="p-3 bg-[#FFCCCC] rounded-[8px] w-full text-[12px] flex gap-4 items-center mb-2  ">
                        <WrongFormaticon />
                        <p>{fileTypeError}</p>
                      </div>
                    )}
                    <div className="mb-[24px] ">
                      <div className=" w-full border-[2px]  rounded-[8px] border-[#D2D4DA] border-dashed">
                        <Dropzone
                          maxSize={2097152}
                          accept=".pdf,.jpeg,.jpg,.png"
                          className={docFiles.length === 0 ? "" : "h-[0px]"}
                          ref={dropzoneRef}
                          onDrop={onDrop}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <section className="container h-full cursor-pointer">
                              <div
                                {...getRootProps({
                                  className:
                                    "dropzone h-full flex justify-center items-center",
                                })}
                              >
                                <input {...getInputProps()} />
                                {docFiles.length === 0 && (
                                  <div className="flex justfify-center flex-col items-center my-[60px]  ">
                                    <div className="mb-[15px]">
                                      <DocSvg />
                                    </div>
                                    <p className="text-2xl text-[#0DCD94] leading-[32px] font-medium mb-[6px] ">
                                      Select a file to upload
                                    </p>
                                    <p className="text-[14px] text-[#8F94A1]">
                                      or drag & drop it here
                                    </p>
                                  </div>
                                )}

                                {/* <aside className="mt-[20px]">
        <h4 className="text-lg font-bold">Accepted Files</h4>
        <ul>{acceptedFileItems.length > 0 ? acceptedFileItems : <li>No accepted files</li>}</ul>
        <h4 className="text-lg font-bold mt-[10px]">Rejected Files</h4>
        <ul>{fileRejectionItems.length > 0 ? fileRejectionItems : <li>No rejected files</li>}</ul>
      </aside> */}
                              </div>
                            </section>
                          )}
                        </Dropzone>

                        {docFiles.length !== 0 && (
                          <div className="flex items-center flex-col justify-center my-[98px]">
                            <div
                              className={`flex relative items-center mb-[20px]  px-4 py-3 border   rounded-md  w-fit ${fileTypeError
                                ? "border-[#F7284A]"
                                : "border-[#8F94A1]"
                                }`}
                            >
                              <button
                                onClick={() => {
                                  setDocFiles([]);
                                  setFileTypeError("");
                                }}
                                className="top-1 right-1 absolute text-[#8F94A1] hover:text-gray-700"
                              >
                                <XIcon className="w-[10px] h-[10px] " />
                              </button>
                              {fileTypeError ? (
                                <RedDocIcon />
                              ) : (
                                <img src={docIcon} className="w-8 h-8" />
                              )}

                              <span className="ml-2 text-[14px] font-medium ">
                                {docFiles[0].name}
                              </span>
                            </div>
                            {!fileTypeError && (
                              <p className="text-[14px] text-[#0DCD94]  font-medium  ">
                                File Uploaded Successfully
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                      <p className="text-[12px] mt-2">
                        Note: Files are only accepted in .pdf, .jpg, .png and
                        .jpeg format only. Maximum file size 2MB.
                      </p>
                    </div>
                  </div>
                  <div className="border border-[#E9EBFA] w-full"></div>
                  <div className=" card-footer py-6 px-6   relative">
                    <div className="flex justify-between">
                      <div>
                        {docFiles.length > 0 && (
                          <div onClick={openDialog}>
                            <ButtonHollowXs
                              disabled={docFiles.length == 0}
                              text="#148EFF"
                              color="#FFFFFF"
                            >
                              Replace
                            </ButtonHollowXs>
                          </div>
                        )}
                      </div>
                      <div
                        onClick={() => {
                          setFormType("uploadDocForm");
                          setIsSubmitted(true);
                          const isValid = validate("uploadDocForm");
                          console.log("isValid", isValid);
                          if (isValid) {
                            setConfirmationModal("previewdoc");
                            setIsSubmitted(false);

                            setErrors({});
                          }
                        }}
                      >
                        <ButtonXs
                          disabled={
                            docFiles?.length == 0 || fileTypeError.length > 0
                          }
                          color="#148EFF"
                          text="#FFFFFF"
                        >
                          Preview
                        </ButtonXs>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
};

export default TestOfferInitiation;

const ReloadIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7V11H9"
        stroke="#444D63"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 17V13H15"
        stroke="#444D63"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4027 9.99947C17.08 9.04375 16.5315 8.18927 15.8083 7.51577C15.0852 6.84227 14.2111 6.3717 13.2675 6.14797C12.3238 5.92424 11.3415 5.95464 10.4122 6.23633C9.48278 6.51803 8.63666 7.04184 7.95273 7.75889L5 10.6663M19 13.3337L16.0473 16.2411C15.3633 16.9582 14.5172 17.482 13.5878 17.7637C12.6585 18.0454 11.6762 18.0758 10.7325 17.852C9.78893 17.6283 8.91478 17.1577 8.19166 16.4842C7.46854 15.8107 6.92002 14.9563 6.59727 14.0005"
        stroke="#444D63"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const TickIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      className="mr-[6px]"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.60156 7.99961L5.86943 12.3996L14.4016 3.59961"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const CloseIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className="mr-[6px]"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7327 3.32916C14.0255 3.03627 14.0255 2.56139 13.7327 2.2685C13.4398 1.9756 12.9649 1.9756 12.672 2.2685L8.00155 6.93894L3.33111 2.2685C3.03822 1.9756 2.56334 1.9756 2.27045 2.2685C1.97756 2.56139 1.97756 3.03627 2.27045 3.32916L6.94089 7.9996L2.27045 12.67C1.97756 12.9629 1.97756 13.4378 2.27045 13.7307C2.56334 14.0236 3.03822 14.0236 3.33111 13.7307L8.00155 9.06026L12.672 13.7307C12.9649 14.0236 13.4398 14.0236 13.7327 13.7307C14.0255 13.4378 14.0255 12.9629 13.7327 12.67L9.06221 7.9996L13.7327 3.32916Z"
        fill="#F7284A"
      />
    </svg>
  );
};

export const ToastIcon = (props) => {
  const { className } = props;
  return (
    <div className="flex justify-center m-auto items-center h-8 w-8">
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g opacity="0.6">
          <path
            d="M31 15.5C31 23.7843 24.2843 30.5 16 30.5C7.71573 30.5 1 23.7843 1 15.5C1 7.21573 7.71573 0.5 16 0.5C24.2843 0.5 31 7.21573 31 15.5Z"
            fill="#0DCD94"
            fillOpacity="0.12"
          />
          <path
            d="M28 15.5001C28 22.1275 22.6274 27.5001 16 27.5001C9.37258 27.5001 4 22.1275 4 15.5001C4 8.87271 9.37258 3.50013 16 3.50013C22.6274 3.50013 28 8.87271 28 15.5001Z"
            fill="#0DCD94"
            fillOpacity="0.2"
          />
          <path
            d="M25 15.5C25 20.4706 20.9706 24.5 16 24.5C11.0294 24.5 7 20.4706 7 15.5C7 10.5295 11.0294 6.50004 16 6.50004C20.9706 6.50004 25 10.5295 25 15.5Z"
            fill="#0DCD94"
            fillOpacity="0.28"
          />
        </g>
        <g clipPath="url(#clip0_2446_60085)">
          <path
            d="M14.6719 17.4492L17.9531 14.168"
            stroke="#0DCD94"
            strokeWidth="0.820312"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.6719 14.168H17.9531V17.4492"
            stroke="#0DCD94"
            strokeWidth="0.820312"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3125 21.2852C19.3324 21.2852 21.7813 18.8369 21.7813 15.8164C21.7813 12.7965 19.3324 10.3477 16.3125 10.3477C13.2926 10.3477 10.8438 12.7965 10.8438 15.8164C10.8438 18.8369 13.2926 21.2852 16.3125 21.2852Z"
            stroke="#0DCD94"
            strokeWidth="0.820312"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2446_60085">
            <rect
              width="13.125"
              height="13.125"
              fill="white"
              transform="translate(9.75 9.24609)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

const DocSvg = () => {
  return (
    <svg
      width="70"
      height="69"
      viewBox="0 0 70 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Iconly/Light/Tick Square">
        <g id="Tick Square">
          <circle
            id="Ellipse 1"
            cx="35.0013"
            cy="34.4993"
            r="26.0667"
            stroke="#0DCD94"
            strokeWidth="4.53333"
            strokeLinecap="round"
          />
          <path
            id="Vector"
            d="M34.6094 24.8984V44.0996M44.2193 34.502L25 34.5"
            stroke="#0DCD94"
            strokeWidth="4.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

function XIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </svg>
  );
}

const WrongFormaticon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Iconly/Light/Danger Circle">
      <g id="Group 1000002672">
        <path
          id="Vector"
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          stroke="#F7284A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M15 9L9 15"
          stroke="#F7284A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M9 9L15 15"
          stroke="#F7284A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

const RedDocIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="40"
        height="40"
        rx="9.1125"
        fill="#F7284A"
        fillOpacity="0.14"
      />
      <rect
        x="0.569531"
        y="0.569531"
        width="38.8609"
        height="38.8609"
        rx="6.26484"
        stroke="#F7284A"
        strokeWidth="1.13906"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.596 11.2324H16.2808C14.3064 11.2249 12.688 12.7987 12.6415 14.7721V24.9411C12.5978 26.9468 14.1878 28.6088 16.1935 28.6535C16.2229 28.6535 16.2514 28.6544 16.2808 28.6535H23.8641C25.8518 28.5728 27.418 26.9306 27.4038 24.9411V16.2405L22.596 11.2324Z"
        stroke="#F7284A"
        strokeWidth="1.70859"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3516 11.2207V13.982C22.3516 15.3299 23.4413 16.4224 24.7892 16.4262H27.4043"
        stroke="#F7284A"
        strokeWidth="1.70859"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1727 23.1875H17.0469"
        stroke="#F7284A"
        strokeWidth="1.70859"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2325 19.627H17.0469"
        stroke="#F7284A"
        strokeWidth="1.70859"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
